// PawLink i18n — 4 languages.
// Keep keys short; nested structure for scoped pages.

const en = {
    magic: {
        loading_title: "Signing you in…",
        loading_body: "We're verifying your sign-in link.",
        ok_title: "Welcome to PawLink!",
        ok_body: "You're signed in. Taking you to your dashboard…",
        error_title: "Link no longer valid",
        error_generic: "This sign-in link is no longer valid. Request a new one from the email, or sign in again.",
        missing_title: "Link missing",
        missing_body: "We couldn't find a valid sign-in link in this URL. Please use the button in the email we sent you.",
        go_login: "Sign in",
        get_help: "Get help",
    },
    paddle_success: {
        headline: "Payment received!",
        body: "Thank you for subscribing to PawLink Protection. Every Premium feature is now active on your account.",
        check_inbox: "Check your inbox — we've sent you a magic link so you can access your account instantly.",
        no_email: "Don't see it? Check spam or",
        contact_support: "contact us",
    },
    lang: { name: "English", dir: "ltr" },
    lost: {
        kicker: "PawLink community",
        title: "Lost Pets",
        subtitle: "Let's help them get back home",
        report_cta_h: "Report Lost Pet",
        report_cta_sub: "Help us spread the word",
        hero_h: "Every missing pet deserves a chance to come home.",
        hero_sub: "Browse pets who are lost right now, or report your own in seconds.",
        report_cta: "Report Lost Pet",
        tab_lost: "Lost",
        tab_reunited: "Reunited",
        reunited_h: "Happy endings",
        reunited_sub: "These pets are back home safe",
        search_ph: "Search by name, breed…",
        filter_kind: "Type",
        filter_city_ph: "City",
        filter_city_all: "All Cities",
        near_me: "Nearby",
        sort_recent: "Latest",
        sort_sightings: "Most sightings",
        kind_all: "All animals",
        kind_dog: "Dogs",
        kind_cat: "Cats",
        kind_other: "Other",
        count_lost: "{n} pet(s) currently missing",
        count_reunited: "{n} happy reunion(s)",
        the_pet: "This pet",
        empty_lost_h: "No missing pets right now",
        empty_lost_sub: "That's wonderful news. If your pet ever needs help, you can report them in seconds.",
        empty_reunited_h: "Every reunion starts here",
        empty_reunited_sub: "Reunited pets will appear here as their stories unfold.",
        badge_lost: "LOST",
        badge_reunited: "REUNITED",
        time_min: "{n}m ago",
        time_hr: "{n}h ago",
        time_day: "{n}d ago",
        reunited_after: "Reunited after {hrs}h",
        reunited_after_hrs: "Reunited after {n} hours",
        reunited_after_days: "Reunited after {n} days",
        reunited_line: "Reunited with their family",
        act_saw: "Saw",
        act_found: "I Found This Pet",
        act_found_short: "Found",
        act_call: "Call",
        act_call_owner: "Call Owner",
        act_call_short: "Call",
        act_wa: "WhatsApp",
        act_wa_short: "Chat",
        act_share: "Share",
        share_msg: "Help find {name} — please share",
        detail_back: "Back",
        detail_lastseen_h: "Last seen",
        detail_about_h: "About {name}",
        detail_view_more: "View more",
        detail_view_less: "View less",
        detail_open_map: "Open in map",
        detail_since: "Reported missing: {date}",
        detail_404_h: "Sorry — that pet isn't on the Lost list right now.",
        detail_reunited_line: "was reunited after {hrs} hours",
        detail_sightings_h: "{n} sighting(s)",
        detail_sightings_h_short: "Sightings",
        sightings_empty: "No sightings yet — you could be the first.",
        sighting_generic: "Someone spotted this pet.",
        sighting_h: "I saw {name}",
        sighting_sub: "Add anything you noticed. Every clue helps.",
        sighting_message: "What did you see?",
        sighting_message_ph: "e.g., Running near the park, wearing a blue collar…",
        sighting_still_there: "Still there right now",
        sighting_still_there_h: "The pet is still at this spot right now",
        sighting_name_opt: "Your name (optional)",
        sighting_contact_opt: "Contact (optional)",
        sighting_contact_ph: "Phone or email",
        sighting_gps_sharing: "Sharing your location…",
        sighting_gps_ok: "Location shared",
        sighting_gps_off: "Location off — you can still send a message",
        sighting_send: "Send sighting",
        sighting_sending: "Sending…",
        sighting_sent_h: "Sighting sent — the owner has been notified",
        sighting_sent_sub: "Thank you for helping. You just moved a family closer to reunion.",
        sighting_privacy: "Your contact stays private and is only visible to the pet's owner.",
        sighting_error: "Couldn't send. Please try again.",
        how_h: "How it works",
        how_step1_h: "Report",
        how_step1_sub: "Report your lost pet",
        how_step2_h: "Share",
        how_step2_sub: "We spread the word",
        how_step3_h: "Sight",
        how_step3_sub: "People keep an eye out",
        how_step4_h: "Reunite",
        how_step4_sub: "Bring them home",
        together_h: "Together, we make a difference",
        together_sub: "Every share helps a family reunite",
        stats_reunited_month: "Reunited this month",
        stats_reunited_total: "Total pets reunited",
        stats_guardians: "Active Guardians",
        reported_time: "Reported {time}",
        reunited_time: "Reunited {time}",
    },
    nav: { home: "Home", pricing: "Pricing", dashboard: "Dashboard", login: "Log in", register: "Get started", create_account: "Create account", signout: "Sign out", plan_free: "Free", plan_premium: "Premium", plan_trial: "Trial", menu: "Menu", back: "Back", my_pets: "My Pets", my_qr: "My QR Codes", scan_history: "Scan History", notifications: "Notifications", account: "Account", subscription: "Subscription", protection: "PawLink Safety", safety: "PawLink Safety", rescue_center: "Rescue Center", community: "PawLink Community",
        local_walks: "Local Walks", lost_pets: "Lost Pets", help: "Help", faq: "FAQ", support: "Support", how_it_works: "How it works", view_all: "View all notifications", open_scan: "Open scan", view_map: "View on map", no_pets_yet: "No pets yet — add your first one", dash_pets: "Pets", dash_status: "Status", dash_status_safe: "All Pets Safe", dash_status_lost: "{n} Pet Missing", bn_home: "Home", bn_pets: "Pets", bn_lost: "Lost", bn_community: "Community", bn_safety: "Safety", bn_account: "Account" },
    brand: { tagline: "Your pet. Always finding home." },
    common: { save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", back: "Back", next: "Next", loading: "Loading…", saving: "Saving…", remove: "Remove", upload: "Upload", record: "Record", stop: "Stop", close: "Close" },
    landing: {
        chip: "Smart QR pet ID",
        h1a: "If your pet gets lost,",
        h1b: "help them find their way back home ❤️",
        sub: "PawLink gives your best friend a Smart QR ID. If they're lost, any kind stranger can scan and reach you in seconds — no app required.",
        cta_primary: "Create your pet's profile",
        cta_secondary: "See how it works",
        badge_privacy: "Privacy-first",
        badge_dynamic: "Dynamic QR",
        badge_love: "Made with love",
        story_scan: "Someone scanned Milo's tag",
        story_when: "Just now · 5th & Main",
        story_reunited: "Milo is on his way home 🐾",
        protect_h: "Protect your best friend today 🐾",
        protect_price: "9.90 CHF / month  ·  79.00 CHF / year",
        protect_line: "Peace of mind — because losing them is not an option.",
        protect_cta: "Start PawLink Protection",
        how_over: "How it works",
        how_h2: "Three steps between lost and home.",
        step1_t: "🐶 Create profile",
        step1_d: "Photo, name, health notes, and a message from the heart.",
        step2_t: "📱 Attach Smart QR",
        step2_d: "Print your QR on a tag, collar or sticker. Update it anytime.",
        step3_t: "❤️ Get reunited",
        step3_d: "A finder scans, you're notified with location — voice, call, done.",
        why_over: "Peace of mind, built in",
        why_h2: "Everything they need to come home.",
        why_sub: "Every second matters when a pet is missing. PawLink is your calm plan.",
        f1_t: "🔔 Instant scan alerts",
        f1_d: "Know the moment someone scans your pet's QR.",
        f2_t: "📍 Last seen location",
        f2_d: "GPS or city — right on your dashboard.",
        f3_t: "🎙 Voice messages with finder",
        f3_d: "Your voice calms your pet. The finder's voice reaches you fast.",
        f4_t: "📞 One-tap call & WhatsApp",
        f4_d: "The finder reaches you in a single touch.",
        f5_t: "🔒 Privacy control",
        f5_d: "You choose exactly what a stranger sees.",
        cta_h2: "They can't call you. But a stranger can.",
        cta_sub: "Give your pet the safety net they deserve — in under two minutes.",
        cta_btn: "Get PawLink free",
        cta_compare: "See pricing",
    },
    auth: {
        welcome: "Welcome back",
        sign_sub: "Sign in to manage your pet profiles.",
        create: "Create your account",
        create_sub: "Start protecting your pet in under two minutes.",
        email: "Email",
        password: "Password",
        password_hint: "At least 6 characters",
        name: "Your name",
        signin: "Sign in",
        signing: "Signing in…",
        creating: "Creating…",
        create_btn: "Create account",
        no_account: "No account?",
        have_account: "Already have an account?",
        create_one: "Create one",
        trouble_signing_in: "Trouble signing in? Contact us at",
        sign_in: "Sign in",
        or_continue: "or continue with email",
        google_signin: "Sign in with Google",
        google_signup: "Sign up with Google",
        welcome_h: "Welcome to PawLink",
        welcome_sub: "Protect your pet in seconds.",
        welcome_hi: "Hi there! 👋",
        welcome_footer: "By continuing you agree to our terms and privacy.",
        forgot_password: "Forgot?",
        forgot_title: "Reset your password",
        forgot_sub: "Enter your email — we'll send you a secure link to set a new password.",
        forgot_submit: "Send reset link",
        forgot_sending: "Sending…",
        forgot_sent_title: "Check your inbox",
        forgot_sent_sub: "If an account exists for that email, we just sent a password reset link. It expires in 1 hour.",
        forgot_back_login: "Back to sign in",
        reset_title: "Set a new password",
        reset_sub: "Choose a strong password of at least 6 characters. You'll be signed in automatically.",
        reset_new: "New password",
        reset_confirm: "Confirm new password",
        reset_submit: "Reset password",
        reset_saving: "Saving…",
        reset_success: "Password updated. Redirecting…",
        reset_mismatch: "Passwords don't match.",
        reset_invalid_link: "This link is invalid or has expired. Request a new one.",
        reset_no_token: "Missing reset token. Open the link from your email again.",
    },
    dash: {
        welcome: "Welcome back",
        sub: "Manage your pets’ digital IDs and share their QR anywhere.",
        add_pet: "Add a pet",
        upgrade: "Upgrade to Premium",
        empty_h: "No pets yet",
        empty_sub: "Let’s create your pet’s digital ID. It only takes a minute — and could save their life.",
        empty_cta: "Create your first pet",
        pet_qr_h: "’s QR",
        scan_share: "Scan or share this link:",
        select_pet: "Select a pet to see its QR code.",
        loading: "Loading your pets…",
        upgrade_download: "Upgrade to Premium to download the QR (PNG/PDF), unlock unlimited pets, and receive instant scan alerts.",
        upgrade_inline: "Upgrade",
        no_phone: "No phone set",
        finder_url: "Finder URL:",
        recent_scans: "Recent scans",
        no_scans: "No scans yet. Print & share the QR to get started.",
        scan_gps: "GPS",
        scan_ip: "IP location",
        notifications: "Notifications",
        no_notifications: "You’re all caught up.",
        mark_all_read: "Mark all as read",
        notif_scan: "Someone scanned {pet}’s QR",
        notif_found: "{finder} found {pet}",
        just_now: "just now",
        min_ago: "{n} min ago",
        hr_ago: "{n} h ago",
        day_ago: "{n} d ago",
    },
    petform: {
        new_over: "New pet", edit_over: "Edit pet",
        new_h: "Create a pet profile",
        edit_h: "Update {name}",
        photo_h: "Photo",
        photo_sub: "A clear photo helps finders recognize your pet instantly.",
        upload_photo: "Upload photo",
        about_h: "About your pet",
        pet_name: "Pet name *",
        type: "Type *",
        type_dog: "Dog", type_cat: "Cat", type_other: "Other",
        finder_message: "Message for the finder",
        contact_h: "Contact",
        contact_sub: "Phone is required. Everything else is optional — you control what a finder sees below.",
        owner_name: "Your name",
        phone: "Phone number *",
        whatsapp: "WhatsApp (optional)",
        city: "City",
        address: "Full address (optional)",
        health_h: "Health & Care",
        allergies: "Allergies / forbidden foods",
        allergies_ph: "Allergic to chicken. Do not feed chocolate.",
        medical: "Medical notes",
        medical_ph: "Takes seizure meds. Anxious around loud sounds.",
        voice_h: "Voice message & reward",
        voice_sub: "Record a soothing voice for your pet and set an optional reward to encourage finders.",
        voice_label: "Voice message",
        reward: "Reward (optional)",
        reward_ph: "$100 reward for safe return",
        privacy_h: "Privacy controls",
        privacy_sub: "Choose exactly what a finder sees when they scan the QR.",
        p_phone: "Show my phone number",
        p_name: "Show my name",
        p_city_only: "Show city only (recommended)",
        p_address: "Show full address (advanced)",
        p_allergies: "Show allergies / forbidden foods",
        p_medical: "Show medical notes",
        p_reward: "Show reward",
        submit_create: "Create pet",
        submit_edit: "Save changes",
        default_msg: "If you found me, please contact my human. Thank you for being kind!",
        back_to_dash: "Back to dashboard",
        // — Wizard v3 —
        step_of: "Step {n} of {total}",
        continue: "Continue",
        back: "Back",
        protect_btn: "Protect {name} 🐾",
        protect_generic: "Protect my pet 🐾",
        // Step 1 — Meet your best friend
        s1_h: "Meet your best friend",
        s1_emoji: "🐾",
        s1_sub: "Let's build a beautiful profile for the family member who can't speak for themselves.",
        s1_photo_label: "Tap to add a photo",
        s1_photo_hint: "A clear photo helps finders recognize your pet in seconds.",
        s1_change_photo: "Change photo",
        s1_name_ph: "e.g. Milo",
        s1_breed_label: "Breed (optional)",
        s1_breed_ph: "e.g. Golden Retriever",
        s1_gender_label: "Gender (optional)",
        gender_male: "Male",
        gender_female: "Female",
        gender_unknown: "Prefer not to say",
        // Step 2 — Help them get home
        s2_h: "Help them get home",
        s2_emoji: "❤️",
        s2_sub: "If someone finds your pet, this is how they bring them back to you.",
        s2_privacy_note: "Full address is hidden from finders by default. You can change that later.",
        // Step 3 — Things a rescuer should know
        s3_h: "Things a rescuer should know",
        s3_emoji: "🩺",
        s3_sub: "Details that could save your pet's life in the wrong hands.",
        s3_notes_label: "Special notes (optional)",
        s3_notes_ph: "e.g. Gets scared easily · Loves belly rubs · Do not feed chicken",
        // Step 4 — A message from the heart
        s4_h: "A message from the heart",
        s4_emoji: "🎤",
        s4_sub: "Record a voice note the finder will hear the moment they scan.",
        s4_example: "\"Hi, I'm Milo's mom. Thank you for finding him. Please call me ❤️\"",
        s4_written_label: "Or write a short message",
        s4_reward_label: "Reward (optional)",
        s4_reward_hint: "Optional. A small thank-you helps motivate finders.",
        // Step 5 — Privacy
        s5_h: "Privacy control",
        s5_emoji: "🔒",
        s5_sub: "Choose what strangers see when they scan {name}'s QR.",
        s5_sub_generic: "Choose what strangers see when they scan the QR.",
        // Success
        success_h: "{name} is protected now",
        success_h_generic: "Your pet is protected now",
        success_sub: "Your Smart QR is ready. Print it, attach it to their collar — you're their safety net now.",
        success_card_over: "Digital Pet Passport",
        success_card_id: "PawLink ID",
        success_view_profile: "View public profile",
        success_go_dashboard: "Go to dashboard",
        edit_saved: "Changes saved ❤️",
    },
    finder: {
        im_lost: "I’m lost, please help me go home",
        call: "Call owner",
        whatsapp: "WhatsApp",
        text: "Text message",
        whatsapp_optional: "Prefer WhatsApp? Message on WhatsApp",
        owner: "Owner:",
        message_h: "A message from my human",
        voice_h: "Voice message",
        voice_sub: "Playing my human’s voice may calm me down.",
        voice_unsupported: "Your browser can't play this audio.",
        voice_open_new: "Open audio in new tab",
        default_plea: "Hi! I'm {name}. If you found me, please contact my family so I can go home safely. Thank you! ❤️",
        allergies_h: "Allergies & forbidden foods",
        medical_h: "Medical notes",
        location_h: "Where I live",
        reward_h: "Reward",
        personality_h: "How to approach {name}",
        passport_h: "{name}'s passport",
        passport_sub: "Shared by the owner in case a vet or authority needs it.",
        passport_view: "View",
        lost: {
            badge: "Missing · Please help",
            pawlink_verified: "PawLink verified",
            headline_kicker: "Please help me get home",
            headline: "I'm {name} — my family is looking for me.",
            missing_for: "Missing for {time}",
            call_cta: "Call my family",
            sms_cta: "Text my family",
            whatsapp_cta: "Message on WhatsApp",
            plea_h: "Keep me safe — I'm scared",
            plea_default: "Please keep me safe until my family arrives. Call the number above and I'll be home soon. Thank you, kind stranger. ❤️",
            reward_h: "Reward if returned",
            lastseen_h: "Last seen",
            view_on_map: "View on map",
            medical_h: "Important — I have medical needs",
        },
        found_h: "Did you just find {name}?",
        found_sub: "Tap the button below and we’ll instantly notify the owner.",
        found_btn: "I found this pet",
        thanks_h: "Thank you — you’re a hero.",
        thanks_sub: "We’ve notified {owner}. Please stay close to the pet if you can.",
        owner_generic: "the owner",
        powered: "Powered by",
        tagline: "Bringing lost pets home",
        tech_help: "Technical issue with this page? Contact PawLink support at",
        modal_h: "Tell the owner where you are",
        modal_sub: "Your details help the owner reach you fast.",
        f_name: "Your name (optional)",
        f_phone: "Your phone (optional)",
        f_location: "Where are you?",
        f_location_ph: "Corner of 5th & Main",
        f_message: "Message (optional)",
        f_voice: "Voice reply (optional)",
        share_location: "Share my location",
        location_sharing: "Sharing…",
        location_shared: "Location shared",
        submit: "Notify owner",
        sending: "Sending…",
        cancel: "Cancel",
        not_found_h: "Profile not found",
        not_found_sub: "This QR code may have been removed by the owner.",
        go_home: "Go home",
        voice_shortcut_h: "Can't type? Send a voice message 🎙️",
        voice_shortcut_sub: "One-tap voice reply — {name}'s owner hears it in seconds.",
        voice_shortcut_send: "Send voice to owner",
        voice_shortcut_sending: "Sending…",
        voice_shortcut_sent_h: "Voice message sent ❤️",
        voice_shortcut_sent_sub: "{name}'s owner just got a notification with your voice.",
        voice_shortcut_default_msg: "Voice message from a finder.",
        voice_shortcut_error: "Could not send. Please try again.",
        sighting_h: "I saw this pet 👀",
        sighting_sub: "One-tap sighting alert. {name}'s owner gets your exact spot and can head there right away.",
        sighting_send: "I saw them — send my location",
        sighting_locating: "Getting your location…",
        sighting_privacy: "🔒 Your location is shared once, only with this pet's owner.",
        sighting_default_msg: "I just saw {name} nearby.",
        sighting_sent_h: "Sighting sent 📍",
        sighting_sent_sub: "{name}'s owner is on the way. Thank you for helping!",
        sighting_error: "Could not send. Please try again.",
    },
    community: {
        title: "PawLink Community",
        sub: "One map for lost pets, local walks, and the PawLink community nearby.",
        privacy_h: "Your map presence",
        privacy_sub: "You choose what others see. Your exact home is never stored — only a fuzzy neighborhood pin.",
        vis_invisible: "Invisible",
        vis_invisible_sub: "You don't appear on any map.",
        vis_approximate: "Approximate",
        vis_approximate_sub: "A soft pin near your neighborhood — never your address.",
        vis_helper: "PawLink Helper 🐾",
        vis_helper_sub: "Show as a helper so nearby owners know they can count on you.",
        location_needed_h: "Add your neighborhood to the map",
        location_needed_sub: "One tap. We round your location to about 1 km — no addresses are stored.",
        share_approx_location: "Add my approximate area",
        locating: "Getting your area…",
        location_error: "Could not save your area. Try again.",
        location_denied: "Location permission denied.",
        geo_unsupported: "Your browser doesn't support location.",
        visibility_error: "Could not update visibility.",
        your_area: "Your area: {area}",
        helpers_near: "{count} PawLink helpers near {area}",
        helpers_generic: "{count} PawLink helpers nearby",
        helpers_sub: "Anonymous. Ready to help if a pet goes missing in your area.",
        protectors_near: "{count} PawLink protectors near you 🐾",
        protectors_generic: "{count} PawLink protectors near you 🐾",
        protectors_sub: "A quiet family of pet parents watching each other's backs — anonymous on the map, real when it counts.",
        stat_helpers: "Helpers",
        stat_lost: "Lost",
        stat_found: "Recently found",
        filter_all: "All",
        filter_lost: "Lost pets",
        filter_walking_now: "Walking Now",
        walks_legend: "Warm markers = pets walking now. Lost-pet & rescue markers stay visible.",
        filter_helpers: "Nearby Community",
        filter_found: "Recently found",
        refresh: "Refresh",
        legend_helper: "Helper",
        legend_lost: "Lost pet",
        legend_found: "Recently found",
        legend_walking: "Walking now",
        you_are_here: "You",
        find_my_location: "Find my location",
        center_on_me: "Center on me",
        distance_h: "Distance",
        map_visibility_h: "Map visibility",
        map_visibility_hidden: "Hidden",
        map_visibility_approximate: "Approximate",
        map_visibility_live_approx: "Live approximately",
        map_visibility_change: "Change",
        km_unit: "km",
        pin_helper: "PawLink Helper",
        pin_helper_anon: "Anonymous Guardian",
        pin_member: "PawLink member",
        avail_available: "Available",
        avail_busy: "Busy",
        avail_offline: "Offline",
        availability_h: "My availability",
        rescue_count: "{n} rescues joined",
        radius_h: "Radius",
        receive_alerts_h: "Receive lost-pet alerts",
        receive_alerts_sub: "Get a ping when a pet nearby needs help. You never share your details.",
        delete_location_cta: "Delete my stored location",
        delete_location_confirm: "Clear your stored community location? You'll become invisible on the map.",
        lost_pet: "Lost pet",
        recently_found: "Recently found",
        last_seen: "Last seen",
        distance_km: "{km} km away",
        view_pet: "View profile",
        lost_nearby_h: "{count} lost pets near you",
        found_nearby_h: "{count} recently found",
        location_unknown: "Location unknown",
        popup_isaw: "I saw this pet",
        popup_ifound: "I found this pet",
        popup_sighting_sending: "Sending your location…",
        popup_sighting_sent: "Sighting sent ❤️ Owner notified.",
        guardians_city: "{count} PawLink guardians protecting pets in {city} 🐾",
        guardians_sub: "Your pet has thousands of eyes helping him come home.",
        sheet_missing: "Missing",
        sheet_found_safe: "Found safely",
        sheet_reward: "Reward if returned",
        sheet_contact_owner: "Contact owner",
        sheet_privacy: "Locations are shared only when someone chooses to help.",
        sheet_reunion_h: "Back home, safe and sound",
        sheet_reunion_sub: "{name} was recently reunited with their family thanks to the PawLink community. 🐾",
        live: "Live",
        live_rescue_network: "Live rescue network",
        avatars_caption: "Guardians nearby — anonymous by default 🐾",
        helper_ready_h: "PawLink Helper — ready to help",
        helper_ready_sub: "Anonymous by default. If a pet goes missing nearby, this neighbor can help you find them.",
        ticker_area_generic: "your area",
        ticker_joined: "🐾 {name} just joined the PawLink community",
        ticker_reunited: "❤️ {name} returned home safely",
        ticker_someone_helping: "🔍 Someone is helping find a lost pet nearby",
        ticker_helper_joined_area: "📍 A PawLink helper joined in {area}",
        ticker_helpers_watching: "🛡️ {count} guardians watching over {area}",
        ticker_helping_lost: "🐾 Neighbors are helping look for a lost pet nearby",
        ticker_guardian_active: "✨ {name} became a PawLink Guardian",
        rescue_alert_h: "🚨 {count} pet(s) need help nearby",
        rescue_alert_sub: "Tap the map, share a sighting, or call the owner. Every second matters.",
        rescue_help_now: "Help now",
        locate_me: "Center on my location",
        empty_first_guardian_h: "Be the first PawLink Guardian in your area 🐾",
        empty_first_guardian_sub: "No lost pets, helpers, or reunions have been reported around you yet. Turn on Helper mode to become the first pair of eyes watching over pets in your neighborhood.",
        empty_needs_location_h: "Your rescue map is waiting",
        empty_needs_location_sub: "Add your approximate area to see real PawLink members, live lost-pet alerts, and reunions happening around you. Your exact address is never stored.",
        empty_share_cta: "Add my approximate area",
        empty_become_helper: "Become a PawLink Helper",
    },
    pricing: {
        eyebrow: "Pricing",
        h1: "Simple and fair.",
        sub: "Discover PawLink for free. When you're ready to protect your best friend, activate PawLink Protection.",
        free_title: "FREE",
        free_price: "$0",
        free_period: "",
        free_desc: "Discover PawLink and create your first digital ID.",
        premium_title: "PAWLINK PROTECTION 🐾",
        premium_desc: "Because losing them is not an option ❤️",
        premium_line: "A smart protection system that helps bring your best friend home safely.",
        billing_monthly: "Monthly",
        billing_yearly: "Yearly",
        price_monthly: "9.90 CHF",
        per_month: "/ month",
        price_yearly: "79.00 CHF",
        per_year: "/ year",
        save_badge: "Best value · $1.67/mo",
        recommended: "⭐ Best Value",
        free_list: [
            "Create 1 profile",
            "Add photo & basic details",
            "Preview your Smart ID",
            "See how protection works",
        ],
        free_footer: "QR activation and premium safety tools require PawLink Protection.",
        premium_benefits: [
            { emoji: "🚨", title: "Lost Rescue Mode", sub: "Instant alerts + scan location when someone finds your best friend." },
            { emoji: "📍", title: "Smart QR ID", sub: "Anyone can scan and contact you instantly — no app required." },
            { emoji: "✈️", title: "Digital Passport", sub: "Vaccines, vet records & travel documents always ready." },
            { emoji: "❤️", title: "Emergency Health & Safety Profile", sub: "Allergies, medical needs & personality details in one place." },
            { emoji: "👨‍👩‍👧", title: "Trusted Family Contacts", sub: "Your loved ones can help bring them home safely." },
            { emoji: "🐾", title: "Multi-Pet Protection", sub: "Protect every dog or cat you love from one account." },
        ],
        one_scan: "One scan can bring them home 🐾",
        your_plan: "Your plan",
        upgrade: "Activate PawLink Protection",
        get_free: "Get started free",
        go_dash: "Go to dashboard",
        redirecting: "Redirecting…",
        on_premium: "You're protected",
        secure: "Secure checkout by Paddle. Cancel anytime.",
    },
    payment: {
        checking_h: "Confirming your payment…",
        checking_sub: "Hang tight, this only takes a moment.",
        paid_h: "Welcome to Premium!",
        paid_sub: "You’ve unlocked QR download (PNG & PDF), instant scan alerts, last scan location, and voice replies from finders.",
        go_dash: "Go to dashboard",
        expired_h: "Session expired",
        expired_sub: "Your checkout session ended. Please try again.",
        back_pricing: "Back to pricing",
        pending_h: "Still processing…",
        pending_sub: "This is taking longer than usual. Your subscription will appear on the dashboard once completed.",
        continue: "Continue",
        error_h: "We hit a snag",
        error_sub: "We couldn’t verify your payment. Please contact support if you were charged.",
    },
    langpicker: {
        title: "Choose your language",
        sub: "You can change it later from the header.",
        continue: "Continue",
    },
    theme: { light: "Light", dark: "Dark", system: "System default" },
    account: {
        eyebrow: "Your account",
        title_greeting: "Welcome, {name}",
        header_edit: "Edit profile",
        section_profile: "Personal information",
        section_prefs: "App preferences",
        section_privacy: "Privacy & security",
        community_vis_h: "Community Map Visibility",
        community_vis_sub: "Controls whether you appear under Nearby Community on the shared map. Exact location and personal contact details are never shared.",
        community_vis_hidden: "Hidden",
        community_vis_approximate: "Visible approximately",
        section_help: "Help & support",
        section_legal: "Legal",
        section_help_legal: "Help & legal",
        // profile fields
        f_name: "Full name",
        f_name_ph: "Your name",
        f_name_hint_google: "Imported from your Google account.",
        f_email: "Email",
        f_email_hint: "Contact support to change your email.",
        f_phone: "Phone number",
        f_phone_ph: "Optional — used for scan alerts",
        f_country: "Country",
        f_country_ph: "United States",
        save: "Save changes",
        saving: "Saving…",
        saved: "Saved",
        // preferences
        pref_language: "Language",
        pref_appearance: "Appearance",
        pref_appearance_hint: "Match your system or pick a mood.",
        pref_notifications: "In-app notifications",
        pref_notifications_hint: "Receive scan alerts inside PawLink.",
        // privacy
        priv_public_h: "Public pet profile",
        priv_public_sub: "When someone scans your Smart QR they only see your pet's photo, name, and the contact you choose. Your home address is never shared.",
        priv_public_manage: "Manage per-pet visibility in My Pets.",
        priv_password_h: "Change password",
        priv_password_google: "You sign in with Google, so no password to change here.",
        priv_password_current: "Current password",
        priv_password_new: "New password (min. 8 characters)",
        priv_password_save: "Update password",
        priv_password_ok: "Password updated.",
        priv_delete_h: "Delete account",
        priv_delete_sub: "Permanently remove your account, pets, scan history, and messages. This can't be undone.",
        priv_delete_help: "Need help with account deletion? Contact us at",
        priv_delete_btn: "Delete my account",
        priv_delete_confirm_h: "Are you absolutely sure?",
        priv_delete_confirm_sub: "Type DELETE below to confirm. All your pets and scan history will be erased.",
        priv_delete_placeholder: "Type DELETE",
        priv_delete_yes: "Yes, delete forever",
        priv_delete_cancel: "Keep my account",
        // help
        help_center: "Help center",
        help_contact: "Contact support",
        help_faq: "FAQ",
        help_report: "Report a problem",
        // legal
        legal_terms: "Terms of Use",
        legal_privacy: "Privacy Policy",
        // logout
        logout: "Sign out",
    },
    qr: { locked_h: "QR download is Premium", locked_sub: "Upgrade to 9.90 CHF/mo to download PNG and printable PDF for your pet’s QR.", locked_cta: "Unlock download", png: "Download PNG", pdf: "Printable PDF", scan_hint: "Print this QR on a tag, collar, or sticker. If your pet gets lost, any finder can scan it.", downloading: "Preparing…", pdf_headline: "If found, please scan", pdf_sub: "This tag is protected by PawLink — the finder will see this pet's photo, allergies, medical notes and contact you in one tap.", pdf_scan_here: "SCAN HERE", pdf_url_label: "Or visit", pdf_footer: "PawLink — Smart QR Pet ID · getpawlink.com", page_h: "Your Smart QR codes", page_sub: "Download, print, or share each pet's tag anywhere — collar, sticker, poster, or backup card.", public_link: "Public link", empty_h: "No QR codes yet", empty_sub: "Create a pet first — we'll generate a Smart QR that leads finders home." },
    pets_page: {
        hero_kicker: "Your family",
        hero_h: "Everyone home. Everyone safe.",
        hero_sub: "Every one of your pets carries a Smart QR. If they get lost, a stranger can bring them home in seconds.",
        add_pet: "Add another family member",
        error_title: "We couldn't load your pets",
        error_sub: "The server didn't respond. Check your connection and try again — your data is safe.",
        error_retry: "Try again",
        status_active: "Protected",
        status_lost: "Missing",
        status_sub: "Digital ID active",
        status_ready: "Ready if {name} gets lost",
        badge_qr: "QR active",
        act_view: "View profile",
        act_qr: "QR code",
        act_edit: "Edit info",
        act_delete: "Delete",
        protected_line: "{name} is protected",
        lost_line: "{name} is missing — help is on the way",
        safety_h: "Safety Center",
        safety_sub: "Lost mode · Personality · Passport",
        safety_lost_h: "{name} is in Lost Mode",
        safety_lost_sub: "Open the emergency dashboard",
        confirm_delete: "Remove {name}'s profile? This can't be undone.",
        cancel: "Cancel",
        empty_h: "Meet your best friend",
        empty_sub: "Create their digital safety passport. It takes 2 minutes and could bring them home forever.",
        empty_cta: "Protect my pet",
        trust_h_one: "Your best friend is safe.",
        trust_h_many: "Your {count} best friends are safe.",
        trust_sub: "Every scan sends you their live location instantly. You're never more than one tap away from bringing them home.",
    },
    home_story: {
        hero_eyebrow: "PawLink · Smart Pet ID",
        hero_h_a: "When they get lost…",
        hero_h_a2: "They can't tell anyone where home is.",
        hero_h_b: "PawLink can.",
        hero_sub: "Because love is the fastest way home.",
        hero_cta_primary: "Protect my best friend",
        hero_cta_secondary: "See how it works",
        hero_scroll: "See how it works",
        pill_scan: "Scan · Reach owner · Reunion",
        // Scene 1 — The Scan
        s1_kicker: "Scene 01 · The Scan",
        s1_h: "Someone finds your best friend.",
        s1_sub: "A stranger scans the PawLink tag. In the next second, they see your photo, hear your voice, and reach you with one tap. No app, no sign-up. Just kindness — instantly connected.",
        s1_note_title: "New scan · Central Park",
        s1_note_body: "A finder just scanned Milo's tag.",
        // Scene 2 — Lost Mode
        s2_kicker: "Scene 02 · Lost Mode",
        s2_h: "Your best friend is missing.",
        s2_sub: "Activate Lost Mode. Every scan pings your phone with GPS. Your neighborhood becomes a search party — your reward, your plea, your photo travel wherever the tag goes.",
        s2_chip: "MISSING · Please help",
        s2_stat: "Live search",
        // How it works — 3 clear steps
        how_kicker: "How PawLink works",
        how_h: "Three simple steps to bring them home.",
        how_sub: "PawLink is a digital service — your Smart QR is ready in minutes, not days.",
        how_1_h: "Create your pet's PawLink profile",
        how_1_sub: "Add the pet's photo, name, owner contact options, medical information and the details the owner chooses to share.",
        how_2_h: "Generate and attach the smart QR",
        how_2_sub: "PawLink generates a unique QR code that the owner can download, print and attach to the pet's collar or tag.",
        how_3_h: "One scan connects the finder to the owner",
        how_3_sub: "When someone scans the QR code, they immediately see the pet's Rescue Card with the photo, name and owner-approved contact buttons. The owner receives an instant scan alert and the scan location when available.",
        // Benefits — Premium single card (3 pillars) shown on Home
        benefits_kicker: "Why PawLink",
        benefits_h: "Everything you need to bring them home.",
        big_b1_h: "Digital Pet Passport",
        big_b1_sub: "No more carrying documents with you. Your pet's passport, vaccination records, insurance, rabies certificate and medical history are always with you — ready for travel or a veterinary visit.",
        big_b2_h: "Rescue Center",
        big_b2_sub: "Report your dog as lost and activate Lost Mode. Track their live GPS location and get precise directions to bring them home safely.",
        big_b3_h: "Smart QR",
        big_b3_sub: "Download your pet's unique digital QR code and use it however you like — print it at home, add it to a collar tag or accessory you already own, or share it as a sticker. When someone scans it, you get an instant notification and the finder can reach you immediately to help reunite you with your pet.",
        big_b4_h: "PawLink Map",
        big_b4_sub: "Connect with nearby PawLink members who can help search for and reunite you with your pet.",
        benefits_close: "Don't worry. We're with you whenever you need us.",
        // Legacy 6-tile benefits — kept for backward compatibility (not currently rendered on Home)
        hb1_h: "PawLink Rescue Community",
        hb1_sub: "If your pet goes missing, you are not alone. Nearby PawLink members can become part of the search and help bring your friend home.",
        hb2_h: "Smart QR + Instant Scan Alerts",
        hb2_sub: "Create a unique QR code for your pet and receive an immediate in-app and email alert whenever someone scans it — including scan time and location when available.",
        hb3_h: "Smart Rescue Card",
        hb3_sub: "After scanning the QR, the finder sees a clean rescue card containing only what the owner chose to share — photo, name, call button, WhatsApp, medical warning, reward and emergency notes.",
        hb4_h: "Digital Pet Passport",
        hb4_sub: "Keep essential vaccination, travel and identification information together in one secure digital place.",
        hb5_h: "PawLink Rescue Map",
        hb5_sub: "Discover nearby PawLink members and rescue activity wherever you are, so help may be closer when your pet goes missing.",
        hb6_h: "Medical Records Always Available",
        hb6_sub: "Store allergies, medications, medical information and veterinarian details so they are available during vet visits, emergencies and travel.",
        // Reviews / social proof
        reviews_kicker: "Loved by pet parents",
        reviews_h: "Real reunions. Real families.",
        review_1_body: "Someone scanned Luna's PawLink QR and she was back home the same day. I still cry thinking about it.",
        review_1_author: "Emily · Dog Mom",
        review_2_body: "Best protection I bought for my dog. Simple, worth every dollar, and I sleep better at night.",
        review_2_author: "James · PawLink member",
        // Family section
        family_kicker: "Join the PawLink family 🐾❤️",
        family_h_none: "Pet parents who protect their best friends — before something happens.",
        family_h_one: "You're one of them. One name, one heart, one safety net.",
        family_h_many: "You're one of them. {count} names. {count} hearts. One safety net.",
        family_sub: "A quiet community of families who choose to be ready. Everyone home. Everyone safe.",
        family_cta: "Add another pet",
        family_cta_manage: "Manage my pets",
        family_cta_first: "Create your first pet",
        // Final CTA
        final_kicker: "PawLink Protection",
        final_h: "If you truly love your best friend, protect them today ❤️",
        final_sub: "Don't wait for the day you wish you had done it earlier. 9.90 CHF / month · 79.00 CHF / year. Cancel anytime.",
        final_cta_upgrade: "Protect my best friend",
        final_cta_manage: "Manage plan",
        final_active: "Protection active",
    },
    home_protection: {
        eyebrow: "One protection. One family.",
        heading: "Give them the safest way home",
        body: "See exactly what PawLink Protection unlocks — from instant scan alerts to a rescue community that helps bring lost pets home faster.",
        cta: "See PawLink Protection",
    },
    install: {
        title: "Protect your pet in less than one minute.",
        subtitle: "Install PawLink directly from our website and start protecting your pet today. No app store search. No complicated setup. Just install, create your pet profile, and you're ready.",
        cta: "Install PawLink",
        cta_installing: "Installing…",
        cta_installed: "Installed",
        cta_open: "Open PawLink",
        desktop_qr_title: "Scan to install PawLink instantly.",
        desktop_qr_sub: "Point your phone's camera at this code — you'll continue the installation on your device.",
        badge_secure: "Secure Installation",
        badge_free: "Free Download",
        badge_fast: "Fast Setup",
        badge_updates: "Automatic Updates",
        ios_modal_title: "Install PawLink on iPhone",
        ios_modal_sub: "In Safari, tap the Share button and then \"Add to Home Screen\".",
        ios_step_1: "Tap the Share icon at the bottom of Safari.",
        ios_step_2: "Choose \"Add to Home Screen\".",
        ios_step_3: "Tap Add — PawLink is now on your home screen.",
        ios_modal_close: "Got it",
        already_installed_hint: "Already installed? Open PawLink from your home screen.",
        phone_caption: "The rescue card your pet will wear.",
        ios_coming_kicker: "Coming soon on the App Store",
        ios_coming_title: "PawLink for iPhone is on the way.",
        ios_coming_sub: "We're finalizing the App Store release. In the meantime, you can still protect your pet — every feature works beautifully on the web.",
        ios_meanwhile_label: "In the meantime",
        ios_meanwhile_body: "Create your PawLink account now and start protecting your pet from Safari — no install required.",
        share_cta: "Share PawLink",
        share_title: "Share PawLink",
        share_sub: "Help another pet get home safe — share PawLink with your friends and family.",
        share_message: "PawLink — the smart QR safety ID that helps bring lost pets home. Try it free:",
        share_whatsapp: "WhatsApp",
        share_facebook: "Facebook",
        share_x: "X",
        share_email: "Email",
        share_copy: "Copy link",
        share_copied: "Link copied",
        share_close: "Close",
        petcard_verified: "PawLink Verified",
        petcard_qr_id: "QR ID",
        petcard_vaccinations: "Vaccinations",
        petcard_up_to_date: "Up to date",
        petcard_allergies: "Allergies",
        petcard_medical: "Medical notes",
        petcard_owner: "Owner",
        petcard_emergency: "Emergency",
        petcard_documents: "Documents",
        petcard_passport: "Passport · Vet records",
        petcard_updated: "Updated",
        petcard_updated_time: "2 days ago",
        petcard_pet_name: "Coco",
        petcard_pet_breed: "Toy Poodle · Female",
        petcard_allergy_value: "Chicken protein",
        petcard_medical_value: "None reported",
        petcard_owner_value: "Léa M.",
        petcard_none: "None",
        // Rescue scan mockup (public finder view shown on Home)
        petcard_scan_title: "QR scanned successfully",
        petcard_scan_sub: "This pet has a family waiting.",
        petcard_age: "Age",
        petcard_age_value: "3 years",
        petcard_gender: "Gender",
        petcard_gender_value: "Female",
        petcard_reward: "Reward for safe return",
        petcard_reward_value: "$200",
        petcard_notes: "Emergency notes",
        petcard_notes_value: "Very friendly. Please keep her hydrated and calm until we arrive.",
        petcard_call: "Call owner",
        petcard_whatsapp: "WhatsApp",
        android_soon_kicker: "Android APK — coming very soon",
        android_soon_title: "PawLink Android is nearly ready.",
        android_soon_sub: "Our native Android app is in final testing. In the meantime, install PawLink as a web app — same protection, ready in one tap.",
        android_install_pwa: "Install as web app",
        android_dismiss: "Not now",
    },
    home_pricing: {
        eyebrow: "Simple, honest pricing",
        heading: "Free forever — Protection when it matters most",
        sub: "Start free. Upgrade only when you want the extras that turn PawLink into a true rescue network.",
        hero_get_started: "Get started — it's free",
        free_title: "Free",
        free_price: "$0",
        free_sub: "Everything you need to bring them home.",
        free_f1: "1 pet profile with Smart QR",
        free_f2: "Real-time scan alerts",
        free_f3: "Basic finder contact tools",
        free_cta: "Create free account",
        pro_title: "PawLink Protection",
        pro_price: "79.00 CHF",
        pro_period: "/year",
        pro_sub: "Or 9.90 CHF / month · cancel anytime",
        pro_badge: "Most loved",
        pro_f1: "Unlimited pets & profiles",
        pro_f2: "Digital passport & medical documents",
        pro_f3: "PawLink Community Rescue Map",
        pro_f4: "Two-way voice messages with finders",
        pro_f5: "Priority reunion support",
        pro_cta: "Get Protection",
        see_all: "Compare all features",
    },
    home_faq: {
        eyebrow: "Questions & answers",
        heading: "Everything a pet owner asks before joining PawLink",
        q1_q: "How does the Smart QR actually work?",
        q1_a: "You download your pet's unique digital QR from the pet's page and display it however you like — print it at home, add it to a tag or collar you already own, or share it as a sticker. When anyone points a phone at it, they open a beautiful public page showing your pet's name and how to reach you — no app or account needed on their side.",
        q2_q: "What happens the moment my pet is scanned?",
        q2_a: "You get an instant notification in the Rescue Center with the finder's live location (reverse-geocoded to city / street), any voice message they leave, and a direct way to call them back.",
        q3_q: "Do you share my exact address?",
        q3_a: "Never. Finders see only the info you choose to display on your public profile. The Community Map uses approximate location — your home address stays private, always.",
        q4_q: "Can I cancel PawLink Protection anytime?",
        q4_a: "Yes. Manage or cancel your subscription in one tap from Settings. Your free profile — and every scan history — stays yours forever.",
        see_all: "See the full FAQ",
    },
    rescue: {
        title: "Every rescue, in one place.",
        sub: "Alerts, scans, and finder contacts — all your pet's rescue activity, together.",
        tab_alerts: "Alerts",
        tab_scans: "Scan history",
        filter_all: "All pets",
        call_finder: "Call finder",
        sms_finder: "Send SMS",
        empty_alerts_h: "You're all caught up.",
        empty_alerts_sub: "No alerts yet. When someone scans your Smart QR, you'll see it here instantly with GPS and any message they leave.",
        empty_scans_h: "No scans yet.",
        empty_scans_sub: "Print your Smart QR on a tag or collar. As soon as someone scans it, you'll see where and when — right here.",
        finder_voice_h: "Voice message from the finder",
        rescue_alert_line: "🚨 A pet nearby needs help — {pet} · {km} km away",
        rescue_alert_open: "See rescue details",
    },
    legal: {
        back: "Back to Account",
        updated: "Updated",
        privacy_kicker: "Legal · Privacy",
        privacy_title: "Your data, protected.",
        privacy_sub: "Exactly what PawLink collects, how we use it, and the controls you have.",
        terms_kicker: "Legal · Terms",
        terms_title: "Terms of Use",
        terms_sub: "Simple, human terms for using PawLink to keep your pet safe.",
        faq_kicker: "Support · FAQ",
        faq_title: "Questions pet owners ask.",
        faq_sub: "Everything you might wonder about Smart QR pet IDs, privacy, and Protection.",
        support_kicker: "Support",
        support_title: "We're here for you and your pet.",
        support_sub: "Send us a message and we'll get back to you — usually within one business day.",
    },
    support: {
        email_label: "Email us",
        email_hint: "For urgent issues, an email always reaches a human.",
        faq_label: "Self-serve",
        faq_title: "Browse the FAQ",
        faq_hint: "Answers to the questions we hear every week.",
        form_title: "Send us a message",
        form_sub: "Tell us what's happening and we'll take it from there.",
        cat_account: "Account",
        cat_billing: "Billing",
        cat_bug: "Bug",
        cat_safety: "Pet safety",
        cat_other: "Other",
        f_category: "Category",
        f_email: "Your email",
        f_subject: "Subject",
        f_subject_ph: "A short summary",
        f_message: "Message",
        f_message_ph: "Share as much detail as you can — order or scan IDs help us help you faster.",
        send: "Send message",
        sending: "Sending…",
        sent_ok: "Message sent. We'll be in touch soon.",
    },
    qr_detail: {
        back: "Back to pets",
        kicker: "Digital Pet ID",
        protection_badge: "Protected by PawLink",
        pet_id: "PawLink ID",
        scan_h: "How to use this QR",
        scan_1: "Print it on a tag, sticker, collar or wallet card",
        scan_2: "Attach it to something your pet always wears",
        scan_3: "If they get lost, any finder scans and reaches you instantly",
        actions_download_png: "Download PNG",
        actions_download_pdf: "Download PDF",
        actions_print: "Print QR",
        actions_share: "Share",
        share_title_prefix: "Find",
        share_text: "If you find them, please scan this and bring them home ❤️",
        tags_h: "See it on real tags",
        tags_sub: "Imagine your pet wearing your PawLink QR. Download the QR anytime and print it yourself on any tag or collar you already own — PawLink is a digital service and does not sell any physical product.",
        tag_stainless: "Stainless steel",
        tag_bone: "Bone shape",
        tag_black: "Black premium",
        tag_gold: "Gold premium",
        tag_silicone: "Silicone",
        tag_sticker: "Sticker",
        tag_wallet: "Wallet card",
        premium_gate_h: "Download {name}'s QR — Premium",
        premium_gate_sub: "Upgrade to 9.90 CHF/mo to download, print, and share {name}'s QR anywhere.",
        premium_gate_cta: "Unlock this QR",
        premium_gate_preview: "You can preview the design — downloading unlocks with Protection.",
        passport_reassure: "If {name} is found, this code guides them back to you.",
        live_indicator: "Live",
    },


    safety: {
        kicker: "Safety Center",
        title: "Keep {name} safe",
        sub: "Emergency mode, personality tags, and travel-ready documents — everything that keeps {name} safe every day.",
        back_to_pets: "Back to pets",
        pet_not_found: "Pet not found",
        tab_emergency: "Alert",
        tab_personality: "Traits",
        tab_passport: "Passport",
        tab_health: "Health",
        hero_safe: "Currently safe",
        sos_kicker: "Emergency mode",
        sos_h: "If {name} ever gets lost",
        sos_sub: "One tap turns {name}'s public QR into a full missing-pet page — with your contact, last-seen spot and reward.",
        sos_cta: "Report {name} missing",
        sos_reassure: "You can turn this off any time when {name} is back home safe.",
        step_s1_h: "Tap SOS",
        step_s1_d: "One button flips the QR to emergency mode instantly.",
        step_s2_h: "Strangers see your alert",
        step_s2_d: "Big red banner, one-tap call, reward and last-seen spot.",
        step_s3_h: "You get {name} home",
        step_s3_d: "Every scan pings you. Bring your family back together.",
        modal_h: "Report {name} missing",
        modal_sub: "This changes the public QR page to emergency mode instantly.",
        f_last_seen: "Last seen location",
        f_last_seen_ph: "e.g. Riverside Park by the west gate",
        f_reward: "Reward (optional)",
        f_reward_ph: "e.g. $200",
        f_instructions: "Note for whoever finds them",
        f_instructions_ph: "e.g. {name} is shy — please don't chase. Call me and I'll come.",
        gps_sharing: "Reading your location…",
        gps_ok: "Your location saved as starting point",
        gps_off: "Location off — that's OK, you can type an address.",
        gps_idle: "We'll capture your location if you allow it.",
        activate_now: "Activate Lost Mode",
        activating: "Activating…",
        activate_error: "Could not activate. Please try again.",
        activate_fineprint: "You can mark {name} as safe any time.",
        status_lost: "Lost Mode active",
        missing_for: "Missing for {time}",
        missing_now: "Just reported missing",
        stat_scans: "Scans since missing",
        stat_qr: "Public QR",
        stat_qr_on: "In emergency mode",
        share_h: "Share the alert",
        copied: "Link copied",
        copy_link: "Copy link",
        share_msg: "Help — my dog {name} is missing! Please share this link so a finder can bring them home: {url}",
        mark_safe_cta: "{name} is safe — bring them home",
        rescue_alert_h: "Alert nearby Guardians",
        rescue_alert_sub: "Ping every opted-in PawLink Guardian in your chosen radius. They see the pet photo & last-seen area — never your phone or address.",
        rescue_alert_send: "Send alert to Guardians within {r} km",
        rescue_alert_sending: "Sending alert…",
        rescue_alert_result: "Alert sent to {n} nearby Guardian(s) within {r} km ❤️",
        rescue_alert_error: "Couldn't send the alert. Please try again.",
        rescue_alert_privacy: "We share the pet name, photo and rough area only. Your identity stays private.",
        confirm_safe: "Mark {name} as found and safe? This turns Lost Mode off.",
        preview_h: "What a finder sees right now",
        preview_line1: "🚨 {name} is missing — please help.",
        preview_line2: "Call button, reward and your instructions are shown front and centre.",
        preview_cta: "Preview the public page",
        elapsed_d: "{d}d",
        elapsed_h: "{h}h",
        elapsed_m: "{m}m",
        elapsed_now: "just now",
        personality: {
            h: "How to approach {name}",
            sub: "Pick every tag that fits {name}. Strangers who scan the QR will see them — so they know exactly how to interact.",
            g_friendly: "Good vibes",
            g_friendly_sub: "Tell finders what {name} loves.",
            g_careful: "Handle with care",
            g_careful_sub: "Anything a stranger should be gentle about.",
            g_medical: "Medical & diet",
            g_medical_sub: "So no one gives them the wrong food or misses their meds.",
            save_cta: "Save personality",
            no_changes: "All up to date",
        },
        p: {
            friendly_people: "Friendly with people",
            friendly_dogs: "Friendly with dogs",
            friendly_cats: "Friendly with cats",
            good_children: "Great with children",
            trained: "Well trained",
            energetic: "Energetic & playful",
            nervous: "Nervous / anxious",
            needs_space: "Needs space",
            do_not_approach: "Don't approach without owner",
            medical_needs: "Has medical needs",
            special_diet: "On a special diet",
            needs_medication: "Needs medication",
        },
        passport: {
            brand: "Digital Pet Passport",
            g_health: "Vaccines & health",
            g_vet: "Vet & certificates",
            g_insurance: "Insurance",
            g_travel: "Travel & other",
            empty_h: "No documents yet",
            empty_sub: "Upload {name}'s rabies certificate, vaccine records or insurance — carry the paperwork nowhere, everywhere.",
            add_h: "Add a new document",
            add_sub: "PDF or photo. Only you can see it unless you flip it to public.",
            upload_cta: "Upload document",
        },
        dockind: {
            vaccine: "Vaccination",
            rabies: "Rabies certificate",
            vet: "Vet document",
            medical: "Medical record",
            insurance: "Insurance",
            travel: "Travel document",
            other: "Other",
        },
        f_doc_name: "Document name",
        f_doc_name_ph: "e.g. Rabies 2026",
        f_doc_kind: "Type",
        uploading: "Uploading…",
        upload_error: "Upload failed. Please try again.",
        saved: "Saved",
        view: "View",
        public_on: "Visible to finders (public)",
        public_off: "Only you can see it (private)",
        public_on_hint: "The finder scanning the QR can view this document.",
        public_off_hint: "Kept private — only for you.",
        tt_public: "Public — visible to finders",
        tt_private: "Private — only you",
        confirm_remove_doc: 'Remove "{name}"? This can\'t be undone.',
    },
    footer: { product: "Product", pricing: "Pricing", create_profile: "Create a profile", sign_in: "Sign in", trust: "Trust & Legal", trust1: "Privacy-first: you choose what a finder sees.", trust2: "Dynamic QR — edit info any time.", trust3: "Made with care for pets & owners.", tag: "Bring them home.", support: "Support", contact_us: "Contact us", help_center: "Help center" },
    scanloc: {
        exact: "Exact GPS",
        exact_acc: "Exact GPS · ±{m} m",
        coarse: "Approx GPS",
        coarse_acc: "Approx GPS · ±{m} m",
        approx: "Approximate location",
        unknown: "Unknown location",
        open_exact: "Open exact spot on Google Maps",
        open_coarse: "Open approx. spot on Google Maps",
        open_area: "Open general area on Google Maps",
        open_in_maps: "Open in Google Maps",
    },
    premium_soon: {
        badge: "Coming soon",
        chip: "Premium",
        title: "Premium is coming soon 🐾",
        body: "This feature is part of PawLink Premium. Premium subscriptions will be available soon.",
        free_hint: "For now, you can continue using PawLink's free features.",
        ok: "Got it",
    },
    subscription: {
        title_active: "PawLink Protection is active",
        title_choose: "Because losing them is not an option ❤️",
        sub_active: "You're protecting your best friend with our most advanced plan. Thank you for keeping them safe.",
        sub_choose: "A smarter way to protect the ones who are always by your side.",
        current_plan: "Current plan",
        plan_free_name: "Free plan",
        plan_premium_name: "PawLink Protection",
        plan_free_meta: "1 pet profile · Preview only",
        plan_premium_meta: "Renews automatically · Cancel anytime",
        active: "Active",
        upgrade_cta: "Upgrade to Protection",
        benefits_h: "What's included",
        emotional_sub: "A smarter way to protect the ones who are always by your side.",
        cancel_anytime: "Cancel anytime",
        get_started: "Get started",
        best_value_sub: "Best value · 6.58 CHF/mo, billed annually",
        choose_yearly: "Choose yearly",
        family_reassure: "You're protecting a family member — not buying a QR code.",
        // Emotional storytelling redesign
        emo_hero_title: "What if your pet gets lost today?",
        emo_hero_sub: "They can't tell someone your phone number. PawLink can bring them back home.",
        compact_title: "What if your pet gets lost?",
        compact_sub: "Get alerted. Share location. Bring them home faster.",
        hero_new_title: "Protect your best friend — even when you are not there",
        hero_new_sub: "One scan can help someone reach you faster.",
        b1_title: "Instant Lost Alert",
        b1_sub: "Know the moment someone finds your best friend.",
        b2_title: "Scan Location",
        b2_sub: "See exactly where the QR was scanned.",
        b3_title: "One-Tap Contact",
        b3_sub: "The finder reaches you instantly — no app required.",
        b4_title: "Digital Passport",
        b4_sub: "Vet records, vaccines & travel documents always with you.",
        b5_title: "Voice Message",
        b5_sub: "Let your voice comfort them until you reunite.",
        b6_title: "Smart QR Protection",
        b6_sub: "A faster way home when they need you.",
        // v7.41 — 6 emotional features (new subscription page)
        f1_title: "PawLink Rescue Community",
        f1_tagline: "If your pet goes missing, you're never alone. Nearby PawLink members can help search for your pet through the Rescue Community.",
        f1_line1: "One Family.",
        f1_line2: "One Mission.",
        f1_line3: "Bring Every Pet Home.",
        f2_title: "Smart QR Protection & Instant Alerts",
        f2_tagline: "The instant someone scans your pet's Smart QR, you get a push and email alert — so you can act in seconds, not hours.",
        f2_line1: "Push notification",
        f2_line2: "Email notification",
        f2_line3: "Scan time",
        f2_footer: "Know immediately when someone has found your best friend.",
        f3_title: "Smart Rescue Card",
        f3_tagline: "One scan reveals a beautiful rescue card — photo, name, medical warnings, reward, plus Call and WhatsApp buttons that reach you instantly.",
        f3_line1: "Pet photo",
        f3_line2: "Pet name",
        f3_line3: "Call owner button",
        f3_line4: "WhatsApp button",
        f3_line5: "Medical warning",
        f3_line6: "Reward (optional)",
        f3_line7: "Emergency notes",
        f3_footer: "The owner has complete control over what information is visible. Privacy always comes first.",
        f4_title: "Digital Pet Passport",
        f4_tagline: "Keep your pet's important information safely stored in one place. Vaccinations, travel information and essential records are always available whenever you need them.",
        f5_title: "PawLink Rescue Map",
        f5_tagline: "See nearby PawLink members and the rescue activity around you. When your pet goes missing, the Rescue Map helps connect you with nearby PawLink users who may be able to help bring your pet home faster.",
        f6_title: "Medical Records Always With You",
        f6_tagline: "Vaccinations, allergies, medications and vet contacts — securely stored and ready when it matters most.",
        f6_line1: "Medical information",
        f6_line2: "Allergies",
        f6_line3: "Medications",
        f6_line4: "Veterinary information",
        f6_footer: "No more carrying paper documents. Everything is available instantly during veterinary visits, emergencies or travel.",
        emotional_close: "Join the PawLink community — keep your pet safe today.",
        // v7.42 — Two-plan selector + home protection callout
        pick_a_plan_aria: "Pick a plan",
        plan_monthly_label: "Monthly",
        plan_yearly_label: "Yearly",
        plan_monthly_note: "Cancel anytime",
        plan_yearly_note: "Save 33% vs monthly",
        plan_yearly_badge: "Best Value",
        per_month: "/ month",
        per_year: "/ year",
        selected_prefix: "You selected:",
        cta_new: "Protect my pet 🐾",
        cta_open_browser: "Open in browser to subscribe →",
        store_free_h: "PawLink is free on this app",
        store_free_sub: "You can use all core PawLink features on Android at no cost — no subscription is required inside this app. Your pet profiles, Smart QR, Lost Mode, and notifications are all available for free.",
        early_access_chip: "Founding Member · Early Access",
        early_access_h: "Welcome to PawLink Early Access 🐾",
        early_access_sub: "PawLink is new — and you're early. Enjoy PawLink's protection features during our early-access period while we continue building PawLink for pet families worldwide.",
        early_access_note: "You're one of PawLink's early members. Premium plans and additional features are coming in the future.",
        ea_welcome_h: "You're an early PawLink member 🧡",
        ea_welcome_sub: "Thanks for joining us early. Set up your pet's profile and Smart QR at no charge — additional PawLink Premium features (Lost Mode, PawLink Rescue Map, live tracking) are coming soon.",
        ea_welcome_dismiss: "Got it",
        trial_title: "How your 7-day free trial works",
        trial_day0: "Day 0 — Full access unlocks, free.",
        trial_day5: "Day 5 — We remind you before the trial ends.",
        trial_day7: "Day 7 — PawLink protection begins.",
        urgency_line: "Lost pets don't wait. Be ready before it happens. ❤️",
        family_line: "Because they are family — and family deserves a way home",
        billing_help: "Billing or subscription questions? Contact us at",
        benefit_short_1: "Instant alert",
        benefit_short_2: "Live location",
        benefit_short_3: "Privacy safe",
        journey_kicker: "The rescue journey",
        journey_title: "Lost → Scan → Alert → Home",
        journey_1_title: "Someone found Max",
        journey_1_sub: "Instant scan alert on your phone.",
        journey_2_title: "Last-seen location",
        journey_2_sub: "Know exactly where the QR was scanned.",
        journey_3_title: "One-tap contact",
        journey_3_sub: "The finder reaches you immediately.",
        journey_4_title: "Private & safe",
        journey_4_sub: "Your home address stays hidden — always.",
        best_protection: "Best Protection",
        cancel_line: "No charge today · Cancel anytime with one tap.",
        cardholder_hint: "Please enter the name on your card exactly as printed — letters, spaces, hyphens (-) and apostrophes (') only. Numbers or symbols aren't accepted by our payment provider.",
        cardholder_helper: "Tip: enter your cardholder name in Latin letters — spaces, hyphens (-) and apostrophes (') are fine.",
        invalid_browser_locale: "Your browser is reporting an unusual language setting that prevents secure checkout from loading. Please change your browser or system language to a standard locale (e.g. English) and reload, or contact support@getpawlink.com and we'll help you activate Protection manually.",
        checkout_config_missing_token: "Secure checkout is temporarily unavailable — our payment configuration is missing on this deployment. Please contact support@getpawlink.com and we'll activate Protection for you.",
        checkout_config_wrong_env: "Secure checkout is temporarily unavailable — our payment provider is not fully configured for this domain. Please contact support@getpawlink.com and we'll activate Protection for you.",
        checkout_config_test_token: "Secure checkout is temporarily unavailable — our payment provider is running in test mode on this domain. Please contact support@getpawlink.com and we'll activate Protection for you.",
        checkout_config_missing_price: "Secure checkout is temporarily unavailable — plan pricing is not fully configured. Please contact support@getpawlink.com and we'll activate Protection for you.",
        cancel_manage: "Manage or cancel subscription",
        cancel_confirm: "Yes, cancel at period end",
        cancel_back: "Keep my Protection",
        canceling: "Canceling…",
        cancel_ok: "Subscription will end at the end of the current period.",
        cancel_error: "We couldn't cancel just now. Please try again in a moment.",
        emo_cta: "Protect my pet",
        emo_cta_premium: "Protection is active",
        or_monthly: "Prefer monthly?",
        billing_h: "Billing",
        billing_sub: "We use Paddle for secure billing. To update your card, cancel, or view invoices, tap below.",
        billing_contact: "Contact billing support",
        // New premium page copy
        kicker_protection: "PawLink Plans",
        hero_title_pre: "Because losing them is not an option",
        hero_sub: "A smarter way to protect the ones who are always by your side.",
        protection_name: "PAWLINK PROTECTION",
        protection_name_short: "PawLink Protection",
        best: "Best",
        best_value: "Best Value",
        yearly_save_line: "Save 33% · 6.58 CHF/mo, billed annually",
        monthly_flex_line: "Cancel anytime — no commitment",
        cta: "Activate Protection",
        redirecting: "Redirecting to secure checkout…",
        checkout_error: "Could not start checkout. Please try again.",
        secure: "Secure checkout with Paddle",
        features: {
            smart_qr: {
                title: "Smart QR + Live Location",
                sub: "When someone scans your pet's QR, receive the location instantly and connect in one tap.",
            },
            passport: {
                title: "Digital Pet Passport",
                sub: "Keep vet records, vaccines, travel papers and important documents always ready — at the airport, vet or anywhere.",
            },
            rescue: {
                title: "Community Rescue Alert",
                sub: "If your pet goes missing, notify nearby PawLink users who can help.",
            },
            identity: {
                title: "Complete Pet Identity",
                sub: "All important information in one secure profile: care details, needs, emergency contacts and personality.",
            },
        },
        page_title: "Two ways to protect your pet.",
        page_sub: "Start free. Upgrade when you want faster alerts and wider help.",
        free_name: "PawLink Free",
        free_tagline: "A simple first step to keep your pet connected to you.",
        free_price: "0.00 CHF",
        free_billing_label: "Forever",
        free_feat_1_title: "1 Digital Pet Profile",
        free_feat_1_sub: "Keep essential identity and contact details in one place.",
        free_feat_2_title: "Unique Smart QR Code",
        free_feat_2_sub: "Download, print, and attach it to any tag or collar.",
        free_feat_3_title: "Instant Rescue Page",
        free_feat_3_sub: "Help a finder recognize your pet and reach you quickly.",
        free_feat_4_title: "No App Required",
        free_feat_4_sub: "Any finder can scan the QR code directly with a phone.",
        free_cta_web: "Create My Free Profile",
        free_cta_android: "Continue with Free",
        recommended_badge: "Recommended",
        protection_name: "PawLink Protection",
        protection_tagline: "Faster alerts, wider support, and greater peace of mind.",
        protection_price_monthly: "9.90 CHF",
        protection_price_annual: "79.00 CHF",
        save_33: "Save 33%",
        pro_feat_1_title: "Everything in PawLink Free",
        pro_feat_1_sub: "Keep every essential protection already included.",
        pro_feat_2_title: "Finder Location Sharing",
        pro_feat_2_sub: "Receive the finder’s location when they choose to share it.",
        pro_feat_3_title: "Instant Scan Alerts",
        pro_feat_3_sub: "Get an email the moment the QR code is scanned.",
        pro_feat_4_title: "Lost Mode",
        pro_feat_4_sub: "Turn the profile into an urgent recovery page in seconds.",
        pro_feat_5_title: "Community Rescue Map",
        pro_feat_5_sub: "Expand the search with help from nearby PawLink members.",
        pro_feat_6_title: "Nearby Community Alerts",
        pro_feat_6_sub: "Reach people close to the reported area when time matters.",
        pro_feat_7_title: "Complete Rescue Card",
        pro_feat_7_sub: "Give rescuers the medical and behavioral details they need.",
        pro_feat_8_title: "Vaccinations & Pet Passport",
        pro_feat_8_sub: "Keep important health and travel documents organized.",
        pro_feat_9_title: "Multiple Pet Profiles",
        pro_feat_9_sub: "Manage and protect all your pets from one account.",
        pro_feat_10_title: "Sightings & Rescue Activity",
        pro_feat_10_sub: "Follow available scan and sighting updates during the search.",
        cancel_anytime: "Cancel anytime",
        cta_choose_monthly: "Choose Monthly Protection",
        cta_choose_annual: "Choose Annual Protection",
        premium_active_line: "PawLink Protection is active.",
        annual_equivalent: "6.58 CHF / month, billed annually",
        checkout_awaiting_chf_configuration: "Checkout awaiting Paddle CHF configuration.",
        cta_protect_monthly: "Protect My Pet — Monthly",
        cta_protect_annual: "Protect My Pet — Annual",
        android_info_text: "PawLink Protection subscriptions are available through the official PawLink website.",
        android_already_subscribed: "I Already Subscribed",
        android_signin: "Sign In",
        android_refresh: "Refresh Subscription",
        android_refreshing: "Refreshing…",
        android_refresh_ok: "Subscription refreshed.",
        android_refresh_err: "Could not refresh right now. Please try again.",
        trust_line: "Clear pricing in CHF. No hidden fees. Cancel anytime. Finders never need to install an app.",
        free_price: "0.00 CHF",
        // Feature bullets — Free
        // Feature bullets — Protection
    },
    scan_upgrade: {
        default_pet: "your pet",
        title: "Someone found {pet} ❤️",
        subtitle: "This moment is why PawLink exists. Unlock full protection so the next hand that helps them home can reach you in seconds.",
        u1_title: "Instant scan alerts",
        u1_sub: "The moment your QR is scanned, your phone lights up.",
        u2_title: "Finder location",
        u2_sub: "See exactly where they were spotted, on a real map.",
        u3_title: "Two-way voice message",
        u3_sub: "Your voice calms them until you arrive.",
        u4_title: "Digital pet passport",
        u4_sub: "Vet records, vaccines and travel papers, always with you.",
        u5_title: "Unlimited pets",
        u5_sub: "Protect every companion under one plan.",
        reassure: "Because they are family — and family deserves a way home.",
        cta_primary: "Activate Protection",
        cta_later: "Maybe later",
        close: "Close",
    },
    trial_offer: {
        title: "Your pet is protected ❤️",
        subtitle: "Unlock complete PawLink Protection free for 7 days. Cancel anytime — no charge until day 8.",
        p1_title: "Instant scan alerts",
        p1_sub: "The moment your QR is scanned, your phone lights up.",
        p2_title: "Last seen location",
        p2_sub: "See exactly where they were spotted on a live map.",
        p3_title: "Voice messages",
        p3_sub: "Your voice calms them until you arrive.",
        p4_title: "Digital pet passport",
        p4_sub: "Vet records, vaccines and travel papers, always with you.",
        p5_title: "Family sharing",
        p5_sub: "Everyone at home gets alerts, not just one phone.",
        p6_title: "Advanced protection",
        p6_sub: "Multiple pets, reward badges, medical documents.",
        billing_note: "You'll pick Monthly or Yearly on the next screen. We only charge once your 7-day trial ends — no surprises.",
        cta_primary: "Protect my pet",
        cta_later: "Maybe later",
        close: "Close",
    },
    thankyou: {
        title: "Thank you for trusting PawLink ❤️🐾",
        body: "Your pet is fully protected. We're honored to help keep your best friend safe.",
        badge: "PawLink Protection Active",
        cta: "Continue",
        close: "Close",
    },
    downgrade: {
        default_pet: "your pet",
        title: "{pet}'s basic rescue profile is still active ❤️",
        sub: "Upgrade anytime to restore complete PawLink Protection.",
        cta: "Restore Protection",
        dismiss: "Not now",
    },
    protection: {
        active: "PawLink Protection is active",
        canceled_pending: "Protection stays active until your renewal date",
        trial_days: "PawLink Protection active — {days} day{s} left in your trial",
        trial_chip: "Free trial",
        plural_s: "s",
        sub: "Instant alerts, precise location, voice messages, digital passport.",
    },

    health: {
        kicker: "Health & Care",
        setup_kicker: "Get started",
        setup_h: "Build your pet's health record",
        setup_sub: "Choose how you'd like to start — you can always add more later. Only the pet's name and species are ever required.",
        setup_manual_h: "Add information manually",
        setup_manual_sub: "Fill short, friendly sections at your own pace.",
        setup_scan_h: "Scan an existing document",
        setup_scan_sub: "Snap a vaccination card, EU pet passport or vet report and we'll pre-fill the fields.",
        ai_badge: "AI",
        overview_h: "Overview",
        stat_vaccinations: "Vaccinations",
        stat_documents: "Documents",
        stat_reminders: "Reminders",
        last_updated: "Updated {at}",
        manual_h: "Health & identity details",
        sec_identification: "Identification",
        sec_health: "Health notes",
        sec_vet: "Veterinarian",
        sec_vaccinations: "Vaccinations & appointments",
        sec_reminders: "Reminders",
        sec_documents: "Documents",
        sec_timeline: "Timeline",
        f_birth_date: "Birth date",
        f_sex: "Sex",
        sex_unset: "Not set",
        sex_male: "Male",
        sex_female: "Female",
        sex_unknown: "Unknown",
        f_microchip: "Microchip number",
        f_microchip_ph: "e.g. 900123456789012",
        f_passport_id: "Passport number",
        f_passport_id_ph: "e.g. CH-EU-…",
        f_allergies: "Allergies",
        f_allergies_ph: "e.g. Peanuts, chicken",
        f_conditions: "Medical conditions",
        f_conditions_ph: "Comma-separated, e.g. Hip dysplasia, mild anxiety",
        f_medications: "Current medications",
        f_medications_ph: "Comma-separated, e.g. Apoquel 16mg daily",
        f_medical_notes: "Other notes for the vet",
        f_medical_notes_ph: "Anything a vet should know",
        f_vet_name: "Vet name",
        f_vet_phone: "Vet phone",
        f_vet_clinic: "Clinic",
        f_vacc_name: "Vaccination name",
        f_dose_date: "Dose date",
        f_next_due: "Next due",
        f_batch: "Batch number",
        f_note: "Notes",
        save: "Save",
        saving: "Saving…",
        cancel: "Cancel",
        discard: "Discard",
        save_error: "We couldn't save that. Please try again.",
        no_diagnosis_note: "PawLink stores your notes as-is. It does not give medical diagnosis or treatment advice.",
        vacc_add: "Add",
        vacc_empty: "No vaccinations recorded yet.",
        vacc_name_req: "Please add a vaccination name.",
        dose_short: "Given",
        next_short: "Next",
        confirm_remove_vacc: "Remove the vaccination \"{name}\"?",
        rem_empty: "No reminders for this pet yet.",
        rem_overdue: "Overdue",
        rem_due_soon: "Due soon",
        rem_completed: "Completed",
        rem_mark_done: "Mark done",
        doc_scan: "Scan",
        doc_upload: "Upload",
        doc_empty: "No documents yet. Scan a certificate to get started.",
        doc_untitled: "Document",
        uploading: "Uploading…",
        view: "View",
        scan_title: "Scan a document",
        scan_sub: "We'll extract the pet name, vaccine info, dates and clinic. You'll review everything before it's saved.",
        scan_camera: "Take a photo",
        scan_camera_sub: "Use your camera to capture the certificate.",
        scan_upload: "Upload a file",
        scan_upload_sub: "Image or PDF, up to 15MB.",
        scanning: "Extracting details…",
        scan_privacy: "The original document is stored securely with your pet's record. Extraction happens server-side.",
        extract_error: "AI extraction couldn't read that document. Please add the details manually.",
        review_title: "Review the extracted details",
        review_sub: "Nothing is saved yet. Fix any highlighted field, then tap Save.",
        review_save: "Save",
        please_verify: "Please verify",
        review_ai_note: "AI can make mistakes. Always double-check dates and identifiers.",

        // ── Vaccination → reminder suggestion (user-confirmed) ──
        rem_suggest_h: "Create a reminder?",
        rem_suggest_h_vaccination: "Create a reminder for the next dose?",
        rem_suggest_h_appointment: "Create a reminder for this appointment?",
        rem_suggest_sub: "We'll add it to your Reminders so you don't forget. Edit anything before confirming.",
        rem_suggest_open: "Create reminder",
        rem_suggest_existing: "Reminder already set for this vaccination",
        rem_dialog_title: "New reminder",
        rem_dialog_sub: "PawLink will notify you before the due date. Change anything below.",
        rem_field_title: "Title",
        rem_field_date: "Date",
        rem_field_time: "Time",
        rem_field_note: "Note (optional)",
        rem_field_notify: "Notify me",
        rem_offset_7d: "7 days before",
        rem_offset_1d: "1 day before",
        rem_offset_0d: "On the day",
        rem_confirm: "Confirm reminder",
        rem_confirming: "Confirming…",
        rem_never_auto: "Nothing is created automatically — you're always in charge.",

        // ── Vet appointments ──
        sec_appointments: "Vet appointments",
        apt_add: "Add appointment",
        apt_empty: "No appointments yet.",
        apt_f_date: "Date",
        apt_f_time: "Time",
        apt_f_clinic: "Clinic",
        apt_f_vet: "Veterinarian",
        apt_f_reason: "Reason",
        apt_f_reason_ph: "e.g. Annual check-up, dental cleaning",
        apt_f_notes: "Notes",
        apt_f_notes_ph: "Anything else worth remembering",
        apt_also_reminder: "Also create a reminder",
        apt_status_scheduled: "Scheduled",
        apt_status_completed: "Completed",
        apt_status_cancelled: "Cancelled",
        apt_mark_done: "Mark complete",
        apt_edit: "Edit",
        apt_delete: "Delete",
        apt_confirm_delete: "Delete this appointment?",
        apt_date_req: "Please pick an appointment date.",
        apt_reason_default: "Vet visit",
    },

    walks: {
        kicker: "Local Walks",
        h1: "See who's out nearby",
        tagline: "Turn an ordinary walk into a friendly PawLink moment.",
        cta_start: "We're Walking Now 🐾",
        start_title: "Start a Local Walk",
        pet: "Pet",
        duration: "Duration",
        min: "min",
        consent_text: "PawLink will show your pet in an approximate nearby area for the selected time. Your exact location and personal details will remain private.",
        cancel: "Cancel",
        confirm_start: "Start Walk",
        starting: "Starting…",
        end: "End Walk",
        remaining: "remaining",
        you_are_walking: "You're walking {name}",
        your_pet: "your pet",
        need_pet: "Add a pet first to start a walk.",
        nearby_kicker: "Nearby right now",
        nearby_loading: "Looking around…",
        nearby_none: "No PawLink friends walking nearby right now.",
        nearby_count: "{n} PawLink friends are walking nearby 🐾",
        upgrade_to_see_pins: "Upgrade to PawLink Protection to see nearby pet pins on the map.",
        friend: "PawLink friend",
        privacy_note: "Only approximate areas are shown. PawLink never reveals your name, phone, address, exact position, or walking route.",
        err_no_location: "Location permission is needed to start a walk or see nearby friends.",
        err_start: "Could not start the walk. Please try again.",
        left_short: "left",
        need_pet_h: "Add a pet before starting a walk",
        need_pet_sub: "Create a quick pet profile — name, photo and a phone number for the QR tag. Takes under a minute.",
        create_pet_cta: "Create pet profile",
        missing_pet: "pet",
        missing_duration: "duration",
        missing_consent: "consent",
        missing_location: "location",
        missing_location_hint: "We need your live location to fuzz the walk pin. Tap the Center-on-me button on the map first.",
    },
    care: {
        kicker: "PawLink Care",
        title: "Care Reminders",
        add: "Add",
        empty_no_pets: "Add a pet first to create a reminder.",
        pet: "Pet",
        type: "Type",
        title_label: "Title",
        title_placeholder: "e.g. Rabies booster",
        when: "When",
        note: "Note (optional)",
        notify_me: "Notify me",
        offset_7d: "7 days before",
        offset_1d: "1 day before",
        offset_0d: "Same day",
        save: "Save reminder",
        saving: "Saving…",
        cancel: "Cancel",
        err_save: "Could not save. Please try again.",
        tab_upcoming: "Upcoming",
        tab_overdue: "Overdue",
        tab_completed: "Completed",
        empty_upcoming: "Nothing coming up.",
        empty_overdue: "Nothing overdue.",
        empty_completed: "No completed reminders yet.",
        type_vaccination: "Vaccination",
        type_vet: "Vet Visit",
        type_medication: "Medication",
        type_grooming: "Grooming",
        type_other: "Other",
        mark_done: "Mark done",
        delete: "Delete",
    },
};

const ar = {
    magic: {
        loading_title: "جارٍ تسجيل الدخول…",
        loading_body: "نتحقّق من رابط الدخول الخاص بكِ.",
        ok_title: "أهلاً بكِ في PawLink!",
        ok_body: "تمّ تسجيل الدخول. جارٍ نقلكِ إلى لوحة التحكّم…",
        error_title: "رابط غير صالح",
        error_generic: "لم يعد رابط الدخول هذا صالحاً. اطلبي رابطاً جديداً من البريد أو سجّلي الدخول مجدداً.",
        missing_title: "رابط مفقود",
        missing_body: "لم نجد رابط دخول صالحاً في هذا العنوان. الرجاء استخدام الزر من البريد الإلكتروني الذي أرسلناه لكِ.",
        go_login: "تسجيل الدخول",
        get_help: "الحصول على مساعدة",
    },
    paddle_success: {
        headline: "تمّ استلام الدفعة!",
        body: "شكراً لاشتراككِ في PawLink Protection. جميع ميزات Premium فعّالة الآن.",
        check_inbox: "افحصي بريدكِ الإلكتروني — أرسلنا لكِ رابطاً سحرياً للدخول الفوري إلى حسابكِ.",
        no_email: "لا تجدينه؟ افحصي مجلد الإسبام أو",
        contact_support: "تواصلي معنا",
    },
    lang: { name: "العربية", dir: "rtl" },
    lost: {
        kicker: "مجتمع PawLink",
        title: "الحيوانات المفقودة",
        subtitle: "دعونا نساعدها على العودة إلى بيوتها",
        report_cta_h: "الإبلاغ عن حيوان مفقود",
        report_cta_sub: "ساعدنا في نشر الخبر",
        hero_h: "كل حيوان مفقود يستحق فرصة للعودة إلى بيته.",
        hero_sub: "استعرض الحيوانات المفقودة الآن، أو أبلغ عن حيوانك خلال ثوانٍ.",
        report_cta: "الإبلاغ عن حيوان مفقود",
        tab_lost: "مفقود",
        tab_reunited: "عاد إلى العائلة",
        reunited_h: "نهايات سعيدة",
        reunited_sub: "هذه الحيوانات عادت بأمان إلى بيوتها",
        search_ph: "ابحث بالاسم أو السلالة…",
        filter_kind: "النوع",
        filter_city_ph: "المدينة",
        filter_city_all: "كل المدن",
        near_me: "بالقرب",
        sort_recent: "الأحدث",
        sort_sightings: "الأكثر مشاهدات",
        kind_all: "كل الحيوانات",
        kind_dog: "كلاب",
        kind_cat: "قطط",
        kind_other: "أخرى",
        count_lost: "{n} حيوان مفقود حاليّاً",
        count_reunited: "{n} لَمّ شمل سعيد",
        the_pet: "هذا الحيوان",
        empty_lost_h: "لا حيوانات مفقودة الآن",
        empty_lost_sub: "خبر رائع. إذا احتاج حيوانك للمساعدة يوماً، يمكنك الإبلاغ خلال ثوانٍ.",
        empty_reunited_h: "كل لَمّ شمل يبدأ هنا",
        empty_reunited_sub: "ستظهر قصص الحيوانات التي عادت إلى عائلاتها هنا.",
        badge_lost: "مفقود",
        badge_reunited: "عاد إلى بيته",
        time_min: "قبل {n} د",
        time_hr: "قبل {n} س",
        time_day: "قبل {n} ي",
        reunited_after: "عاد بعد {hrs} س",
        reunited_after_hrs: "عاد بعد {n} ساعة",
        reunited_after_days: "عاد بعد {n} يوم",
        reunited_line: "عاد إلى عائلته",
        act_saw: "شاهدتُه",
        act_found: "وجدتُ هذا الحيوان",
        act_found_short: "وجدتُه",
        act_call: "اتّصل",
        act_call_owner: "اتّصل بالمالك",
        act_call_short: "اتّصل",
        act_wa: "واتساب",
        act_wa_short: "دردشة",
        act_share: "شارك",
        share_msg: "ساعد في إيجاد {name} — الرجاء المشاركة",
        detail_back: "رجوع",
        detail_lastseen_h: "آخر مشاهدة",
        detail_about_h: "عن {name}",
        detail_view_more: "عرض المزيد",
        detail_view_less: "عرض أقل",
        detail_open_map: "افتح على الخريطة",
        detail_since: "تاريخ الإبلاغ: {date}",
        detail_404_h: "عفواً — هذا الحيوان ليس ضمن قائمة المفقودين حالياً.",
        detail_reunited_line: "عاد بعد {hrs} ساعة",
        detail_sightings_h: "{n} مشاهدة",
        detail_sightings_h_short: "المشاهدات",
        sightings_empty: "لا مشاهدات بعد — قد تكون أول من يبلّغ.",
        sighting_generic: "شاهد أحدهم هذا الحيوان.",
        sighting_h: "شاهدتُ {name}",
        sighting_sub: "أضف كل ما لاحظته. كل تفصيل مهم.",
        sighting_message: "ماذا رأيت؟",
        sighting_message_ph: "مثلاً: يجري بالقرب من الحديقة، يرتدي طوقاً أزرق…",
        sighting_still_there: "لا يزال هنا الآن",
        sighting_still_there_h: "الحيوان لا يزال في هذا المكان الآن",
        sighting_name_opt: "اسمك (اختياري)",
        sighting_contact_opt: "طريقة التواصل (اختياري)",
        sighting_contact_ph: "هاتف أو بريد",
        sighting_gps_sharing: "جاري مشاركة موقعك…",
        sighting_gps_ok: "تم مشاركة الموقع",
        sighting_gps_off: "الموقع مغلق — يمكنك إرسال رسالة",
        sighting_send: "أرسل المشاهدة",
        sighting_sending: "جاري الإرسال…",
        sighting_sent_h: "تم إرسال المشاهدة — تم إخطار المالك",
        sighting_sent_sub: "شكراً لمساعدتك. لقد قرّبت عائلة من لَمّ شمل.",
        sighting_privacy: "بياناتك خاصة ولا تظهر إلا لمالك الحيوان.",
        sighting_error: "تعذّر الإرسال. حاول مجدداً.",
        how_h: "كيف يعمل الأمر",
        how_step1_h: "بلاغ",
        how_step1_sub: "أبلغ عن حيوانك المفقود",
        how_step2_h: "مشاركة",
        how_step2_sub: "ننشر الخبر",
        how_step3_h: "مشاهدة",
        how_step3_sub: "الناس يبحثون معك",
        how_step4_h: "لَمّ شمل",
        how_step4_sub: "أعده إلى البيت",
        together_h: "معاً نصنع فرقاً",
        together_sub: "كل مشاركة تُقرّب عائلة من لَمّ شملها",
        stats_reunited_month: "عاد إلى بيته هذا الشهر",
        stats_reunited_total: "إجمالي الحيوانات التي عادت",
        stats_guardians: "الحرّاس النشطون",
        reported_time: "أُبلغ {time}",
        reunited_time: "عاد {time}",
    },
    nav: { home: "الرئيسية", pricing: "الأسعار", dashboard: "لوحتي", login: "تسجيل الدخول", register: "ابدأ الآن", create_account: "إنشاء حساب", signout: "تسجيل الخروج", plan_free: "مجاني", plan_premium: "بريميوم", plan_trial: "تجربة", menu: "القائمة", back: "رجوع", my_pets: "حيواناتي", my_qr: "رموز QR", scan_history: "سجل المسح", notifications: "الإشعارات", account: "الحساب", subscription: "الاشتراك", protection: "حماية PawLink", safety: "حماية PawLink", rescue_center: "مركز الإنقاذ", community: "مجتمع PawLink",
        local_walks: "مشاوير قريبة", lost_pets: "الحيوانات المفقودة", help: "المساعدة", faq: "الأسئلة الشائعة", support: "الدعم", how_it_works: "كيف يعمل", view_all: "عرض كل الإشعارات", open_scan: "فتح المسح", view_map: "عرض على الخريطة", no_pets_yet: "لا حيوانات بعد — أضف أوّل حيوان لك", dash_pets: "الحيوانات", dash_status: "الحالة", dash_status_safe: "كل الحيوانات بأمان", dash_status_lost: "{n} حيوان مفقود", bn_home: "الرئيسية", bn_pets: "حيواناتي", bn_lost: "المفقودة", bn_community: "المجتمع", bn_safety: "الحماية", bn_account: "الحساب" },
    brand: { tagline: "حيوانك الأليف. دائماً يجد طريق العودة." },
    common: { save: "حفظ", cancel: "إلغاء", delete: "حذف", edit: "تعديل", back: "رجوع", next: "التالي", loading: "جارٍ التحميل…", saving: "جارٍ الحفظ…", remove: "إزالة", upload: "رفع", record: "تسجيل", stop: "إيقاف", close: "إغلاق" },
    landing: {
        chip: "بطاقة QR ذكية لحيوانك",
        h1a: "إذا ضاع حيوانك،",
        h1b: "ساعده على إيجاد طريقه إلى البيت ❤️",
        sub: "PawLink يمنح صديقك المفضل هوية QR ذكية. إذا ضاع، أي شخص طيب يستطيع مسح الرمز والتواصل معك خلال ثوانٍ — بدون تطبيق.",
        cta_primary: "أنشئ ملف حيوانك",
        cta_secondary: "شاهد كيف يعمل",
        badge_privacy: "الخصوصية أولاً",
        badge_dynamic: "QR ديناميكي",
        badge_love: "صُنع بحب",
        story_scan: "شخص ما مسح لوحة ميلو",
        story_when: "الآن · شارع 5 و ماين",
        story_reunited: "ميلو في طريقه للبيت 🐾",
        protect_h: "احمِ صديقك المفضل اليوم 🐾",
        protect_price: "9.90 CHF شهرياً  ·  79.00 CHF سنوياً",
        protect_line: "راحة بال — لأن فقدانهم ليس خياراً.",
        protect_cta: "فعّل PawLink Protection",
        how_over: "كيف يعمل",
        how_h2: "ثلاث خطوات بين الضياع والعودة للبيت.",
        step1_t: "🐶 أنشئ الملف",
        step1_d: "صورة، اسم، ملاحظات صحية، ورسالة من القلب.",
        step2_t: "📱 اطبع رمز QR الذكي",
        step2_d: "اطبع الرمز على بطاقة أو طوق أو ملصق. حدّثه في أي وقت.",
        step3_t: "❤️ العودة والاجتماع",
        step3_d: "شخص يمسح الرمز، يصلك إشعار مع الموقع — صوت، اتصال، تم.",
        why_over: "راحة البال، من التصميم",
        why_h2: "كل ما يحتاجونه للعودة إلى البيت.",
        why_sub: "كل ثانية تُحسب حين يضيع حيوانك. PawLink هو خطتك الهادئة.",
        f1_t: "🔔 تنبيهات فورية للمسح",
        f1_d: "اعرف اللحظة التي يمسح فيها شخص رمز حيوانك.",
        f2_t: "📍 آخر موقع",
        f2_d: "GPS أو مدينة — مباشرة على لوحتك.",
        f3_t: "🎙 رسائل صوتية مع من يجده",
        f3_d: "صوتك يهدّئ حيوانك. صوت من يجده يصلك بسرعة.",
        f4_t: "📞 اتصال وواتساب بلمسة واحدة",
        f4_d: "يصل إليك من يجد حيوانك بلمسة واحدة.",
        f5_t: "🔒 تحكم كامل بالخصوصية",
        f5_d: "أنت من يقرر بالضبط ما يراه الغريب.",
        cta_h2: "هم لا يستطيعون الاتصال بك. لكن الغريب يستطيع.",
        cta_sub: "امنح حيوانك شبكة الأمان التي يستحقها — في أقل من دقيقتين.",
        cta_btn: "ابدأ مجاناً",
        cta_compare: "شاهد الأسعار",
    },
    auth: {
        welcome: "أهلاً بعودتك",
        sign_sub: "سجّل الدخول لإدارة ملفات حيواناتك.",
        create: "أنشئ حسابك",
        create_sub: "ابدأ حماية حيوانك في أقل من دقيقتين.",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        password_hint: "6 أحرف على الأقل",
        name: "اسمك",
        signin: "تسجيل الدخول",
        signing: "جارٍ الدخول…",
        creating: "جارٍ الإنشاء…",
        create_btn: "إنشاء حساب",
        no_account: "ليس لديك حساب؟",
        have_account: "لديك حساب؟",
        create_one: "أنشئ واحداً",
        trouble_signing_in: "تواجه مشكلة في تسجيل الدخول؟ راسلنا على",
        sign_in: "تسجيل الدخول",
        or_continue: "أو تابع بالبريد الإلكتروني",
        google_signin: "تسجيل الدخول بجوجل",
        google_signup: "إنشاء حساب بجوجل",
        welcome_h: "أهلاً بك في PawLink",
        welcome_sub: "احمِ حيوانك في ثوانٍ.",
        welcome_hi: "مرحباً بك! 👋",
        welcome_footer: "بمتابعتك فأنت توافق على الشروط وسياسة الخصوصية.",
        forgot_password: "نسيتها؟",
        forgot_title: "إعادة تعيين كلمة المرور",
        forgot_sub: "أدخل بريدك — سنُرسل رابطاً آمناً لتحديد كلمة مرور جديدة.",
        forgot_submit: "أرسل رابط إعادة التعيين",
        forgot_sending: "جارٍ الإرسال…",
        forgot_sent_title: "تحقّق من بريدك",
        forgot_sent_sub: "إذا كان الحساب موجوداً، أرسلنا رابط إعادة تعيين كلمة المرور. صالح لمدّة ساعة.",
        forgot_back_login: "العودة لتسجيل الدخول",
        reset_title: "حدّد كلمة مرور جديدة",
        reset_sub: "اختر كلمة مرور قويّة لا تقلّ عن 6 أحرف. سيتمّ تسجيل دخولك تلقائياً.",
        reset_new: "كلمة المرور الجديدة",
        reset_confirm: "تأكيد كلمة المرور",
        reset_submit: "إعادة التعيين",
        reset_saving: "جارٍ الحفظ…",
        reset_success: "تمّ التحديث. جارٍ إعادة التوجيه…",
        reset_mismatch: "كلمتا المرور غير متطابقتين.",
        reset_invalid_link: "هذا الرابط غير صالح أو منتهي الصلاحية. اطلب رابطاً جديداً.",
        reset_no_token: "لا يوجد رمز في الرابط. افتح الرابط من بريدك مجدداً.",
    },
    dash: {
        welcome: "أهلاً بعودتك",
        sub: "أدر هويات حيواناتك الرقمية وشارك رموزها.",
        add_pet: "إضافة حيوان",
        upgrade: "الترقية إلى بريميوم",
        empty_h: "لا حيوانات بعد",
        empty_sub: "لننشئ الهوية الرقمية لحيوانك. الأمر يستغرق دقيقة — وقد ينقذ حياته.",
        empty_cta: "أنشئ أول حيوان",
        pet_qr_h: " — رمز QR",
        scan_share: "امسح أو شارك هذا الرابط:",
        select_pet: "اختر حيواناً لعرض رمز QR الخاص به.",
        loading: "جارٍ تحميل حيواناتك…",
        upgrade_download: "قم بالترقية إلى بريميوم لتحميل رمز QR (PNG/PDF)، وفتح تنبيهات المسح الفورية والمزيد.",
        upgrade_inline: "ترقية",
        no_phone: "لا رقم محدد",
        finder_url: "رابط العثور:",
        recent_scans: "آخر عمليات المسح",
        no_scans: "لا مسح بعد. اطبع الرمز وشاركه لتبدأ.",
        scan_gps: "GPS",
        scan_ip: "موقع IP",
        notifications: "الإشعارات",
        no_notifications: "لا شيء جديد. كل شيء بخير.",
        mark_all_read: "تعليم الكل مقروءاً",
        notif_scan: "شخص ما مسح رمز {pet}",
        notif_found: "{finder} وجد {pet}",
        just_now: "الآن",
        min_ago: "قبل {n} د",
        hr_ago: "قبل {n} س",
        day_ago: "قبل {n} يوم",
    },
    petform: {
        new_over: "حيوان جديد", edit_over: "تعديل حيوان",
        new_h: "إنشاء ملف حيوان",
        edit_h: "تحديث {name}",
        photo_h: "الصورة",
        photo_sub: "صورة واضحة تساعد من يجد حيوانك على التعرف عليه فوراً.",
        upload_photo: "رفع صورة",
        about_h: "عن حيوانك",
        pet_name: "اسم الحيوان *",
        type: "النوع *",
        type_dog: "كلب", type_cat: "قطة", type_other: "آخر",
        finder_message: "رسالة لمن يجده",
        contact_h: "التواصل",
        contact_sub: "الهاتف مطلوب. الباقي اختياري — أنت من يقرر ماذا يرى من يجده.",
        owner_name: "اسمك",
        phone: "رقم الهاتف *",
        whatsapp: "واتساب (اختياري)",
        city: "المدينة",
        address: "العنوان الكامل (اختياري)",
        health_h: "الصحة والعناية",
        allergies: "الحساسية / الأطعمة الممنوعة",
        allergies_ph: "لديه حساسية من الدجاج. ممنوع الشوكولاتة.",
        medical: "ملاحظات طبية",
        medical_ph: "يأخذ دواءً للتشنجات. قلق من الأصوات العالية.",
        voice_h: "رسالة صوتية ومكافأة",
        voice_sub: "سجّل صوتاً مطمئناً لحيوانك، ويمكنك تحديد مكافأة اختيارية.",
        voice_label: "رسالة صوتية",
        reward: "مكافأة (اختياري)",
        reward_ph: "٥٠٠ ريال مكافأة لمن يعيده بأمان",
        privacy_h: "إعدادات الخصوصية",
        privacy_sub: "اختر بالضبط ما يراه من يمسح رمز QR.",
        p_phone: "إظهار رقم هاتفي",
        p_name: "إظهار اسمي",
        p_city_only: "إظهار المدينة فقط (موصى به)",
        p_address: "إظهار العنوان الكامل (متقدم)",
        p_allergies: "إظهار الحساسية / الأطعمة الممنوعة",
        p_medical: "إظهار الملاحظات الطبية",
        p_reward: "إظهار المكافأة",
        submit_create: "إنشاء الحيوان",
        submit_edit: "حفظ التعديلات",
        default_msg: "إن وجدتَني، رجاءً اتصل بصاحبي. شكراً لطيبتك!",
        back_to_dash: "العودة إلى اللوحة",
        step_of: "الخطوة {n} من {total}",
        continue: "متابعة",
        back: "رجوع",
        protect_btn: "احمِ {name} 🐾",
        protect_generic: "احمِ حيواني 🐾",
        s1_h: "تعرّف على أعزّ أصدقائك",
        s1_emoji: "🐾",
        s1_sub: "لنُنشئ ملفاً جميلاً لأحد أفراد العائلة الذي لا يستطيع التحدث عن نفسه.",
        s1_photo_label: "اضغط لإضافة صورة",
        s1_photo_hint: "صورة واضحة تساعد من يجده على التعرف عليه في ثوانٍ.",
        s1_change_photo: "تغيير الصورة",
        s1_name_ph: "مثال: ميلو",
        s1_breed_label: "السلالة (اختياري)",
        s1_breed_ph: "مثال: غولدن ريتريفر",
        s1_gender_label: "الجنس (اختياري)",
        gender_male: "ذكر",
        gender_female: "أنثى",
        gender_unknown: "أفضّل عدم القول",
        s2_h: "ساعده على العودة إلى البيت",
        s2_emoji: "❤️",
        s2_sub: "إذا وجده أحد، هكذا سيعيده إليك.",
        s2_privacy_note: "العنوان الكامل مخفي عن الغرباء افتراضياً. يمكنك تغيير ذلك لاحقاً.",
        s3_h: "أشياء يجب أن يعرفها المنقذ",
        s3_emoji: "🩺",
        s3_sub: "تفاصيل قد تنقذ حياة حيوانك في يد شخص غريب.",
        s3_notes_label: "ملاحظات خاصة (اختياري)",
        s3_notes_ph: "مثال: يخاف بسرعة · يحب مداعبة البطن · لا تطعمه دجاجاً",
        s4_h: "رسالة من القلب",
        s4_emoji: "🎤",
        s4_sub: "سجّل رسالة صوتية سيسمعها من يجده لحظة المسح.",
        s4_example: "«مرحباً، أنا والد ميلو. شكراً لعثوركم عليه. اتصل بي من فضلك ❤️»",
        s4_written_label: "أو اكتب رسالة قصيرة",
        s4_reward_label: "مكافأة (اختياري)",
        s4_reward_hint: "اختياري. شكر صغير يحفّز من يجده.",
        s5_h: "التحكم بالخصوصية",
        s5_emoji: "🔒",
        s5_sub: "اختر ما يراه الغرباء عند مسح رمز {name}.",
        s5_sub_generic: "اختر ما يراه الغرباء عند مسح رمز QR.",
        success_h: "{name} محمي الآن",
        success_h_generic: "حيوانك محمي الآن",
        success_sub: "رمز QR الذكي جاهز. اطبعه وضعه على طوقه — أنت الآن شبكة أمانه.",
        success_card_over: "جواز سفر رقمي لحيوانك",
        success_card_id: "PawLink ID",
        success_view_profile: "عرض الملف العام",
        success_go_dashboard: "الذهاب إلى اللوحة",
        edit_saved: "تم حفظ التعديلات ❤️",
    },
    finder: {
        im_lost: "أنا تائه، أرجوك ساعدني بالعودة للبيت",
        call: "اتصل بالمالك",
        whatsapp: "واتساب",
        text: "رسالة نصية",
        whatsapp_optional: "تفضل واتساب؟ راسل عبر واتساب",
        owner: "المالك:",
        message_h: "رسالة من صاحبي",
        voice_h: "رسالة صوتية",
        voice_sub: "قد يهدأني سماع صوت صاحبي.",
        voice_unsupported: "متصفحك لا يدعم تشغيل الصوت.",
        voice_open_new: "افتح الصوت في تبويب جديد",
        default_plea: "مرحباً! أنا {name}. إذا وجدتني، من فضلك تواصل مع عائلتي لأعود إلى بيتي بأمان. شكراً لك! ❤️",
        allergies_h: "الحساسية والأطعمة الممنوعة",
        medical_h: "ملاحظات طبية",
        location_h: "أين أعيش",
        reward_h: "المكافأة",
        personality_h: "كيف تتعامل مع {name}",
        passport_h: "جواز {name} الرقمي",
        passport_sub: "شاركها المالك في حال احتاج الطبيب أو أي جهة إليها.",
        passport_view: "عرض",
        lost: {
            badge: "مفقود · أرجوك ساعد",
            pawlink_verified: "موثّق من PawLink",
            headline_kicker: "أرجوك ساعدني أعود للبيت",
            headline: "أنا {name} — عائلتي تبحث عني.",
            missing_for: "مفقود منذ {time}",
            call_cta: "اتصل بعائلتي",
            sms_cta: "أرسل رسالة لعائلتي",
            whatsapp_cta: "راسل عبر واتساب",
            plea_h: "احمِني — أنا خائف",
            plea_default: "أرجوك احمني حتى تصل عائلتي. اتصل بالرقم أعلاه وسأعود قريباً للبيت. شكراً لك أيها الغريب الطيب. ❤️",
            reward_h: "مكافأة عند العودة",
            lastseen_h: "آخر مكان شوهدت فيه",
            view_on_map: "شاهد على الخريطة",
            medical_h: "مهم — لديّ احتياجات طبية",
        },
        found_h: "هل وجدت {name} للتو؟",
        found_sub: "اضغط الزر أدناه وسنبلّغ المالك فوراً.",
        found_btn: "لقد وجدت هذا الحيوان",
        thanks_h: "شكراً — أنت بطل.",
        thanks_sub: "أبلغنا {owner}. رجاءً ابقَ قريباً من الحيوان إن أمكن.",
        owner_generic: "المالك",
        powered: "مدعوم من",
        tagline: "نُعيد الحيوانات التائهة إلى بيوتها",
        tech_help: "مشكلة تقنية في هذه الصفحة؟ تواصل مع دعم PawLink على",
        modal_h: "أخبر المالك بمكانك",
        modal_sub: "بياناتك تساعد المالك على الوصول إليك بسرعة.",
        f_name: "اسمك (اختياري)",
        f_phone: "هاتفك (اختياري)",
        f_location: "أين أنت؟",
        f_location_ph: "عند تقاطع شارع كذا",
        f_message: "رسالة (اختياري)",
        f_voice: "رد صوتي (اختياري)",
        share_location: "شارك موقعي",
        location_sharing: "جارٍ المشاركة…",
        location_shared: "تمت مشاركة الموقع",
        submit: "إبلاغ المالك",
        sending: "جارٍ الإرسال…",
        cancel: "إلغاء",
        not_found_h: "الملف غير موجود",
        not_found_sub: "قد يكون المالك أزال هذا الرمز.",
        go_home: "العودة للرئيسية",
        voice_shortcut_h: "لا تستطيع الكتابة؟ أرسل رسالة صوتيّة 🎙️",
        voice_shortcut_sub: "ردٌّ صوتيّ بلمسة واحدة — يسمعه صاحب {name} خلال ثوانٍ.",
        voice_shortcut_send: "إرسال الصوت إلى المالك",
        voice_shortcut_sending: "جارٍ الإرسال…",
        voice_shortcut_sent_h: "تمّ إرسال الرسالة الصوتيّة ❤️",
        voice_shortcut_sent_sub: "وصل الآن إشعارٌ إلى صاحب {name} بصوتك.",
        voice_shortcut_default_msg: "رسالة صوتيّة من شخصٍ وجد الحيوان.",
        voice_shortcut_error: "تعذّر الإرسال. حاول مرّة أخرى.",
        sighting_h: "شاهدتُ هذا الحيوان 👀",
        sighting_sub: "تنبيه رؤية بلمسة واحدة. يستلم صاحب {name} موقعك بالضبط ويمكنه التوجّه فوراً.",
        sighting_send: "شاهدتُه — أرسل موقعي",
        sighting_locating: "جارٍ تحديد موقعك…",
        sighting_privacy: "🔒 يُشارَك موقعك مرّة واحدة، مع صاحب هذا الحيوان فقط.",
        sighting_default_msg: "شاهدتُ {name} قريباً للتوّ.",
        sighting_sent_h: "أُرسلت الرؤية 📍",
        sighting_sent_sub: "صاحب {name} في طريقه. شكراً لمساعدتك!",
        sighting_error: "تعذّر الإرسال. حاول مرّة أخرى.",
    },
    community: {
        title: "مجتمع PawLink",
        sub: "خريطة واحدة للحيوانات المفقودة، والمشاوير القريبة، ومجتمع PawLink من حولك.",
        privacy_h: "حضورك على الخريطة",
        privacy_sub: "أنت تختار ما يراه الآخرون. عنوان بيتك لا يُخزَّن أبداً — فقط دبّوس مُضبّب بجانب حيّك.",
        vis_invisible: "مخفيّ",
        vis_invisible_sub: "لا تظهر على أيّ خريطة.",
        vis_approximate: "تقريبيّ",
        vis_approximate_sub: "دبّوس ناعم قرب حيّك — ليس عنوانك أبداً.",
        vis_helper: "مساعد PawLink 🐾",
        vis_helper_sub: "اظهر كمساعد ليعرف الجيران أنّهم يستطيعون الاعتماد عليك.",
        location_needed_h: "أضف حيّك إلى الخريطة",
        location_needed_sub: "لمسةٌ واحدة. نحن نقرّب موقعك إلى نحو كيلومتر — ولا نخزّن أيّ عنوان.",
        share_approx_location: "أضف منطقتي التقريبيّة",
        locating: "جارٍ تحديد منطقتك…",
        location_error: "تعذّر حفظ منطقتك. حاول مرّة أخرى.",
        location_denied: "رُفض إذن الموقع.",
        geo_unsupported: "متصفّحك لا يدعم الموقع.",
        visibility_error: "تعذّر تحديث الظهور.",
        your_area: "منطقتك: {area}",
        helpers_near: "{count} من مساعدي PawLink قرب {area}",
        helpers_generic: "{count} من مساعدي PawLink قريبون",
        helpers_sub: "مجهولون. جاهزون للمساعدة إن فُقد حيوانٌ قرب منطقتك.",
        protectors_near: "{count} من حماة PawLink قربك 🐾",
        protectors_generic: "{count} من حماة PawLink قربك 🐾",
        protectors_sub: "عائلة هادئة من أهل الحيوانات يحمون بعضهم — مجهولون على الخريطة، وحقيقيّون حين يتطلّب الأمر.",
        stat_helpers: "المساعدون",
        stat_lost: "المفقودون",
        stat_found: "عادوا للبيت",
        filter_all: "الكلّ",
        filter_lost: "المفقودون",
        filter_walking_now: "يتمشّى الآن",
        walks_legend: "العلامات الدافئة = حيوانات تتمشى الآن. تبقى علامات المفقودين والإنقاذ ظاهرة.",
        filter_helpers: "مجتمع PawLink القريب",
        filter_found: "عادوا للبيت",
        refresh: "تحديث",
        legend_helper: "مساعد",
        legend_lost: "حيوان مفقود",
        legend_found: "عاد للبيت",
        legend_walking: "يتمشّى الآن",
        you_are_here: "أنت",
        find_my_location: "حدّد موقعي",
        center_on_me: "مركّز عليّ",
        distance_h: "المسافة",
        map_visibility_h: "الظهور على الخريطة",
        map_visibility_hidden: "مخفي",
        map_visibility_approximate: "تقريبي",
        map_visibility_live_approx: "مباشر تقريبي",
        map_visibility_change: "تغيير",
        km_unit: "كم",
        pin_helper: "مساعد PawLink",
        pin_helper_anon: "حارس مجهول الهوية",
        pin_member: "عضو PawLink",
        avail_available: "متاح",
        avail_busy: "مشغول",
        avail_offline: "غير متصل",
        availability_h: "توفري",
        rescue_count: "{n} عملية إنقاذ",
        radius_h: "نطاق",
        receive_alerts_h: "استقبال تنبيهات الحيوانات المفقودة",
        receive_alerts_sub: "احصل على إشعار عند حاجة حيوان قريب للمساعدة. لن تتم مشاركة أي من بياناتك.",
        delete_location_cta: "احذف موقعي المخزّن",
        delete_location_confirm: "هل تريد مسح موقعك في المجتمع؟ ستصبح غير مرئي على الخريطة.",
        lost_pet: "حيوان مفقود",
        recently_found: "عاد للبيت مؤخّراً",
        last_seen: "آخر ظهور",
        distance_km: "{km} كم بعيد",
        view_pet: "عرض الملف",
        lost_nearby_h: "{count} من الحيوانات المفقودة قربك",
        found_nearby_h: "{count} عادوا مؤخّراً",
        location_unknown: "الموقع غير معروف",
        popup_isaw: "شاهدتُ هذا الحيوان",
        popup_ifound: "أنا وجدتُ هذا الحيوان",
        popup_sighting_sending: "جارٍ إرسال موقعك…",
        popup_sighting_sent: "أُرسلت الرؤية ❤️ تمّ إخطار المالك.",
        guardians_city: "{count} من حماة PawLink يحمون الحيوانات في {city} 🐾",
        guardians_sub: "حيوانك لديه آلاف الأعين تساعده على العودة إلى البيت.",
        sheet_missing: "مفقود",
        sheet_found_safe: "عاد بأمان",
        sheet_reward: "مكافأة عند العثور",
        sheet_contact_owner: "الاتصال بالمالك",
        sheet_privacy: "المواقع تُشارَك فقط عندما يقرّر أحدهم المساعدة.",
        sheet_reunion_h: "عاد إلى البيت بأمان",
        sheet_reunion_sub: "لمّت عائلة {name} شمله مؤخّراً بفضل مجتمع PawLink. 🐾",
        live: "مباشر",
        live_rescue_network: "شبكة إنقاذ مباشرة",
        avatars_caption: "حماة قريبون — مجهولون افتراضياً 🐾",
        helper_ready_h: "مساعد PawLink — جاهزٌ للمساعدة",
        helper_ready_sub: "مجهولٌ افتراضياً. إن فُقد حيوانٌ قريب، يمكن لهذا الجار أن يساعدك في العثور عليه.",
        ticker_area_generic: "منطقتك",
        ticker_joined: "🐾 انضم/ت {name} إلى مجتمع PawLink للتو",
        ticker_reunited: "❤️ عاد {name} إلى بيته بسلام",
        ticker_someone_helping: "🔍 أحدهم يساعد في البحث عن حيوان مفقود قريب",
        ticker_helper_joined_area: "📍 انضم مساعد PawLink جديد في {area}",
        ticker_helpers_watching: "🛡️ {count} من الحماة يسهرون على {area}",
        ticker_helping_lost: "🐾 الجيران يساعدون في البحث عن حيوان مفقود قريب",
        ticker_guardian_active: "✨ أصبح/ت {name} حارساً في PawLink",
        rescue_alert_h: "🚨 {count} حيوان بحاجة إلى المساعدة قريباً",
        rescue_alert_sub: "اضغط على الخريطة، شارك مشاهدة، أو اتصل بالمالك. كل ثانية تهم.",
        rescue_help_now: "ساعِد الآن",
        locate_me: "توسيط على موقعي",
        empty_first_guardian_h: "كن أول حارس PawLink في منطقتك 🐾",
        empty_first_guardian_sub: "لم يتم الإبلاغ بعد عن أي حيوان مفقود أو مساعد أو لمّ شمل قربك. فعّل وضع المساعد لتكون أول عين تحمي الحيوانات في حيّك.",
        empty_needs_location_h: "خريطة الإنقاذ في انتظارك",
        empty_needs_location_sub: "أضف منطقتك التقريبية لترى أعضاء PawLink الحقيقيين وتنبيهات الحيوانات المفقودة ولحظات لمّ الشمل قربك. لا يتم تخزين عنوانك الدقيق أبداً.",
        empty_share_cta: "أضف منطقتي التقريبية",
        empty_become_helper: "كن مساعد PawLink",
    },
    pricing: {
        eyebrow: "الأسعار",
        h1: "بسيط وعادل.",
        sub: "اكتشف PawLink مجاناً. عندما تكون مستعداً لحماية صديقك المفضل، فعّل PawLink Protection.",
        free_title: "مجاني",
        free_price: "$0",
        free_period: "",
        free_desc: "اكتشف PawLink وأنشئ أول هوية رقمية لك.",
        premium_title: "PAWLINK PROTECTION 🐾",
        premium_desc: "لأن فقدانهم ليس خياراً ❤️",
        premium_line: "نظام حماية ذكي يساعد على إعادة صديقك المفضل إلى البيت بأمان.",
        billing_monthly: "شهري",
        billing_yearly: "سنوي",
        price_monthly: "9.90 CHF",
        per_month: "/ شهرياً",
        price_yearly: "79.00 CHF",
        per_year: "/ سنوياً",
        save_badge: "الأفضل قيمة · $1.67/شهر",
        recommended: "⭐ الأفضل قيمة",
        free_list: [
            "إنشاء ملف واحد",
            "إضافة صورة وبيانات أساسية",
            "معاينة الهوية الذكية",
            "شاهد كيف تعمل الحماية",
        ],
        free_footer: "تفعيل رمز QR وأدوات الأمان المميزة تتطلب PawLink Protection.",
        premium_benefits: [
            { emoji: "🚨", title: "وضع الإنقاذ عند الفقدان", sub: "تنبيهات فورية وموقع المسح عندما يعثر أحد على صديقك." },
            { emoji: "📍", title: "هوية QR ذكية", sub: "أي شخص يستطيع المسح والاتصال بك فوراً — دون تطبيق." },
            { emoji: "✈️", title: "الجواز الرقمي", sub: "التطعيمات وسجلات الطبيب ووثائق السفر دائماً جاهزة." },
            { emoji: "❤️", title: "الملف الصحي والأمان في حالات الطوارئ", sub: "الحساسيات، الاحتياجات الطبية وتفاصيل الشخصية في مكان واحد." },
            { emoji: "👨‍👩‍👧", title: "جهات اتصال العائلة الموثوقة", sub: "أحباؤك يمكنهم المساعدة في إعادته إلى البيت بأمان." },
            { emoji: "🐾", title: "حماية متعددة الحيوانات", sub: "احمِ كل كلب أو قطة تحبها من حساب واحد." },
        ],
        one_scan: "مسحة واحدة قد تعيدهم للبيت 🐾",
        your_plan: "خطتك",
        upgrade: "فعّل PawLink Protection",
        get_free: "ابدأ مجاناً",
        go_dash: "اذهب إلى اللوحة",
        redirecting: "جارٍ التوجيه…",
        on_premium: "أنت محمي",
        secure: "دفع آمن عبر Paddle. ألغِ في أي وقت.",
    },
    payment: {
        checking_h: "جارٍ تأكيد الدفع…",
        checking_sub: "دقيقة فقط.",
        paid_h: "أهلاً بك في بريميوم!",
        paid_sub: "لقد فتحتَ تحميل QR (PNG و PDF)، والتنبيهات الفورية، وآخر موقع للمسح، والردود الصوتية من من يجد حيوانك.",
        go_dash: "اذهب إلى اللوحة",
        expired_h: "انتهت الجلسة",
        expired_sub: "انتهت جلسة الدفع. أعد المحاولة.",
        back_pricing: "العودة للأسعار",
        pending_h: "لا زلنا نعالج…",
        pending_sub: "الأمر يستغرق أكثر من المعتاد. سيظهر اشتراكك في اللوحة عند اكتماله.",
        continue: "متابعة",
        error_h: "حدث خطأ",
        error_sub: "لم نتمكن من التحقق من الدفع. تواصل مع الدعم إن تم خصم المبلغ.",
    },
    langpicker: {
        title: "اختر لغتك",
        sub: "يمكنك تغييرها لاحقاً من الأعلى.",
        continue: "متابعة",
    },
    theme: { light: "فاتح", dark: "داكن", system: "افتراضي النظام" },
    account: {
        eyebrow: "حسابك",
        title_greeting: "مرحباً، {name}",
        header_edit: "تعديل الملف",
        section_profile: "المعلومات الشخصيّة",
        section_prefs: "تفضيلات التطبيق",
        section_privacy: "الخصوصيّة والأمان",
        community_vis_h: "ظهور خريطة المجتمع",
        community_vis_sub: "يتحكم في ظهورك ضمن مجتمع PawLink القريب على الخريطة المشتركة. لا تتم مشاركة الموقع الدقيق ولا بيانات الاتصال أبدًا.",
        community_vis_hidden: "مخفي",
        community_vis_approximate: "مرئي تقريبيًا",
        section_help: "المساعدة والدعم",
        section_legal: "الشؤون القانونيّة",
        section_help_legal: "المساعدة والشؤون القانونيّة",
        f_name: "الاسم الكامل",
        f_name_ph: "اسمك",
        f_name_hint_google: "مستورد من حساب Google الخاصّ بك.",
        f_email: "البريد الإلكترونيّ",
        f_email_hint: "تواصل مع الدعم لتغيير بريدك.",
        f_phone: "رقم الهاتف",
        f_phone_ph: "اختياريّ — يُستخدم لتنبيهات المسح",
        f_country: "البلد",
        f_country_ph: "المملكة العربيّة السعوديّة",
        save: "حفظ التعديلات",
        saving: "جارٍ الحفظ…",
        saved: "تمّ الحفظ",
        pref_language: "اللغة",
        pref_appearance: "المظهر",
        pref_appearance_hint: "طابق نظامك أو اختر مزاجك.",
        pref_notifications: "الإشعارات داخل التطبيق",
        pref_notifications_hint: "استلم تنبيهات المسح داخل PawLink.",
        priv_public_h: "الملف العامّ للحيوان",
        priv_public_sub: "عندما يمسح شخصٌ ما رمز QR، يرى فقط صورة حيوانك واسمه وطريقة التواصل التي تختارها. عنوان بيتك لا يُشارَك أبداً.",
        priv_public_manage: "إدارة الظهور لكلّ حيوان من صفحة \"حيواناتي\".",
        priv_password_h: "تغيير كلمة السر",
        priv_password_google: "تسجيلك عبر Google، فلا كلمة سرّ لتغييرها هنا.",
        priv_password_current: "كلمة السر الحاليّة",
        priv_password_new: "كلمة السر الجديدة (٨ أحرف على الأقلّ)",
        priv_password_save: "تحديث كلمة السر",
        priv_password_ok: "تمّ تحديث كلمة السر.",
        priv_delete_h: "حذف الحساب",
        priv_delete_sub: "احذف حسابك وحيواناتك وسجلّ المسح والرسائل نهائيّاً. لا يمكن التراجع.",
        priv_delete_help: "تحتاج مساعدة في حذف الحساب؟ راسلنا على",
        priv_delete_btn: "احذف حسابي",
        priv_delete_confirm_h: "هل أنت متأكّد تماماً؟",
        priv_delete_confirm_sub: "اكتب DELETE للتأكيد. سيُمحى كلّ شيء.",
        priv_delete_placeholder: "اكتب DELETE",
        priv_delete_yes: "نعم، احذف نهائيّاً",
        priv_delete_cancel: "الاحتفاظ بحسابي",
        help_center: "مركز المساعدة",
        help_contact: "تواصل مع الدعم",
        help_faq: "الأسئلة الشائعة",
        help_report: "الإبلاغ عن مشكلة",
        legal_terms: "شروط الاستخدام",
        legal_privacy: "سياسة الخصوصيّة",
        logout: "تسجيل الخروج",
    },
    qr: { locked_h: "تحميل QR ميزة بريميوم", locked_sub: "قم بالترقية بـ 9.90 CHF/شهر لتحميل PNG و PDF قابل للطباعة.", locked_cta: "افتح التحميل", png: "تحميل PNG", pdf: "PDF للطباعة", scan_hint: "اطبع هذا الرمز على البطاقة أو الطوق أو ملصق. إذا ضاع حيوانك، أي شخص يستطيع مسحه.", downloading: "جارٍ التحضير…", pdf_headline: "إذا وجدته، من فضلك امسح الرمز", pdf_sub: "هذه البطاقة محمية بواسطة PawLink — سيرى الشخص الذي وجد الحيوان صورته وحساسيته وملاحظاته الطبية ويتصل بك بلمسة واحدة.", pdf_scan_here: "امسح هنا", pdf_url_label: "أو زر", pdf_footer: "PawLink — بطاقة QR ذكية · getpawlink.com", page_h: "رموز QR الذكية", page_sub: "قم بتحميل أو طباعة أو مشاركة بطاقة كل حيوان — طوق، ملصق، بوستر أو كرت احتياطي.", public_link: "الرابط العام", empty_h: "لا توجد رموز QR بعد", empty_sub: "أنشئ ملف حيوان أولاً — سنولّد بطاقة QR ذكية تقود من يجده إلى بيته." },
    footer: { product: "المنتج", pricing: "الأسعار", create_profile: "أنشئ ملفاً", sign_in: "تسجيل الدخول", trust: "الثقة والقانوني", trust1: "الخصوصية أولاً: أنت تختار ما يراه من يجد حيوانك.", trust2: "QR ديناميكي — عدّل المعلومات متى شئت.", trust3: "صُنع بعناية للحيوانات وأصحابها.", tag: "أعِدهم للبيت.", support: "الدعم", contact_us: "تواصل معنا", help_center: "مركز المساعدة" },
    scanloc: {
        exact: "GPS دقيق",
        exact_acc: "GPS دقيق · ±{m} م",
        coarse: "GPS تقريبي",
        coarse_acc: "GPS تقريبي · ±{m} م",
        approx: "موقع تقريبي فقط",
        unknown: "موقع غير معروف",
        open_exact: "افتح النقطة الدقيقة على خرائط جوجل",
        open_coarse: "افتح النقطة التقريبية على خرائط جوجل",
        open_area: "افتح المنطقة العامة على خرائط جوجل",
        open_in_maps: "افتح على خرائط جوجل",
    },
    pets_page: {
        hero_kicker: "عائلتك",
        hero_h: "الكل في البيت. الكل بأمان.",
        hero_sub: "كل حيوان لديك يحمل رمز QR ذكياً. إذا ضاع، يمكن لأي شخص إعادته إلى البيت في ثوانٍ.",
        add_pet: "أضف فرداً جديداً للعائلة",
        error_title: "تعذّر تحميل حيواناتك",
        error_sub: "لم يستجب الخادم. تحقق من اتصالك وحاول مجدداً — بياناتك بأمان.",
        error_retry: "حاول مرة أخرى",
        status_active: "محمي",
        status_lost: "مفقود",
        status_sub: "الهوية الرقمية مفعّلة",
        status_ready: "جاهز إذا ضاع {name}",
        badge_qr: "QR مفعّل",
        act_view: "عرض الملف",
        act_qr: "رمز QR",
        act_edit: "تعديل المعلومات",
        act_delete: "حذف",
        protected_line: "{name} محمي",
        lost_line: "{name} مفقود — المساعدة في الطريق",
        safety_h: "مركز الأمان",
        safety_sub: "وضع الفقد · الشخصية · جواز السفر",
        safety_lost_h: "{name} في وضع الفقد",
        safety_lost_sub: "افتح لوحة الطوارئ",
        confirm_delete: "حذف ملف {name}؟ لا يمكن التراجع.",
        cancel: "إلغاء",
        empty_h: "تعرّف على أعزّ صديق",
        empty_sub: "أنشئ جواز سفره الرقمي للأمان. يستغرق دقيقتين وقد يعيده إلى بيته للأبد.",
        empty_cta: "احمِ حيواني",
        trust_h_one: "أعزّ صديق لك بأمان.",
        trust_h_many: "أعزّ {count} أصدقاء لك بأمان.",
        trust_sub: "كل مسح يُرسل موقعه الحيّ إليك فوراً. لن تبعد سوى نقرة واحدة عن إعادته إلى البيت.",
    },
    home_story: {
        hero_eyebrow: "PawLink · هويّة ذكيّة لصديقك المفضّل",
        hero_h_a: "حين يضيعون…",
        hero_h_a2: "لا يستطيعون إخبار أحدٍ أين البيت.",
        hero_h_b: "PawLink يستطيع.",
        hero_sub: "لأنّ الحبّ هو أسرع طريقٍ إلى البيت.",
        hero_cta_primary: "احمِ صديقي المفضّل",
        hero_cta_secondary: "شاهد كيف يعمل",
        hero_scroll: "شاهد كيف يعمل",
        pill_scan: "مسح · تواصل · لمّة",
        s1_kicker: "المشهد ٠١ · لحظة المسح",
        s1_h: "شخصٌ ما وجد صديقك المفضّل.",
        s1_sub: "غريبٌ يمسح رمز PawLink. في الثانية التالية يرى صورته، يسمع صوتك، ويصل إليك بلمسة واحدة. لا حاجة لتطبيق ولا لتسجيل. فقط لُطف — متّصلٌ فوراً.",
        s1_note_title: "مسحٌ جديد · وسط المدينة",
        s1_note_body: "شخصٌ ما مسح رمز ميلو للتوّ.",
        s2_kicker: "المشهد ٠٢ · وضع الفقدان",
        s2_h: "صديقك المفضّل مفقود.",
        s2_sub: "فعّل وضع الفقدان. كل مسح يُرسل إلى هاتفك موقعاً دقيقاً. حيّك كلّه يصبح فريق بحث — مكافأتك، نداؤك، صورتك تسافر مع الرمز أينما ذهب.",
        s2_chip: "مفقود · ساعدنا رجاءً",
        s2_stat: "بحث مباشر",
        how_kicker: "كيف يعمل PawLink",
        how_h: "ثلاث خطوات بسيطة لإعادته إلى البيت.",
        how_sub: "PawLink خدمة رقمية — يجهز رمز QR الذكي خلال دقائق، لا أيام.",
        how_1_h: "أنشئ ملفّ حيوانك على PawLink",
        how_1_sub: "أضف صورة الحيوان، اسمه، خيارات التواصل مع المالك، معلوماته الطبيّة والتفاصيل التي يختار المالك مشاركتها.",
        how_2_h: "أنشئ رمز QR الذكيّ وأرفقه",
        how_2_sub: "يُنشئ PawLink رمز QR فريدًا يمكن للمالك تنزيله وطباعته وإرفاقه بطوق الحيوان أو بطاقته.",
        how_3_h: "مسح واحد يوصل من عثر عليه بالمالك",
        how_3_sub: "عند مسح رمز QR، يرى الشخص فورًا بطاقة الإنقاذ مع الصورة والاسم وأزرار التواصل التي وافق عليها المالك. ويستلم المالك تنبيه المسح مع موقعه عند توفّره.",
        benefits_kicker: "لماذا PawLink",
        benefits_h: "كل ما تحتاجه لإعادتهم إلى البيت.",
        big_b1_h: "جواز حيوانك الرقمي",
        big_b1_sub: "لا داعي لحمل الأوراق بعد اليوم. جواز حيوانك، سجلات التطعيم، التأمين، شهادة السعار، والتاريخ الطبي — كلها معك دائماً، جاهزة للسفر أو لزيارة الطبيب البيطري.",
        big_b2_h: "مركز الإنقاذ",
        big_b2_sub: "أبلغ عن كلبك كمفقود وفعّل وضع «مفقود». تتبّع موقعه المباشر عبر GPS واحصل على إرشادات دقيقة لإعادته إلى البيت بأمان.",
        big_b3_h: "الرمز الذكي QR",
        big_b3_sub: "نزّل رمز QR الرقمي الفريد لحيوانك واستخدمه كما تشاء — اطبعه في البيت، أضِفه إلى بطاقة طوق أو اكسسوار تملكه، أو شاركه كملصق. حين يقوم شخصٌ بمسحه، يصلك إشعارٌ فوري ويستطيع مَن وجده التواصل معك مباشرةً للمساعدة في لمّ شملك بحيوانك.",
        big_b4_h: "خريطة PawLink",
        big_b4_sub: "تواصل مع أعضاء PawLink القريبين الذين يمكنهم المساعدة في البحث عن حيوانك الأليف وإعادته إليك.",
        benefits_close: "لا تقلق. نحن معك متى احتجتنا.",
        // Legacy 6-tile benefits — kept for backward compatibility (not currently rendered on Home)
        hb1_h: "مجتمع الإنقاذ في PawLink",
        hb1_sub: "إذا فُقد حيوانك، فأنت لست وحدك. أعضاء PawLink القريبون يمكنهم الانضمام إلى البحث والمساعدة في إعادته إلى البيت.",
        hb2_h: "QR ذكي + تنبيهات مسح فوريّة",
        hb2_sub: "أنشئ رمز QR فريدًا لحيوانك واستقبل تنبيهًا فوريًّا داخل التطبيق وعبر البريد الإلكتروني عند مسحه — بما في ذلك وقت المسح وموقعه عند توفّره.",
        hb3_h: "بطاقة الإنقاذ الذكيّة",
        hb3_sub: "بعد مسح QR، يرى من عثر عليه بطاقة إنقاذ نظيفة تحتوي على ما اختار المالك مشاركته فقط — الصورة، الاسم، زر الاتصال، WhatsApp، تحذير طبيّ، المكافأة وملاحظات الطوارئ.",
        hb4_h: "جواز السفر الرقميّ",
        hb4_sub: "احتفظ بمعلومات اللقاحات والسفر والهويّة الأساسيّة في مكانٍ رقميّ آمن واحد.",
        hb5_h: "خريطة الإنقاذ في PawLink",
        hb5_sub: "اكتشف أعضاء PawLink القريبين ونشاط الإنقاذ حولك، لتكون المساعدة أقرب عندما يُفقد حيوانك.",
        hb6_h: "السجلّات الطبيّة متاحة دائمًا",
        hb6_sub: "احفظ الحساسيّات والأدوية والمعلومات الطبيّة وتفاصيل الطبيب البيطريّ لتكون متاحة أثناء الزيارات البيطريّة، الطوارئ والسفر.",
        reviews_kicker: "يحبّه أهل الحيوانات",
        reviews_h: "لمّاتٌ حقيقيّة. عائلاتٌ حقيقيّة.",
        review_1_body: "شخصٌ ما مسح رمز لونا وعادت إلى البيت في اليوم نفسه. ما زلت أبكي كلّما تذكّرت.",
        review_1_author: "إيميلي · أمّ كلب",
        review_2_body: "أفضل حمايةٍ اشتريتها لكلبي. بسيطة، تستحقّ كل دولار، وأنام أفضل ليلاً.",
        review_2_author: "جيمس · عضو PawLink",
        family_kicker: "انضمّ إلى عائلة PawLink 🐾❤️",
        family_h_none: "أهل حيوانات يحمون أعزّ أصدقائهم — قبل أن يحدث شيء.",
        family_h_one: "أنت واحدٌ منهم. اسمٌ واحد، قلبٌ واحد، أمانٌ واحد.",
        family_h_many: "أنت واحدٌ منهم. {count} أسماء. {count} قلوب. أمانٌ واحد.",
        family_sub: "مجتمعٌ هادئ من عائلاتٍ اختارت أن تكون جاهزة. الجميع في البيت. الجميع بأمان.",
        family_cta: "أضف حيواناً آخر",
        family_cta_manage: "إدارة حيواناتي",
        family_cta_first: "أنشئ حيوانك الأوّل",
        final_kicker: "PawLink Protection",
        final_h: "إن كنت تحبّ صديقك المفضّل حقّاً، احمِه اليوم ❤️",
        final_sub: "لا تنتظر اليوم الذي تتمنّى فيه لو فعلتَ ذلك مبكّراً. 9.90 CHF شهريّاً · 79.00 CHF سنويّاً. يُلغى في أيّ وقت.",
        final_cta_upgrade: "احمِ صديقي المفضّل",
        final_cta_manage: "إدارة الاشتراك",
        final_active: "الحماية مفعّلة",
    },
    home_protection: {
        eyebrow: "حمايةٌ واحدة. عائلةٌ واحدة.",
        heading: "امنحهم أأمن طريقٍ إلى البيت",
        body: "شاهد بالضبط ما تفتحه حماية PawLink — من التنبيهات الفوريّة إلى مجتمع إنقاذ يساعد في إعادة الحيوانات المفقودة إلى بيوتها بسرعة أكبر.",
        cta: "اكتشف حماية PawLink",
    },
    install: {
        title: "احمِ حيوانك في أقل من دقيقة واحدة.",
        subtitle: "ثبّت PawLink مباشرة من موقعنا وابدأ حماية حيوانك اليوم. لا بحث في متجر التطبيقات، ولا إعدادات معقّدة. فقط ثبّت، أنشئ ملفّ حيوانك، وأنت جاهز.",
        cta: "تثبيت PawLink",
        cta_installing: "جارٍ التثبيت…",
        cta_installed: "تمّ التثبيت",
        cta_open: "افتح PawLink",
        desktop_qr_title: "امسح لتثبيت PawLink فوراً.",
        desktop_qr_sub: "وجّه كاميرا هاتفك نحو هذا الرمز — ستكمل التثبيت على جهازك.",
        badge_secure: "تثبيت آمن",
        badge_free: "تنزيل مجاني",
        badge_fast: "إعداد سريع",
        badge_updates: "تحديثات تلقائية",
        ios_modal_title: "ثبّت PawLink على iPhone",
        ios_modal_sub: "في Safari، اضغط زرّ المشاركة ثم \"إضافة إلى الشاشة الرئيسية\".",
        ios_step_1: "اضغط أيقونة المشاركة أسفل Safari.",
        ios_step_2: "اختر \"إضافة إلى الشاشة الرئيسية\".",
        ios_step_3: "اضغط إضافة — أصبح PawLink على شاشتك الرئيسية.",
        ios_modal_close: "فهمت",
        already_installed_hint: "مثبَّت مسبقاً؟ افتح PawLink من شاشتك الرئيسية.",
        phone_caption: "بطاقة الإنقاذ التي سيرتديها حيوانك.",
        ios_coming_kicker: "قريباً على App Store",
        ios_coming_title: "PawLink لهاتف iPhone قادم قريباً.",
        ios_coming_sub: "نضع اللمسات النهائيّة على إصدار App Store. حتى ذلك الحين، تستطيع حماية حيوانك — كلّ الميزات تعمل بشكل رائع على الويب.",
        ios_meanwhile_label: "حتى ذلك الحين",
        ios_meanwhile_body: "أنشئ حساب PawLink الآن وابدأ حماية حيوانك من Safari — دون الحاجة إلى تثبيت.",
        share_cta: "شارك PawLink",
        share_title: "شارك PawLink",
        share_sub: "ساعد حيواناً آخر على العودة إلى بيته بأمان — شارك PawLink مع أصدقائك وعائلتك.",
        share_message: "PawLink — بطاقة QR الذكية التي تساعد على إعادة الحيوانات المفقودة إلى منازلها. جرّبها مجاناً:",
        share_whatsapp: "واتساب",
        share_facebook: "فيسبوك",
        share_x: "X",
        share_email: "البريد الإلكتروني",
        share_copy: "نسخ الرابط",
        share_copied: "تم نسخ الرابط",
        share_close: "إغلاق",
        petcard_verified: "موثّق PawLink",
        petcard_qr_id: "رمز QR",
        petcard_vaccinations: "التطعيمات",
        petcard_up_to_date: "محدَّثة",
        petcard_allergies: "الحساسية",
        petcard_medical: "ملاحظات طبية",
        petcard_owner: "المالك",
        petcard_emergency: "طوارئ",
        petcard_documents: "المستندات",
        petcard_passport: "جواز · سجلّ بيطري",
        petcard_updated: "آخر تحديث",
        petcard_updated_time: "قبل يومين",
        petcard_pet_name: "كوكو",
        petcard_pet_breed: "توي بودل · أنثى",
        petcard_allergy_value: "بروتين الدجاج",
        petcard_medical_value: "لا شيء",
        petcard_owner_value: "ليا م.",
        petcard_none: "لا شيء",
        // Rescue scan mockup (public finder view shown on Home)
        petcard_scan_title: "تمّ مسح رمز QR بنجاح",
        petcard_scan_sub: "لهذا الحيوان عائلة تنتظره.",
        petcard_age: "العمر",
        petcard_age_value: "٣ سنوات",
        petcard_gender: "الجنس",
        petcard_gender_value: "أنثى",
        petcard_reward: "مكافأة عند إعادته بأمان",
        petcard_reward_value: "٢٠٠ $",
        petcard_notes: "ملاحظات طارئة",
        petcard_notes_value: "ودودة جداً. الرجاء إبقاؤها هادئة ومرطّبة حتى نصل.",
        petcard_call: "اتصل بالمالك",
        petcard_whatsapp: "واتساب",
        android_soon_kicker: "تطبيق أندرويد — قريباً جداً",
        android_soon_title: "PawLink لأندرويد شبه جاهز.",
        android_soon_sub: "تطبيقنا الأصلي لأندرويد في الاختبارات النهائيّة. حتى ذلك الحين، ثبّت PawLink كتطبيق ويب — نفس الحماية، بضغطة واحدة.",
        android_install_pwa: "ثبّت كتطبيق ويب",
        android_dismiss: "ليس الآن",
    },
    home_pricing: {
        eyebrow: "أسعار بسيطة وصادقة",
        heading: "مجانيّ للأبد — والحماية عند الحاجة",
        sub: "ابدأ مجاناً. طوّر خطتك فقط حين تريد الميزات التي تجعل PawLink شبكة إنقاذ حقيقيّة.",
        hero_get_started: "ابدأ الآن — مجاناً",
        free_title: "مجاني",
        free_price: "0$",
        free_sub: "كل ما تحتاجه لإعادتهم إلى البيت.",
        free_f1: "ملف حيوان واحد مع QR ذكي",
        free_f2: "تنبيهات مسح فوريّة",
        free_f3: "أدوات تواصل أساسيّة مع من يجد حيوانك",
        free_cta: "أنشئ حساباً مجانيّاً",
        pro_title: "حماية PawLink",
        pro_price: "79.00 CHF",
        pro_period: "/سنويّاً",
        pro_sub: "أو 9.90 CHF / شهريّاً · إلغاء في أيّ وقت",
        pro_badge: "الأكثر تفضيلاً",
        pro_f1: "حيوانات وملفّات غير محدودة",
        pro_f2: "جواز سفر رقميّ ووثائق طبيّة",
        pro_f3: "خريطة إنقاذ مجتمع PawLink",
        pro_f4: "رسائل صوتيّة ثنائيّة الاتجاه",
        pro_f5: "دعم أولويّة للمّ الشمل",
        pro_cta: "احصل على الحماية",
        see_all: "قارن كل الميزات",
    },
    home_faq: {
        eyebrow: "أسئلة وأجوبة",
        heading: "كلّ ما يسأله صاحب حيوان قبل الانضمام إلى PawLink",
        q1_q: "كيف يعمل QR الذكيّ فعلياً؟",
        q1_a: "تنزّل رمز QR الرقمي الفريد لحيوانك من صفحة الحيوان وتعرضه كما تشاء — اطبعه في البيت، أضِفه إلى بطاقة أو طوق تملكه، أو استخدمه كملصق. حين يوجّه أيّ شخص هاتفه إليه، تفتح صفحة عامة أنيقة تعرض اسم حيوانك وطريقة التواصل معك — دون تطبيق أو حساب من طرفه.",
        q2_q: "ماذا يحدث لحظة مسح حيواني؟",
        q2_a: "تحصل على إشعار فوريّ في مركز الإنقاذ يتضمّن موقع من وجده مباشرةً (متحوّل إلى المدينة/الشارع)، وأيّ رسالة صوتيّة يتركها، وطريقة اتّصال مباشرة به.",
        q3_q: "هل تشاركون عنواني الدقيق؟",
        q3_a: "أبداً. يرى من يجد حيوانك فقط المعلومات التي تختار عرضها على ملفك العام. خريطة المجتمع تستخدم موقعاً تقريبيّاً — عنوان بيتك يبقى خاصاً دائماً.",
        q4_q: "هل يمكنني إلغاء الحماية في أيّ وقت؟",
        q4_a: "نعم. إدارة أو إلغاء الاشتراك بلمسة واحدة من الإعدادات. ملفّك المجانيّ — وسجلّ كل مسح — يبقى لك للأبد.",
        see_all: "شاهد الأسئلة الشائعة كاملة",
    },
    rescue: {
        title: "كل إنقاذ في مكان واحد.",
        sub: "التنبيهات، عمليات المسح، وتواصل الرائين — كل نشاط إنقاذ حيوانك، معاً.",
        tab_alerts: "التنبيهات",
        tab_scans: "سجل المسح",
        filter_all: "كل الحيوانات",
        call_finder: "اتّصل بالرائي",
        sms_finder: "أرسل رسالة",
        empty_alerts_h: "لا شيء جديد.",
        empty_alerts_sub: "لا تنبيهات بعد. عندما يمسح شخص ما رمز QR الذكيّ، ستراه هنا فوراً مع الموقع وأيّ رسالة يتركها.",
        empty_scans_h: "لا يوجد مسح بعد.",
        empty_scans_sub: "اطبع رمز QR الذكيّ على وسم أو طوق. بمجرد أن يمسحه شخصٌ ما، سترى أين ومتى — هنا مباشرةً.",
        finder_voice_h: "رسالة صوتيّة من الرائي",
        rescue_alert_line: "🚨 حيوان قريب يحتاج المساعدة — {pet} · {km} كم",
        rescue_alert_open: "عرض تفاصيل الإنقاذ",
        delete_alert: "حذف التنبيه",
        confirm_delete: "حذف هذا التنبيه؟ لا يمكن التراجع.",
    },
    legal: {
        back: "العودة إلى الحساب",
        updated: "آخر تحديث",
        privacy_kicker: "الشؤون القانونيّة · الخصوصيّة",
        privacy_title: "بياناتك محميّة.",
        privacy_sub: "بالضبط ما يجمعه PawLink، وكيف نستخدمه، والتحكّم الذي تملكه.",
        terms_kicker: "الشؤون القانونيّة · الشروط",
        terms_title: "شروط الاستخدام",
        terms_sub: "شروط بسيطة وإنسانيّة لاستخدام PawLink للحفاظ على حيوانك.",
        faq_kicker: "الدعم · الأسئلة الشائعة",
        faq_title: "أسئلة يطرحها ملّاك الحيوانات.",
        faq_sub: "كلّ ما قد تتساءل عنه حول رمز QR الذكيّ والخصوصيّة وحماية PawLink.",
        support_kicker: "الدعم",
        support_title: "نحن هنا من أجلك ومن أجل حيوانك.",
        support_sub: "أرسل لنا رسالة وسنعود إليك — عادةً خلال يوم عمل واحد.",
    },
    support: {
        email_label: "راسلنا بالبريد",
        email_hint: "للحالات العاجلة، البريد يصل دائماً إلى إنسان.",
        faq_label: "الخدمة الذاتيّة",
        faq_title: "تصفّح الأسئلة الشائعة",
        faq_hint: "إجابات للأسئلة التي نسمعها كلّ أسبوع.",
        form_title: "أرسل لنا رسالة",
        form_sub: "أخبرنا بما يحدث وسنتولّى الأمر من هناك.",
        cat_account: "الحساب",
        cat_billing: "الفوترة",
        cat_bug: "خطأ برمجيّ",
        cat_safety: "سلامة الحيوان",
        cat_other: "أخرى",
        f_category: "الفئة",
        f_email: "بريدك الإلكترونيّ",
        f_subject: "الموضوع",
        f_subject_ph: "ملخّص قصير",
        f_message: "الرسالة",
        f_message_ph: "شارك أكبر قدر من التفاصيل — أرقام الطلبات أو المسح تساعدنا على مساعدتك بشكل أسرع.",
        send: "إرسال الرسالة",
        sending: "جارٍ الإرسال…",
        sent_ok: "تمّ الإرسال. سنكون على تواصل معك قريباً.",
    },
    qr_detail: {
        back: "العودة للحيوانات",
        kicker: "الهوية الرقمية للحيوان",
        protection_badge: "محمي بواسطة PawLink",
        pet_id: "PawLink ID",
        scan_h: "كيفية استخدام هذا الرمز",
        scan_1: "اطبعه على بطاقة أو ملصق أو طوق أو كرت محفظة",
        scan_2: "ألصقه بشيء يرتديه حيوانك دائماً",
        scan_3: "إذا ضاع، أي شخص يمسحه سيتصل بك فوراً",
        actions_download_png: "تحميل PNG",
        actions_download_pdf: "تحميل PDF",
        actions_print: "طباعة QR",
        actions_share: "مشاركة",
        share_title_prefix: "اعثر على",
        share_text: "إذا وجدته، من فضلك امسح هذا الرمز وأعده إلى البيت ❤️",
        tags_h: "شاهده على بطاقات حقيقية",
        tags_sub: "تخيّل حيوانك يرتدي رمز PawLink QR. نزّل الرمز الرقمي متى شئت واطبعه بنفسك على أي بطاقة أو طوق تملكه — PawLink خدمة رقمية ولا تبيع أي منتج مادّي.",
        tag_stainless: "ستانلس ستيل",
        tag_bone: "شكل عظمة",
        tag_black: "أسود بريميوم",
        tag_gold: "ذهبي بريميوم",
        tag_silicone: "سيليكون",
        tag_sticker: "ملصق",
        tag_wallet: "كرت محفظة",
        premium_gate_h: "تحميل رمز {name} — بريميوم",
        premium_gate_sub: "قم بالترقية بـ 9.90 CHF/شهر لتحميل وطباعة ومشاركة رمز {name} في أي مكان.",
        premium_gate_cta: "افتح هذا الرمز",
        premium_gate_preview: "يمكنك معاينة التصميم — التحميل يتطلب اشتراك بريميوم.",
        passport_reassure: "إذا وُجد {name}، هذا الرمز يعيده إليك.",
        live_indicator: "مباشر",
    },
    safety: {
        kicker: "مركز الأمان",
        title: "احمِ {name}",
        sub: "وضع الطوارئ، شخصية الحيوان، وثائق جاهزة للسفر — كل ما يبقي {name} بأمان كل يوم.",
        back_to_pets: "العودة للحيوانات",
        pet_not_found: "الحيوان غير موجود",
        tab_emergency: "الطوارئ",
        tab_personality: "الطباع",
        tab_passport: "الجواز",
        tab_health: "الصحة",
        hero_safe: "بأمان الآن",
        sos_kicker: "وضع الطوارئ",
        sos_h: "إذا ضاع {name} يوماً ما",
        sos_sub: "لمسة واحدة تُحوّل رمز QR الخاص بـ{name} إلى صفحة طوارئ كاملة — مع رقمك، آخر مكان شوهد فيه، والمكافأة.",
        sos_cta: "بلّغ عن {name} مفقود",
        sos_reassure: "يمكنك إيقاف هذا الوضع في أي لحظة عند عودة {name} بأمان.",
        step_s1_h: "اضغط SOS",
        step_s1_d: "زر واحد يحوّل الرمز إلى وضع الطوارئ فوراً.",
        step_s2_h: "يظهر التنبيه للغرباء",
        step_s2_d: "بانر أحمر كبير، زر اتصال، مكافأة وآخر مكان.",
        step_s3_h: "تُعيد {name} إلى البيت",
        step_s3_d: "كل مسح يصل إليك. لمّ شمل عائلتك من جديد.",
        modal_h: "التبليغ عن اختفاء {name}",
        modal_sub: "هذا يحوّل صفحة QR العامة إلى وضع الطوارئ فوراً.",
        f_last_seen: "آخر مكان شوهد فيه",
        f_last_seen_ph: "مثال: حديقة الريفرسايد قرب البوابة الغربية",
        f_reward: "مكافأة (اختياري)",
        f_reward_ph: "مثال: $200",
        f_instructions: "ملاحظة لمن يجده",
        f_instructions_ph: "مثال: {name} خجول — لا تلاحقه. اتصل بي وسآتي.",
        gps_sharing: "جارٍ قراءة موقعك…",
        gps_ok: "تم حفظ موقعك كنقطة انطلاق",
        gps_off: "الموقع غير مفعّل — لا بأس، يمكنك كتابة عنوان.",
        gps_idle: "سنحفظ موقعك إن سمحت.",
        activate_now: "فعّل وضع الفقد",
        activating: "جارٍ التفعيل…",
        activate_error: "تعذّر التفعيل. حاول مرة أخرى.",
        activate_fineprint: "يمكنك وضع علامة أن {name} بأمان في أي وقت.",
        status_lost: "وضع الفقد مفعّل",
        missing_for: "مفقود منذ {time}",
        missing_now: "تم الإبلاغ للتو",
        stat_scans: "المسحات منذ الفقد",
        stat_qr: "رمز QR العام",
        stat_qr_on: "في وضع الطوارئ",
        share_h: "شارك التنبيه",
        copied: "تم النسخ",
        copy_link: "انسخ الرابط",
        share_msg: "المساعدة — كلبي {name} مفقود! أرجوك شارك هذا الرابط ليعيده أي شخص للبيت: {url}",
        mark_safe_cta: "{name} بأمان — أعده للبيت",
        rescue_alert_h: "تنبيه الحرّاس القريبين",
        rescue_alert_sub: "أرسل إشعاراً إلى كل حارس PawLink متطوّع ضمن النطاق المختار. يرون صورة الحيوان والمنطقة التقريبية فقط — لا هاتفك ولا عنوانك.",
        rescue_alert_send: "أرسل التنبيه للحرّاس ضمن {r} كم",
        rescue_alert_sending: "جاري إرسال التنبيه…",
        rescue_alert_result: "تم إرسال التنبيه إلى {n} حارساً/حرّاس ضمن {r} كم ❤️",
        rescue_alert_error: "تعذّر إرسال التنبيه. حاول مرة أخرى.",
        rescue_alert_privacy: "نشارك اسم الحيوان وصورته ومنطقته التقريبية فقط. هويتك تظل خاصة.",
        confirm_safe: "وضع علامة أن {name} تم العثور عليه وبأمان؟ سيتم إيقاف وضع الفقد.",
        preview_h: "ما يراه من يجده الآن",
        preview_line1: "🚨 {name} مفقود — أرجوك ساعد.",
        preview_line2: "زر الاتصال والمكافأة وتعليماتك تظهر في المقدمة.",
        preview_cta: "معاينة الصفحة العامة",
        elapsed_d: "{d} يوم",
        elapsed_h: "{h} ساعة",
        elapsed_m: "{m} دقيقة",
        elapsed_now: "الآن",
        personality: {
            h: "كيف تتعامل مع {name}",
            sub: "اختر كل صفة تنطبق على {name}. الغرباء الذين يمسحون QR سيرونها — فيعرفون كيف يتعاملون معه.",
            g_friendly: "طاقة إيجابية",
            g_friendly_sub: "أخبر من يجده بما يحب {name}.",
            g_careful: "تعامل بلطف",
            g_careful_sub: "أشياء يجب على الغريب أن ينتبه لها.",
            g_medical: "طبي وغذاء",
            g_medical_sub: "حتى لا يُطعمه أحد شيئاً خاطئاً أو ينسى دواءه.",
            save_cta: "حفظ الشخصية",
            no_changes: "كل شيء محدَّث",
        },
        p: {
            friendly_people: "ودود مع الناس",
            friendly_dogs: "ودود مع الكلاب",
            friendly_cats: "ودود مع القطط",
            good_children: "رائع مع الأطفال",
            trained: "مدرَّب جيداً",
            energetic: "نشيط ومرِح",
            nervous: "قلق / متوتر",
            needs_space: "يحتاج مساحة",
            do_not_approach: "لا تقترب بدون المالك",
            medical_needs: "لديه احتياجات طبية",
            special_diet: "نظام غذائي خاص",
            needs_medication: "يحتاج دواء",
        },
        passport: {
            brand: "جواز حيوان رقمي",
            g_health: "التطعيمات والصحة",
            g_vet: "الطبيب البيطري والشهادات",
            g_insurance: "التأمين",
            g_travel: "السفر وأخرى",
            empty_h: "لا توجد وثائق بعد",
            empty_sub: "ارفع شهادة داء الكلب لـ{name}، سجلات التطعيم أو التأمين — لا تحمل الأوراق أبداً، وهي معك في كل مكان.",
            add_h: "أضف وثيقة جديدة",
            add_sub: "PDF أو صورة. فقط أنت من يراها ما لم تجعلها عامة.",
            upload_cta: "ارفع الوثيقة",
        },
        dockind: {
            vaccine: "تطعيم",
            rabies: "شهادة داء الكلب",
            vet: "وثيقة بيطرية",
            medical: "سجل طبي",
            insurance: "تأمين",
            travel: "وثيقة سفر",
            other: "أخرى",
        },
        f_doc_name: "اسم الوثيقة",
        f_doc_name_ph: "مثال: داء الكلب 2026",
        f_doc_kind: "النوع",
        uploading: "جارٍ الرفع…",
        upload_error: "فشل الرفع. حاول مجدداً.",
        saved: "تم الحفظ",
        view: "عرض",
        public_on: "مرئي لمن يجد (عام)",
        public_off: "أنت فقط تراه (خاص)",
        public_on_hint: "يمكن لمن يمسح QR أن يشاهد هذه الوثيقة.",
        public_off_hint: "خاصة — لك وحدك.",
        tt_public: "عام — يراها من يجد الحيوان",
        tt_private: "خاصة — لك وحدك",
        confirm_remove_doc: 'إزالة "{name}"؟ لا يمكن التراجع.',
    },
    premium_soon: {
        badge: "قريباً",
        chip: "بريميوم",
        title: "بريميوم قادم قريباً 🐾",
        body: "هذه الميزة جزء من PawLink Premium. ستكون اشتراكات البريميوم متاحة قريباً.",
        free_hint: "حالياً، يمكنك متابعة استخدام ميزات PawLink المجانية.",
        ok: "حسناً",
    },
    subscription: {
        title_active: "PawLink Protection مفعّل",
        title_choose: "لأن فقدانهم ليس خياراً ❤️",
        sub_active: "أنت تحمي صديقك المفضل بأفضل خطة. شكراً لك على إبقائه بأمان.",
        sub_choose: "طريقة أذكى لحماية من هم دائماً بجانبك.",
        current_plan: "خطتك الحالية",
        plan_free_name: "الخطة المجانية",
        plan_premium_name: "PawLink Protection",
        plan_free_meta: "ملف حيوان واحد · معاينة فقط",
        plan_premium_meta: "تجدد تلقائياً · ألغِ في أي وقت",
        active: "مفعّل",
        upgrade_cta: "ترقية إلى Protection",
        benefits_h: "ما هو مضمّن",
        emotional_sub: "طريقة أذكى لحماية من هم دائماً بجانبك.",
        cancel_anytime: "ألغِ في أي وقت",
        get_started: "ابدأ الآن",
        best_value_sub: "الأفضل قيمة · ~$1.25/شهر",
        choose_yearly: "اختر السنوي",
        family_reassure: "أنت تحمي أحد أفراد العائلة — لا تشتري رمز QR.",
        emo_hero_title: "ماذا لو ضاع حيوانك اليوم؟",
        emo_hero_sub: "لا يستطيع أن يخبر أحداً برقم هاتفك. PawLink قادرٌ على إعادته إلى البيت.",
        compact_title: "ماذا لو ضاع حيوانك؟",
        compact_sub: "تنبيه فوريّ. موقع مباشر. إعادةٌ أسرع للبيت.",
        hero_new_title: "احمِ صديقك المفضّل — حتى حين لا تكون بجانبه",
        hero_new_sub: "مسحة واحدة تُساعد من يعثر عليه في التواصل معك بشكل أسرع.",
        b1_title: "تنبيه فقدان فوريّ",
        b1_sub: "اعرف في اللحظة التي يجد فيها أحدهم صديقك المفضّل.",
        b2_title: "موقع المسح",
        b2_sub: "شاهد بالضبط أين تمّ مسح الرمز.",
        b3_title: "اتصال بلمسة واحدة",
        b3_sub: "الرائي يصل إليك فوراً — بدون تطبيق.",
        b4_title: "جواز سفر رقميّ",
        b4_sub: "الملفّ البيطريّ، اللقاحات وأوراق السفر معك دائماً.",
        b5_title: "رسالة صوتيّة",
        b5_sub: "دع صوتك يطمئنه حتى تلتقيا.",
        b6_title: "حماية QR الذكيّة",
        b6_sub: "طريقٌ أسرع للعودة عندما يحتاجون إليك.",
        // v7.41 — 6 features (AR)
        f1_title: "مجتمع الإنقاذ في PawLink",
        f1_tagline: "إذا فُقد حيوانك الأليف، فأنت لست وحدك. أعضاء PawLink القريبون منك يمكنهم المساعدة في البحث من خلال مجتمع الإنقاذ.",
        f1_line1: "عائلة واحدة.",
        f1_line2: "مهمّة واحدة.",
        f1_line3: "لنُعِد كل حيوان إلى بيته.",
        f2_title: "حماية QR الذكيّة وتنبيهات فوريّة",
        f2_tagline: "لحظة أن يقوم شخص بمسح رمز QR الذكي لحيوانك، يصلك إشعار فوري وبريد إلكتروني — فتتصرف خلال ثوانٍ، لا ساعات.",
        f2_line1: "إشعار Push",
        f2_line2: "إشعار عبر البريد الإلكتروني",
        f2_line3: "وقت المسح",
        f2_footer: "اعرف على الفور حين يعثر أحدهم على أعزّ صديق لديك.",
        f3_title: "بطاقة الإنقاذ الذكيّة",
        f3_tagline: "مسحة واحدة تكشف بطاقة إنقاذ أنيقة — الصورة، الاسم، التحذيرات الطبية، المكافأة، وأزرار الاتصال وواتساب التي تصل إليك فوراً.",
        f3_line1: "صورة الحيوان الأليف",
        f3_line2: "اسم الحيوان",
        f3_line3: "زر الاتصال بالمالك",
        f3_line4: "زر WhatsApp",
        f3_line5: "تحذير طبيّ",
        f3_line6: "مكافأة (اختياريّ)",
        f3_line7: "ملاحظات طوارئ",
        f3_footer: "المالك يتحكّم تمامًا بما يظهر للعيان. الخصوصيّة أولاً دائمًا.",
        f4_title: "جواز السفر الرقميّ",
        f4_tagline: "احتفظ بمعلومات حيوانك المهمّة في مكان واحد آمن. اللقاحات، معلومات السفر والسجلّات الأساسيّة متاحة في أي وقت تحتاجها.",
        f5_title: "خريطة الإنقاذ في PawLink",
        f5_tagline: "شاهد أعضاء PawLink القريبين ونشاط الإنقاذ حولك. عندما يُفقد حيوانك، تساعدك خريطة الإنقاذ على التواصل مع مستخدمين قريبين قد يعينونك في إعادته بسرعة أكبر.",
        f6_title: "السجلّات الطبيّة معك دائمًا",
        f6_tagline: "التطعيمات، الحساسيات، الأدوية، وبيانات الطبيب البيطري — محفوظة بأمان وجاهزة عند الحاجة.",
        f6_line1: "المعلومات الطبيّة",
        f6_line2: "الحساسيّات",
        f6_line3: "الأدوية",
        f6_line4: "معلومات الطبيب البيطريّ",
        f6_footer: "لا مزيد من حمل الأوراق. كل شيء متاح فوراً أثناء زيارات الطبيب، الطوارئ أو السفر.",
        emotional_close: "انضمّ إلى مجتمع PawLink — احمِ أليفك اليوم.",
        // v7.42 — Two-plan selector (AR)
        pick_a_plan_aria: "اختر خطة",
        plan_monthly_label: "شهري",
        plan_yearly_label: "سنوي",
        plan_monthly_note: "ألغِ في أي وقت",
        plan_yearly_note: "وفّر ٥٠٪ عن الشهري",
        plan_yearly_badge: "الأفضل قيمة",
        per_month: "/ شهر",
        per_year: "/ سنة",
        selected_prefix: "اخترت:",
        cta_new: "ابدأ تجربتك المجانية لمدة ٧ أيام 🐾",
        cta_open_browser: "افتح في المتصفح للاشتراك →",
        store_free_h: "PawLink مجّاني في هذا التطبيق",
        store_free_sub: "يمكنك استخدام جميع ميزات PawLink الأساسية على أندرويد مجّاناً — لا حاجة لأي اشتراك داخل هذا التطبيق. ملفات حيواناتك ورمز QR الذكي ووضع الفقدان والإشعارات كلّها متاحة مجّاناً.",
        early_access_chip: "عضو مؤسّس · وصول مبكّر",
        early_access_h: "مرحباً بك في PawLink للوصول المبكّر 🐾",
        early_access_sub: "PawLink جديد — وأنت من الأوائل. استمتع بميزات الحماية في PawLink خلال فترة الوصول المبكّر بينما نواصل بناء PawLink لعائلات الحيوانات حول العالم.",
        early_access_note: "أنت أحد أعضاء PawLink الأوائل. خطط بريميوم وميزات إضافية قادمة في المستقبل.",
        ea_welcome_h: "أنت من أوائل أعضاء PawLink 🧡",
        ea_welcome_sub: "شكراً لانضمامك مبكراً. أنشئ ملف حيوانك وارمز QR الذكي دون تكلفة — ميزات PawLink Premium الإضافية (وضع الفقدان، خريطة PawLink للإنقاذ، التتبّع المباشر) قادمة قريباً.",
        ea_welcome_dismiss: "حسناً",
        trial_title: "كيف تعمل تجربتك المجانية لمدة ٧ أيام",
        trial_day0: "اليوم ٠ — تُفتح كل الميزات مجانًا.",
        trial_day5: "اليوم ٥ — نُذكّرك قبل انتهاء التجربة.",
        trial_day7: "اليوم ٧ — تبدأ حماية PawLink.",
        urgency_line: "الحيوانات المفقودة لا تنتظر. كن مستعدّاً قبل أن يحدث ذلك. ❤️",
        family_line: "لأنّهم عائلة — والعائلة تستحقّ طريقاً إلى البيت",
        billing_help: "أسئلة عن الفوترة أو الاشتراك؟ راسلنا على",
        benefit_short_1: "تنبيه فوريّ",
        benefit_short_2: "موقع مباشر",
        benefit_short_3: "خصوصيّة آمنة",
        journey_kicker: "رحلة الإنقاذ",
        journey_title: "ضاع ← مسح ← تنبيه ← عاد للبيت",
        journey_1_title: "شخصٌ وجد ماكس",
        journey_1_sub: "تنبيه فوري على هاتفك عند المسح.",
        journey_2_title: "آخر موقع",
        journey_2_sub: "اعرف أين تمّ مسح رمز QR بالضبط.",
        journey_3_title: "اتصال بلمسة",
        journey_3_sub: "الرائي يتواصل معك فوراً.",
        journey_4_title: "خاصٌّ وآمن",
        journey_4_sub: "عنوان بيتك يبقى مخفيّاً — دائماً.",
        best_protection: "أفضل حماية",
        cancel_line: "لن يُخصم أي مبلغ اليوم · ألغِ بضغطة زر في أي وقت.",
        cardholder_hint: "الرجاء إدخال الاسم كما هو مطبوع على البطاقة — الأحرف والمسافات والشرطة (-) والفاصلة العليا (') فقط. لا يقبل مزوّد الدفع الأرقام أو الرموز.",
        cardholder_helper: "نصيحة: أدخل اسم حامل البطاقة بأحرف لاتينية — يمكنك استخدام المسافات والشرطة (-) والفاصلة العليا (').",
        invalid_browser_locale: "متصفحك يبلّغ عن إعداد لغة غير معتاد يمنع صفحة الدفع الآمنة من التحميل. الرجاء تغيير لغة المتصفح أو النظام إلى إعداد قياسي (مثل الإنجليزية) وإعادة تحميل الصفحة، أو مراسلتنا على support@getpawlink.com وسنساعدك في تفعيل الحماية يدوياً.",
        checkout_config_missing_token: "الدفع الآمن غير متاح مؤقتاً — إعدادات مزوّد الدفع لدينا مفقودة في هذا الإصدار. الرجاء التواصل مع support@getpawlink.com وسنقوم بتفعيل الحماية لك.",
        checkout_config_wrong_env: "الدفع الآمن غير متاح مؤقتاً — مزوّد الدفع لدينا غير مهيَّأ بالكامل لهذا النطاق. الرجاء التواصل مع support@getpawlink.com وسنقوم بتفعيل الحماية لك.",
        checkout_config_test_token: "الدفع الآمن غير متاح مؤقتاً — مزوّد الدفع لدينا يعمل في وضع الاختبار على هذا النطاق. الرجاء التواصل مع support@getpawlink.com وسنقوم بتفعيل الحماية لك.",
        checkout_config_missing_price: "الدفع الآمن غير متاح مؤقتاً — تسعير الخطة غير مكتمل. الرجاء التواصل مع support@getpawlink.com وسنقوم بتفعيل الحماية لك.",
        cancel_manage: "إدارة الاشتراك أو إلغاؤه",
        cancel_confirm: "نعم، ألغِ في نهاية الفترة",
        cancel_back: "احتفظ بالحماية",
        canceling: "جارٍ الإلغاء…",
        cancel_ok: "سيتم إنهاء الاشتراك في نهاية الفترة الحالية.",
        cancel_error: "تعذّر الإلغاء الآن. حاول بعد لحظات.",
        emo_cta: "احمِ حيواني",
        emo_cta_premium: "الحماية مفعّلة",
        or_monthly: "تفضّل الاشتراك الشهريّ؟",
        billing_h: "الفوترة",
        billing_sub: "نستخدم Paddle للفوترة الآمنة. لتحديث البطاقة أو الإلغاء أو عرض الفواتير، اضغط أدناه.",
        billing_contact: "تواصل مع دعم الفوترة",
        // Premium page copy
        kicker_protection: "خطط PawLink",
        hero_title_pre: "لأن فقدانهم ليس خياراً",
        hero_sub: "طريقة أذكى لحماية من هم دائماً بجانبك.",
        protection_name: "PAWLINK PROTECTION",
        protection_name_short: "PawLink Protection",
        best: "الأفضل",
        best_value: "الأفضل قيمة",
        yearly_save_line: "وفّر ٥٠٪ · فقط $2.50/شهر",
        monthly_flex_line: "ألغِ في أي وقت — بدون التزام",
        cta: "فعّل الحماية",
        redirecting: "جارٍ التحويل إلى الدفع الآمن…",
        checkout_error: "تعذّر بدء الدفع. حاول مرة أخرى.",
        secure: "دفع آمن عبر Paddle",
        features: {
            smart_qr: {
                title: "QR ذكي + موقع مباشر",
                sub: "عندما يمسح أحدهم رمز حيوانك، تصلك الموقع فوراً وتتواصل بلمسة واحدة.",
            },
            passport: {
                title: "جواز الحيوان الرقمي",
                sub: "احفظ سجلات الطبيب والتطعيمات وأوراق السفر ووثائق مهمة جاهزة دائماً — في المطار أو عند الطبيب أو في أي مكان.",
            },
            rescue: {
                title: "تنبيه إنقاذ المجتمع",
                sub: "إذا ضاع حيوانك، أبلغ مستخدمي PawLink القريبين الذين يستطيعون المساعدة.",
            },
            identity: {
                title: "هوية حيوان كاملة",
                sub: "كل المعلومات المهمة في ملف واحد آمن: تفاصيل الرعاية، الاحتياجات، جهات الطوارئ والشخصية.",
            },
        },
        page_title: "طريقتان لحماية حيوانك الأليف.",
        page_sub: "ابدأ مجانًا. طوّر خطتك حين تحتاج تنبيهات أسرع ودعمًا أوسع.",
        free_name: "PawLink Free",
        free_tagline: "خطوة أولى بسيطة لإبقاء حيوانك الأليف على اتصال بك.",
        free_price: "0.00 CHF",
        free_billing_label: "إلى الأبد",
        free_feat_1_title: "ملف رقمي واحد لحيوانك",
        free_feat_1_sub: "احفظ الهوية الأساسية وبيانات التواصل في مكان واحد.",
        free_feat_2_title: "رمز QR ذكي فريد",
        free_feat_2_sub: "حمّله واطبعه وثبّته على أي بطاقة أو طوق.",
        free_feat_3_title: "صفحة إنقاذ فورية",
        free_feat_3_sub: "ساعِد من يجد حيوانك على التعرّف عليه والتواصل معك بسرعة.",
        free_feat_4_title: "بدون تطبيق",
        free_feat_4_sub: "يمكن لأي شخص مسح رمز QR مباشرة بهاتفه.",
        free_cta_web: "أنشئ ملفي المجاني",
        free_cta_android: "تابع مجاناً",
        recommended_badge: "موصى به",
        protection_name: "PawLink Protection",
        protection_tagline: "تنبيهات أسرع، دعم أوسع، وراحة بال أكبر.",
        protection_price_monthly: "9.90 CHF",
        protection_price_annual: "79.00 CHF",
        save_33: "وفّر 33٪",
        pro_feat_1_title: "كل ميزات PawLink Free",
        pro_feat_1_sub: "تبقى معك كل الحماية الأساسية.",
        pro_feat_2_title: "مشاركة موقع من يجد الحيوان",
        pro_feat_2_sub: "استلم موقعه إذا اختار مشاركته.",
        pro_feat_3_title: "تنبيهات مسح فورية",
        pro_feat_3_sub: "بريد فوري في اللحظة التي يُمسح فيها رمز QR.",
        pro_feat_4_title: "وضع المفقود",
        pro_feat_4_sub: "حوِّل الملف إلى صفحة إنقاذ عاجلة في ثوانٍ.",
        pro_feat_5_title: "خريطة الإنقاذ المجتمعية",
        pro_feat_5_sub: "وسِّع البحث بمساعدة أعضاء PawLink القريبين.",
        pro_feat_6_title: "تنبيهات مجتمعية قريبة",
        pro_feat_6_sub: "اصل إلى من هم قرب المنطقة المُبلّغ عنها حين يكون الوقت مهمًا.",
        pro_feat_7_title: "بطاقة إنقاذ كاملة",
        pro_feat_7_sub: "زوّد المنقذين بالمعلومات الطبية والسلوكية اللازمة.",
        pro_feat_8_title: "التطعيمات وجواز السفر",
        pro_feat_8_sub: "نظّم المستندات الصحية ومستندات السفر المهمة.",
        pro_feat_9_title: "ملفات متعددة للحيوانات",
        pro_feat_9_sub: "أدِر واحمِ جميع حيواناتك من حساب واحد.",
        pro_feat_10_title: "المشاهدات ونشاط الإنقاذ",
        pro_feat_10_sub: "تابع تحديثات المسح والمشاهدات المتاحة أثناء البحث.",
        cancel_anytime: "إلغاء في أي وقت",
        cta_choose_monthly: "اختر الحماية الشهرية",
        cta_choose_annual: "اختر الحماية السنوية",
        premium_active_line: "PawLink Protection مُفعّل.",
        annual_equivalent: "6.58 CHF / شهر، تُدفع سنويًا",
        checkout_awaiting_chf_configuration: "الدفع في انتظار تهيئة CHF عبر Paddle.",
        cta_protect_monthly: "احمِ حيواني — شهري",
        cta_protect_annual: "احمِ حيواني — سنوي",
        android_info_text: "اشتراكات PawLink Protection متاحة عبر موقع PawLink الرسمي.",
        android_already_subscribed: "أنا مشترك بالفعل",
        android_signin: "تسجيل الدخول",
        android_refresh: "تحديث الاشتراك",
        android_refreshing: "جارٍ التحديث…",
        android_refresh_ok: "تم تحديث الاشتراك.",
        android_refresh_err: "تعذّر التحديث الآن. يُرجى المحاولة لاحقًا.",
        trust_line: "أسعار واضحة بالفرنك السويسري (CHF). لا رسوم خفية. إلغاء في أي وقت. لا يحتاج الشخص الذي يجد حيوانك إلى تثبيت التطبيق.",
        free_price: "0.00 CHF",
    },
    scan_upgrade: {
        default_pet: "حيوانك الأليف",
        title: "شخص وجد {pet} ❤️",
        subtitle: "هذه اللحظة هي السبب وراء وجود PawLink. فعّل الحماية الكاملة ليصل إليك أي يد لطيفة تعينه على العودة إلى البيت في ثوانٍ.",
        u1_title: "تنبيهات مسح فورية",
        u1_sub: "لحظة مسح رمز QR، يضيء هاتفك.",
        u2_title: "موقع من عثر عليه",
        u2_sub: "شاهد بالضبط أين تم رصده على خريطة حقيقية.",
        u3_title: "رسالة صوتية باتجاهين",
        u3_sub: "صوتك يطمئنه حتى تصل إليه.",
        u4_title: "جواز سفر رقمي",
        u4_sub: "السجل البيطري، اللقاحات ووثائق السفر، دائمًا معك.",
        u5_title: "حيوانات بلا حد",
        u5_sub: "احمِ كل رفيق تحت خطة واحدة.",
        reassure: "لأنهم عائلة — والعائلة تستحق طريقًا إلى البيت.",
        cta_primary: "فعّل الحماية",
        cta_later: "لاحقًا",
        close: "إغلاق",
    },
    trial_offer: {
        title: "حيوانك الأليف تحت الحماية ❤️",
        subtitle: "افتح حماية PawLink الكاملة مجانًا لمدة 7 أيام. ألغِ في أي وقت — لن نخصم شيئًا حتى اليوم الثامن.",
        p1_title: "تنبيهات مسح فورية",
        p1_sub: "لحظة مسح رمز QR، يضيء هاتفك.",
        p2_title: "آخر موقع تم رصده",
        p2_sub: "شاهد بالضبط أين تم رصده على خريطة حية.",
        p3_title: "رسائل صوتية",
        p3_sub: "صوتك يطمئنه حتى تصل إليه.",
        p4_title: "جواز سفر رقمي",
        p4_sub: "السجل البيطري، اللقاحات ووثائق السفر، دائمًا معك.",
        p5_title: "المشاركة العائلية",
        p5_sub: "كل من في البيت يستلم التنبيه، وليس هاتفًا واحدًا.",
        p6_title: "حماية متقدمة",
        p6_sub: "حيوانات متعددة، شارات مكافأة، وثائق طبية.",
        billing_note: "ستختار الشهرية أو السنوية في الشاشة التالية. الخصم يبدأ فقط بعد انتهاء التجربة (7 أيام) — بدون مفاجآت.",
        cta_primary: "ابدأ حماية مجانية 7 أيام",
        cta_later: "لاحقًا",
        close: "إغلاق",
    },
    thankyou: {
        title: "شكرًا لثقتك في PawLink ❤️🐾",
        body: "حيوانك الأليف تحت الحماية الكاملة. يشرفنا مساعدتك في الحفاظ على سلامة أعزّ صديق.",
        badge: "حماية PawLink مفعّلة",
        cta: "متابعة",
        close: "إغلاق",
    },
    downgrade: {
        default_pet: "حيوانك الأليف",
        title: "ملف الإنقاذ الأساسي لـ {pet} لا يزال فعّالًا ❤️",
        sub: "قم بالترقية في أي وقت لاستعادة حماية PawLink الكاملة.",
        cta: "استعادة الحماية",
        dismiss: "ليس الآن",
    },
    protection: {
        active: "حماية PawLink مفعّلة",
        canceled_pending: "الحماية تظل فعّالة حتى تاريخ التجديد",
        trial_days: "حماية PawLink مفعّلة — تبقّى {days} يوم من تجربتك",
        trial_chip: "تجربة مجانية",
        plural_s: "",
        sub: "تنبيهات فورية، موقع دقيق، رسائل صوتية، جواز رقمي.",
    },

    health: {
        kicker: "الصحة والرعاية",
        setup_kicker: "لنبدأ",
        setup_h: "أنشئ ملف صحة حيوانك",
        setup_sub: "اختر طريقة البداية — يمكنك إضافة المزيد لاحقًا. المطلوب فقط الاسم والنوع.",
        setup_manual_h: "إضافة المعلومات يدويًا",
        setup_manual_sub: "املأ أقسامًا قصيرة بسهولة.",
        setup_scan_h: "امسح مستندًا موجودًا",
        setup_scan_sub: "التقط صورة لبطاقة التطعيمات أو جواز الحيوان وسنملأ الحقول تلقائيًا.",
        ai_badge: "ذكاء اصطناعي",
        overview_h: "نظرة عامة",
        stat_vaccinations: "التطعيمات",
        stat_documents: "المستندات",
        stat_reminders: "التذكيرات",
        last_updated: "تحديث {at}",
        manual_h: "بيانات الصحة والهوية",
        sec_identification: "التعريف",
        sec_health: "ملاحظات صحية",
        sec_vet: "الطبيب البيطري",
        sec_vaccinations: "التطعيمات والمواعيد",
        sec_reminders: "التذكيرات",
        sec_documents: "المستندات",
        sec_timeline: "الجدول الزمني",
        f_birth_date: "تاريخ الميلاد",
        f_sex: "الجنس",
        sex_unset: "غير محدد",
        sex_male: "ذكر",
        sex_female: "أنثى",
        sex_unknown: "غير معروف",
        f_microchip: "رقم الشريحة",
        f_microchip_ph: "مثال: 900123456789012",
        f_passport_id: "رقم الجواز",
        f_passport_id_ph: "مثال: CH-EU-…",
        f_allergies: "الحساسية",
        f_allergies_ph: "مثال: الفول السوداني",
        f_conditions: "الحالات الطبية",
        f_conditions_ph: "افصل بفواصل",
        f_medications: "الأدوية الحالية",
        f_medications_ph: "افصل بفواصل",
        f_medical_notes: "ملاحظات للطبيب",
        f_medical_notes_ph: "أي شيء يجب أن يعرفه الطبيب",
        f_vet_name: "اسم الطبيب",
        f_vet_phone: "هاتف الطبيب",
        f_vet_clinic: "العيادة",
        f_vacc_name: "اسم التطعيم",
        f_dose_date: "تاريخ الجرعة",
        f_next_due: "التالية",
        f_batch: "رقم الدفعة",
        f_note: "ملاحظات",
        save: "حفظ",
        saving: "جارٍ الحفظ…",
        cancel: "إلغاء",
        discard: "تجاهل",
        save_error: "تعذّر الحفظ. حاول مجددًا.",
        no_diagnosis_note: "PawLink يحفظ ملاحظاتك فقط، ولا يقدم تشخيصًا طبيًا.",
        vacc_add: "إضافة",
        vacc_empty: "لا توجد تطعيمات مسجلة بعد.",
        vacc_name_req: "أضف اسم التطعيم.",
        dose_short: "أُعطي",
        next_short: "التالية",
        confirm_remove_vacc: "إزالة التطعيم \"{name}\"؟",
        rem_empty: "لا توجد تذكيرات لهذا الحيوان بعد.",
        rem_overdue: "متأخرة",
        rem_due_soon: "قريبة",
        rem_completed: "منجزة",
        rem_mark_done: "تم",
        doc_scan: "امسح",
        doc_upload: "رفع",
        doc_empty: "لا توجد مستندات بعد. امسح شهادة للبدء.",
        doc_untitled: "مستند",
        uploading: "جارٍ الرفع…",
        view: "عرض",
        scan_title: "امسح مستندًا",
        scan_sub: "سنستخرج اسم الحيوان ومعلومات التطعيم والتواريخ والعيادة. ستراجع كل شيء قبل الحفظ.",
        scan_camera: "التقط صورة",
        scan_camera_sub: "استخدم الكاميرا لالتقاط الشهادة.",
        scan_upload: "رفع ملف",
        scan_upload_sub: "صورة أو PDF حتى 15 ميغابايت.",
        scanning: "جارٍ استخراج التفاصيل…",
        scan_privacy: "يُحفظ المستند الأصلي بأمان مع سجل حيوانك.",
        extract_error: "لم يتمكن الذكاء الاصطناعي من قراءة المستند. أضف التفاصيل يدويًا.",
        review_title: "راجع البيانات المستخرجة",
        review_sub: "لم يُحفظ شيء بعد. صحح الحقول المميزة ثم اضغط حفظ.",
        review_save: "حفظ",
        please_verify: "تأكّد",
        review_ai_note: "قد يخطئ الذكاء الاصطناعي. تحقّق من التواريخ والأرقام.",

        // ── اقتراح تذكير بعد التطعيم (يتطلب تأكيد المستخدم) ──
        rem_suggest_h: "أنشئ تذكيرًا؟",
        rem_suggest_h_vaccination: "أنشئ تذكيرًا للجرعة التالية؟",
        rem_suggest_h_appointment: "أنشئ تذكيرًا لهذا الموعد؟",
        rem_suggest_sub: "سنضيفه إلى تذكيراتك حتى لا تنسى. يمكنك تعديل أي شيء قبل التأكيد.",
        rem_suggest_open: "إنشاء تذكير",
        rem_suggest_existing: "يوجد تذكير مضبوط لهذا التطعيم",
        rem_dialog_title: "تذكير جديد",
        rem_dialog_sub: "سيُرسل PawLink إشعارًا قبل الموعد. عدّل ما تشاء أدناه.",
        rem_field_title: "العنوان",
        rem_field_date: "التاريخ",
        rem_field_time: "الوقت",
        rem_field_note: "ملاحظة (اختياري)",
        rem_field_notify: "أعلمني",
        rem_offset_7d: "قبل 7 أيام",
        rem_offset_1d: "قبل يوم",
        rem_offset_0d: "في اليوم نفسه",
        rem_confirm: "تأكيد التذكير",
        rem_confirming: "جارٍ التأكيد…",
        rem_never_auto: "لا يُنشأ شيء تلقائيًا — القرار دائمًا لك.",

        // ── مواعيد الطبيب البيطري ──
        sec_appointments: "مواعيد الطبيب البيطري",
        apt_add: "إضافة موعد",
        apt_empty: "لا توجد مواعيد بعد.",
        apt_f_date: "التاريخ",
        apt_f_time: "الوقت",
        apt_f_clinic: "العيادة",
        apt_f_vet: "الطبيب البيطري",
        apt_f_reason: "السبب",
        apt_f_reason_ph: "مثال: فحص سنوي، تنظيف أسنان",
        apt_f_notes: "ملاحظات",
        apt_f_notes_ph: "أي تفاصيل يجب تذكرها",
        apt_also_reminder: "أنشئ تذكيرًا أيضًا",
        apt_status_scheduled: "مجدول",
        apt_status_completed: "منجز",
        apt_status_cancelled: "ملغى",
        apt_mark_done: "وضع كمنجز",
        apt_edit: "تعديل",
        apt_delete: "حذف",
        apt_confirm_delete: "حذف هذا الموعد؟",
        apt_date_req: "اختر تاريخ الموعد.",
        apt_reason_default: "زيارة الطبيب",
    },

    walks: {
        kicker: "مشاوير قريبة",
        h1: "شوف من في الجوار",
        tagline: "حوّل مشوار عادي إلى لحظة PawLink دافئة.",
        cta_start: "نمشي الآن 🐾",
        start_title: "ابدأ مشوارًا قريبًا",
        pet: "الحيوان",
        duration: "المدة",
        min: "دقيقة",
        consent_text: "سيعرض PawLink حيوانك في منطقة قريبة تقريبية للمدة المحددة. يبقى موقعك الدقيق وبياناتك الشخصية خاصة.",
        cancel: "إلغاء",
        confirm_start: "ابدأ المشوار",
        starting: "جارٍ البدء…",
        end: "إنهاء المشوار",
        remaining: "المتبقّي",
        you_are_walking: "أنت تتمشى مع {name}",
        your_pet: "حيوانك",
        need_pet: "أضِف حيوانًا أولاً لبدء المشوار.",
        nearby_kicker: "قريبًا الآن",
        nearby_loading: "جارٍ البحث…",
        nearby_none: "لا يوجد أصدقاء PawLink يتمشّون قربك الآن.",
        nearby_count: "{n} من أصدقاء PawLink يتمشّون قربك 🐾",
        upgrade_to_see_pins: "اشترك في PawLink Protection لرؤية الحيوانات القريبة على الخريطة.",
        friend: "صديق PawLink",
        privacy_note: "تُعرض المناطق التقريبية فقط. لا يكشف PawLink اسمك أو هاتفك أو عنوانك أو موقعك الدقيق أو مسار مشوارك.",
        err_no_location: "نحتاج إذن الموقع لبدء مشوار أو رؤية الأصدقاء القريبين.",
        err_start: "تعذّر بدء المشوار. حاول مجددًا.",
        left_short: "متبقٍ",
        need_pet_h: "أضِف حيوانًا قبل بدء المشوار",
        need_pet_sub: "أنشئ ملفًا سريعًا لحيوانك: الاسم، الصورة، رقم هاتف لبطاقة QR. أقل من دقيقة.",
        create_pet_cta: "إنشاء ملف الحيوان",
        missing_pet: "الحيوان",
        missing_duration: "المدة",
        missing_consent: "الموافقة",
        missing_location: "الموقع",
        missing_location_hint: "نحتاج موقعك المباشر لتقريب دبوس المشوار. اضغط زر «مركّز عليّ» على الخريطة أولًا.",
    },
    care: {
        kicker: "PawLink Care",
        title: "تذكيرات الرعاية",
        add: "إضافة",
        empty_no_pets: "أضِف حيوانًا أولاً لإنشاء تذكير.",
        pet: "الحيوان",
        type: "النوع",
        title_label: "العنوان",
        title_placeholder: "مثال: جرعة داء الكلب المعزّزة",
        when: "متى",
        note: "ملاحظة (اختياري)",
        notify_me: "ذكّرني",
        offset_7d: "قبل 7 أيام",
        offset_1d: "قبل يوم",
        offset_0d: "في نفس اليوم",
        save: "حفظ التذكير",
        saving: "جارٍ الحفظ…",
        cancel: "إلغاء",
        err_save: "تعذّر الحفظ. حاول مجددًا.",
        tab_upcoming: "قادمة",
        tab_overdue: "متأخرة",
        tab_completed: "مكتملة",
        empty_upcoming: "لا يوجد شيء قادم.",
        empty_overdue: "لا يوجد شيء متأخر.",
        empty_completed: "لا توجد تذكيرات مكتملة بعد.",
        type_vaccination: "تطعيم",
        type_vet: "زيارة الطبيب",
        type_medication: "دواء",
        type_grooming: "استحمام وعناية",
        type_other: "أخرى",
        mark_done: "تمّت",
        delete: "حذف",
    },
};

const fr = {
    magic: {
        loading_title: "Connexion en cours…",
        loading_body: "Nous vérifions votre lien d'accès.",
        ok_title: "Bienvenue chez PawLink !",
        ok_body: "Connecté. Redirection vers votre tableau de bord…",
        error_title: "Lien invalide",
        error_generic: "Ce lien d'accès n'est plus valide. Demandez-en un nouveau depuis l'email ou connectez-vous à nouveau.",
        missing_title: "Lien manquant",
        missing_body: "Nous n'avons pas trouvé de lien d'accès valide dans cette URL. Utilisez le bouton de l'email que nous vous avons envoyé.",
        go_login: "Se connecter",
        get_help: "Obtenir de l'aide",
    },
    paddle_success: {
        headline: "Paiement reçu !",
        body: "Merci de vous être abonné à PawLink Protection. Toutes les fonctionnalités Premium sont maintenant actives.",
        check_inbox: "Vérifiez votre boîte mail — nous vous avons envoyé un lien magique pour accéder instantanément à votre compte.",
        no_email: "Vous ne le voyez pas ? Vérifiez les spams ou",
        contact_support: "contactez-nous",
    },
    lang: { name: "Français", dir: "ltr" },
    nav: { home: "Accueil", pricing: "Tarifs", dashboard: "Tableau", login: "Connexion", register: "Commencer", create_account: "Créer un compte", signout: "Déconnexion", plan_free: "Gratuit", plan_premium: "Premium", plan_trial: "Essai", menu: "Menu", back: "Retour", my_pets: "Mes animaux", my_qr: "Mes QR", scan_history: "Scans", notifications: "Notifications", account: "Compte", subscription: "Abonnement", protection: "Sécurité PawLink", safety: "Sécurité PawLink", rescue_center: "Centre de secours", community: "Communauté PawLink",
        local_walks: "Balades locales", lost_pets: "Animaux perdus", help: "Aide", faq: "FAQ", support: "Support", how_it_works: "Comment ça marche", view_all: "Voir toutes les notifications", open_scan: "Ouvrir le scan", view_map: "Voir sur la carte", no_pets_yet: "Aucun animal — ajoutez le premier", dash_pets: "Animaux", dash_status: "Statut", dash_status_safe: "Tous en sécurité", dash_status_lost: "{n} animal perdu", bn_home: "Accueil", bn_pets: "Animaux", bn_lost: "Perdus", bn_community: "Groupe", bn_safety: "Sécurité", bn_account: "Compte" },
    brand: { tagline: "Votre animal. Toujours le chemin du retour." },
    common: { save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier", back: "Retour", next: "Suivant", loading: "Chargement…", saving: "Enregistrement…", remove: "Supprimer", upload: "Envoyer", record: "Enregistrer", stop: "Arrêter" },
    landing: {
        chip: "ID QR intelligent",
        h1a: "Si votre animal se perd,",
        h1b: "aidez-le à retrouver le chemin de la maison ❤️",
        sub: "PawLink donne à votre meilleur ami un ID QR intelligent. S'il se perd, tout inconnu bienveillant peut scanner et vous joindre en secondes — sans app.",
        cta_primary: "Créer le profil",
        cta_secondary: "Voir comment ça marche",
        badge_privacy: "Vie privée d'abord",
        badge_dynamic: "QR dynamique",
        badge_love: "Fait avec amour",
        story_scan: "Quelqu'un a scanné la médaille de Milo",
        story_when: "À l'instant · rue X",
        story_reunited: "Milo rentre à la maison 🐾",
        protect_h: "Protégez votre meilleur ami dès aujourd'hui 🐾",
        protect_price: "9.90 CHF/mois  ·  79.00 CHF/an",
        protect_line: "Tranquillité d'esprit — parce que les perdre n'est pas une option.",
        protect_cta: "Activer PawLink Protection",
        how_over: "Comment ça marche",
        how_h2: "Trois étapes entre perdu et retrouvé.",
        step1_t: "🐶 Créer le profil",
        step1_d: "Photo, nom, notes santé et un message du cœur.",
        step2_t: "📱 Attacher le Smart QR",
        step2_d: "Imprimez sur médaille, collier ou sticker. Modifiez à tout moment.",
        step3_t: "❤️ Retrouvailles",
        step3_d: "On scanne, vous êtes alerté avec la position — voix, appel, c'est fait.",
        why_over: "Tranquillité intégrée",
        why_h2: "Tout ce qu'il faut pour qu'ils rentrent.",
        why_sub: "Chaque seconde compte quand un animal disparaît. PawLink est votre plan serein.",
        f1_t: "🔔 Alertes instantanées",
        f1_d: "Sachez dès qu'on scanne le QR.",
        f2_t: "📍 Dernière position",
        f2_d: "GPS ou ville — sur votre tableau de bord.",
        f3_t: "🎙 Messages vocaux",
        f3_d: "Votre voix rassure. La voix du finder vous parvient.",
        f4_t: "📞 Appel & WhatsApp",
        f4_d: "En un seul toucher.",
        f5_t: "🔒 Confidentialité",
        f5_d: "Vous décidez ce qu'un inconnu voit.",
        cta_h2: "Ils ne peuvent pas vous appeler. Mais un inconnu, oui.",
        cta_sub: "Offrez à votre animal le filet de sécurité qu'il mérite.",
        cta_btn: "Commencer gratuitement",
        cta_compare: "Voir les tarifs",
    },
    auth: {
        welcome: "Bon retour",
        sign_sub: "Connectez-vous pour gérer les profils.",
        create: "Créez votre compte",
        create_sub: "Commencez à protéger votre animal en moins de deux minutes.",
        email: "E-mail",
        password: "Mot de passe",
        password_hint: "Au moins 6 caractères",
        name: "Votre nom",
        signin: "Connexion",
        signing: "Connexion…",
        creating: "Création…",
        create_btn: "Créer un compte",
        no_account: "Pas de compte ?",
        have_account: "Déjà un compte ?",
        create_one: "En créer un",
        trouble_signing_in: "Problème de connexion ? Écrivez-nous à",
        sign_in: "Connexion",
        or_continue: "ou continuer avec e-mail",
        google_signin: "Se connecter avec Google",
        google_signup: "S’inscrire avec Google",
        welcome_h: "Bienvenue sur PawLink",
        welcome_sub: "Protégez votre animal en quelques secondes.",
        welcome_hi: "Salut ! 👋",
        welcome_footer: "En continuant vous acceptez nos conditions et notre politique de confidentialité.",
        forgot_password: "Oublié ?",
        forgot_title: "Réinitialiser votre mot de passe",
        forgot_sub: "Entrez votre e-mail — nous vous enverrons un lien sécurisé.",
        forgot_submit: "Envoyer le lien",
        forgot_sending: "Envoi…",
        forgot_sent_title: "Vérifiez votre boîte",
        forgot_sent_sub: "Si un compte existe pour cet e-mail, nous venons d'envoyer un lien de réinitialisation. Il expire dans 1 heure.",
        forgot_back_login: "Retour à la connexion",
        reset_title: "Définir un nouveau mot de passe",
        reset_sub: "Choisissez un mot de passe fort d'au moins 6 caractères. Vous serez connecté automatiquement.",
        reset_new: "Nouveau mot de passe",
        reset_confirm: "Confirmer le mot de passe",
        reset_submit: "Réinitialiser",
        reset_saving: "Enregistrement…",
        reset_success: "Mot de passe mis à jour. Redirection…",
        reset_mismatch: "Les mots de passe ne correspondent pas.",
        reset_invalid_link: "Ce lien est invalide ou expiré. Demandez-en un nouveau.",
        reset_no_token: "Jeton manquant. Réouvrez le lien depuis votre e-mail.",
    },
    dash: {
        welcome: "Bon retour",
        sub: "Gérez les ID numériques et partagez leur QR partout.",
        add_pet: "Ajouter un animal",
        upgrade: "Passer Premium",
        empty_h: "Aucun animal pour l’instant",
        empty_sub: "Créons l’ID numérique. Cela ne prend qu’une minute — et peut leur sauver la vie.",
        empty_cta: "Créer mon premier animal",
        pet_qr_h: " — QR",
        scan_share: "Scannez ou partagez ce lien :",
        select_pet: "Sélectionnez un animal pour voir son QR.",
        loading: "Chargement…",
        upgrade_download: "Passez Premium pour télécharger le QR (PNG/PDF) et débloquer les alertes de scan instantanées.",
        upgrade_inline: "Passer Premium",
        no_phone: "Pas de téléphone",
        finder_url: "URL finder :",
        recent_scans: "Scans récents",
        no_scans: "Aucun scan. Imprimez et partagez le QR pour commencer.",
        scan_gps: "GPS",
        scan_ip: "Localisation IP",
        notifications: "Notifications",
        no_notifications: "Vous êtes à jour.",
        mark_all_read: "Tout marquer comme lu",
        notif_scan: "Quelqu’un a scanné le QR de {pet}",
        notif_found: "{finder} a trouvé {pet}",
        just_now: "à l’instant",
        min_ago: "il y a {n} min",
        hr_ago: "il y a {n} h",
        day_ago: "il y a {n} j",
    },
    petform: {
        new_over: "Nouvel animal", edit_over: "Modifier",
        new_h: "Créer un profil",
        edit_h: "Modifier {name}",
        photo_h: "Photo",
        photo_sub: "Une photo claire aide à reconnaître votre animal.",
        upload_photo: "Envoyer une photo",
        about_h: "À propos de votre animal",
        pet_name: "Nom *",
        type: "Type *",
        type_dog: "Chien", type_cat: "Chat", type_other: "Autre",
        finder_message: "Message pour le finder",
        contact_h: "Contact",
        contact_sub: "Le téléphone est requis. Le reste est optionnel.",
        owner_name: "Votre nom",
        phone: "Numéro de téléphone *",
        whatsapp: "WhatsApp (optionnel)",
        city: "Ville",
        address: "Adresse complète (optionnel)",
        health_h: "Santé & Soins",
        allergies: "Allergies / aliments interdits",
        allergies_ph: "Allergique au poulet. Pas de chocolat.",
        medical: "Notes médicales",
        medical_ph: "Prend des médicaments. Anxieux avec les bruits forts.",
        voice_h: "Message vocal & récompense",
        voice_sub: "Enregistrez une voix apaisante pour votre animal.",
        voice_label: "Message vocal",
        reward: "Récompense (optionnel)",
        reward_ph: "100€ pour un retour sain et sauf",
        privacy_h: "Confidentialité",
        privacy_sub: "Choisissez ce qu’un finder voit.",
        p_phone: "Afficher mon numéro",
        p_name: "Afficher mon nom",
        p_city_only: "Ville seulement (recommandé)",
        p_address: "Adresse complète (avancé)",
        p_allergies: "Afficher les allergies",
        p_medical: "Afficher les notes médicales",
        p_reward: "Afficher la récompense",
        submit_create: "Créer",
        submit_edit: "Enregistrer",
        default_msg: "Si vous m’avez trouvé, appelez mon humain. Merci d’être gentil !",
        back_to_dash: "Retour au tableau",
        step_of: "Étape {n} sur {total}",
        continue: "Continuer",
        back: "Retour",
        protect_btn: "Protéger {name} 🐾",
        protect_generic: "Protéger mon animal 🐾",
        s1_h: "Rencontrez votre meilleur ami",
        s1_emoji: "🐾",
        s1_sub: "Créons un beau profil pour ce membre de la famille qui ne peut parler pour lui-même.",
        s1_photo_label: "Toucher pour ajouter une photo",
        s1_photo_hint: "Une belle photo aide à reconnaître votre animal en quelques secondes.",
        s1_change_photo: "Changer la photo",
        s1_name_ph: "ex. Milo",
        s1_breed_label: "Race (optionnel)",
        s1_breed_ph: "ex. Golden Retriever",
        s1_gender_label: "Sexe (optionnel)",
        gender_male: "Mâle",
        gender_female: "Femelle",
        gender_unknown: "Préfère ne pas dire",
        s2_h: "Aidez-les à rentrer",
        s2_emoji: "❤️",
        s2_sub: "Si quelqu'un trouve votre animal, voici comment il vous le ramène.",
        s2_privacy_note: "L'adresse complète est masquée par défaut. Vous pouvez changer cela plus tard.",
        s3_h: "Ce qu'un sauveteur doit savoir",
        s3_emoji: "🩺",
        s3_sub: "Des détails qui peuvent sauver la vie de votre animal.",
        s3_notes_label: "Notes spéciales (optionnel)",
        s3_notes_ph: "ex. Peureux · Adore les câlins · Pas de poulet",
        s4_h: "Un message du cœur",
        s4_emoji: "🎤",
        s4_sub: "Enregistrez une note vocale que la personne entendra dès le scan.",
        s4_example: "« Bonjour, je suis la maman de Milo. Merci de l'avoir trouvé. Appelez-moi ❤️ »",
        s4_written_label: "Ou écrivez un court message",
        s4_reward_label: "Récompense (optionnel)",
        s4_reward_hint: "Optionnel. Un petit merci motive les gens.",
        s5_h: "Confidentialité",
        s5_emoji: "🔒",
        s5_sub: "Choisissez ce que les inconnus voient en scannant le QR de {name}.",
        s5_sub_generic: "Choisissez ce que les inconnus voient en scannant le QR.",
        success_h: "{name} est protégé maintenant",
        success_h_generic: "Votre animal est protégé maintenant",
        success_sub: "Votre QR intelligent est prêt. Imprimez-le, attachez-le à son collier.",
        success_card_over: "Passeport numérique de l'animal",
        success_card_id: "ID PawLink",
        success_view_profile: "Voir le profil public",
        success_go_dashboard: "Aller au tableau",
        edit_saved: "Modifications enregistrées ❤️",
    },
    finder: {
        im_lost: "Je suis perdu, aidez-moi à rentrer",
        call: "Appeler le propriétaire",
        whatsapp: "WhatsApp",
        text: "SMS",
        whatsapp_optional: "Vous préférez WhatsApp ? Envoyer un WhatsApp",
        owner: "Propriétaire :",
        message_h: "Un message de mon humain",
        voice_h: "Message vocal",
        voice_sub: "Écouter mon humain peut me calmer.",
        voice_unsupported: "Votre navigateur ne peut pas lire cet audio.",
        voice_open_new: "Ouvrir l'audio dans un nouvel onglet",
        default_plea: "Salut ! Je suis {name}. Si vous m'avez trouvé, contactez ma famille pour me ramener à la maison. Merci ! ❤️",
        allergies_h: "Allergies & aliments interdits",
        medical_h: "Notes médicales",
        location_h: "Où j’habite",
        reward_h: "Récompense",
        personality_h: "Comment approcher {name}",
        passport_h: "Passeport de {name}",
        passport_sub: "Partagé par le propriétaire au cas où un vétérinaire ou une autorité en aurait besoin.",
        passport_view: "Voir",
        lost: {
            badge: "Perdu · Aidez-moi",
            pawlink_verified: "Vérifié par PawLink",
            headline_kicker: "Aidez-moi à rentrer",
            headline: "Je suis {name} — ma famille me cherche.",
            missing_for: "Perdu depuis {time}",
            call_cta: "Appeler ma famille",
            sms_cta: "Envoyer un SMS à ma famille",
            whatsapp_cta: "Message WhatsApp",
            plea_h: "Protégez-moi — j'ai peur",
            plea_default: "Gardez-moi en sécurité jusqu'à ce que ma famille arrive. Appelez le numéro ci-dessus et je serai bientôt à la maison. Merci, gentil inconnu. ❤️",
            reward_h: "Récompense au retour",
            lastseen_h: "Vu la dernière fois",
            view_on_map: "Voir sur la carte",
            medical_h: "Important — j'ai des besoins médicaux",
        },
        found_h: "Vous venez de trouver {name} ?",
        found_sub: "Appuyez sur le bouton, on prévient le propriétaire.",
        found_btn: "J’ai trouvé cet animal",
        thanks_h: "Merci — vous êtes un héros.",
        thanks_sub: "Nous avons prévenu {owner}. Restez près de l’animal si possible.",
        owner_generic: "le propriétaire",
        powered: "Propulsé par",
        tagline: "Nous ramenons les animaux perdus",
        tech_help: "Problème technique sur cette page ? Contactez PawLink à",
        modal_h: "Dites au propriétaire où vous êtes",
        modal_sub: "Vos informations aident à vous joindre vite.",
        f_name: "Votre nom (optionnel)",
        f_phone: "Votre téléphone (optionnel)",
        f_location: "Où êtes-vous ?",
        f_location_ph: "Rue X, coin de Y",
        f_message: "Message (optionnel)",
        f_voice: "Réponse vocale (optionnel)",
        share_location: "Partager ma position",
        location_sharing: "Partage…",
        location_shared: "Position partagée",
        submit: "Prévenir le propriétaire",
        sending: "Envoi…",
        cancel: "Annuler",
        not_found_h: "Profil introuvable",
        not_found_sub: "Ce QR a peut-être été supprimé.",
        go_home: "Accueil",
        voice_shortcut_h: "Vous ne pouvez pas écrire ? Envoyez un message vocal 🎙️",
        voice_shortcut_sub: "Une réponse vocale en un tap — le propriétaire de {name} l'entendra en quelques secondes.",
        voice_shortcut_send: "Envoyer la voix au propriétaire",
        voice_shortcut_sending: "Envoi…",
        voice_shortcut_sent_h: "Message vocal envoyé ❤️",
        voice_shortcut_sent_sub: "Le propriétaire de {name} vient de recevoir une notification avec votre voix.",
        voice_shortcut_default_msg: "Message vocal d'une personne qui l'a trouvé.",
        voice_shortcut_error: "Envoi impossible. Réessayez.",
        sighting_h: "Je l'ai vu 👀",
        sighting_sub: "Alerte d'observation en un tap. Le propriétaire de {name} reçoit votre position exacte et peut s'y rendre immédiatement.",
        sighting_send: "Je l'ai vu — envoyer ma position",
        sighting_locating: "Localisation en cours…",
        sighting_privacy: "🔒 Votre position est partagée une seule fois, uniquement avec le propriétaire.",
        sighting_default_msg: "Je viens de voir {name} tout près.",
        sighting_sent_h: "Observation envoyée 📍",
        sighting_sent_sub: "Le propriétaire de {name} arrive. Merci pour votre aide !",
        sighting_error: "Envoi impossible. Réessayez.",
    },
    community: {
        title: "Communauté PawLink",
        sub: "Une seule carte pour les animaux perdus, les balades locales et la communauté PawLink autour de vous.",
        privacy_h: "Votre présence sur la carte",
        privacy_sub: "Vous choisissez ce que voient les autres. Votre adresse exacte n'est jamais stockée — juste une épingle floue près de votre quartier.",
        vis_invisible: "Invisible",
        vis_invisible_sub: "Vous n'apparaissez sur aucune carte.",
        vis_approximate: "Approximatif",
        vis_approximate_sub: "Une épingle douce près de votre quartier — jamais votre adresse.",
        vis_helper: "Aide PawLink 🐾",
        vis_helper_sub: "Apparaissez comme aidant pour que les voisins sachent qu'ils peuvent compter sur vous.",
        location_needed_h: "Ajoutez votre quartier à la carte",
        location_needed_sub: "Un tap. Nous arrondissons à environ 1 km — aucune adresse n'est stockée.",
        share_approx_location: "Ajouter ma zone approximative",
        locating: "Localisation…",
        location_error: "Impossible d'enregistrer votre zone.",
        location_denied: "Autorisation de localisation refusée.",
        geo_unsupported: "Votre navigateur ne supporte pas la localisation.",
        visibility_error: "Impossible de mettre à jour la visibilité.",
        your_area: "Votre zone : {area}",
        helpers_near: "{count} aidants PawLink près de {area}",
        helpers_generic: "{count} aidants PawLink à proximité",
        helpers_sub: "Anonymes. Prêts à aider si un animal se perd dans votre zone.",
        protectors_near: "{count} protecteurs PawLink près de vous 🐾",
        protectors_generic: "{count} protecteurs PawLink près de vous 🐾",
        protectors_sub: "Une famille discrète de maîtres qui veillent les uns sur les autres — anonymes sur la carte, présents quand il le faut.",
        stat_helpers: "Aidants",
        stat_lost: "Perdus",
        stat_found: "Retrouvés",
        filter_all: "Tout",
        filter_lost: "Perdus",
        filter_walking_now: "En balade",
        walks_legend: "Marqueurs chaleureux = animaux en balade. Les marqueurs perdus et de secours restent visibles.",
        filter_helpers: "Communauté proche",
        filter_found: "Retrouvés",
        refresh: "Actualiser",
        legend_helper: "Aidant",
        legend_lost: "Perdu",
        legend_found: "Retrouvé",
        legend_walking: "En balade",
        you_are_here: "Vous",
        find_my_location: "Me localiser",
        center_on_me: "Centrer sur moi",
        distance_h: "Distance",
        map_visibility_h: "Visibilité sur la carte",
        map_visibility_hidden: "Masquée",
        map_visibility_approximate: "Approximative",
        map_visibility_live_approx: "En direct approximatif",
        map_visibility_change: "Modifier",
        km_unit: "km",
        pin_helper: "Aide PawLink",
        pin_helper_anon: "Gardien anonyme",
        pin_member: "Membre PawLink",
        avail_available: "Disponible",
        avail_busy: "Occupé",
        avail_offline: "Hors ligne",
        availability_h: "Ma disponibilité",
        rescue_count: "{n} sauvetages",
        radius_h: "Rayon",
        receive_alerts_h: "Recevoir les alertes",
        receive_alerts_sub: "Soyez notifié quand un animal a besoin d'aide près de chez vous. Vos coordonnées restent privées.",
        delete_location_cta: "Supprimer ma position",
        delete_location_confirm: "Effacer votre position communautaire ? Vous deviendrez invisible sur la carte.",
        lost_pet: "Animal perdu",
        recently_found: "Retrouvé récemment",
        last_seen: "Vu la dernière fois",
        distance_km: "à {km} km",
        view_pet: "Voir le profil",
        lost_nearby_h: "{count} animaux perdus près de vous",
        found_nearby_h: "{count} retrouvés récemment",
        location_unknown: "Position inconnue",
        popup_isaw: "Je l'ai vu",
        popup_ifound: "Je l'ai trouvé",
        popup_sighting_sending: "Envoi de votre position…",
        popup_sighting_sent: "Observation envoyée ❤️ Propriétaire prévenu.",
        guardians_city: "{count} gardiens PawLink protègent les animaux à {city} 🐾",
        guardians_sub: "Votre animal a des milliers d'yeux qui l'aident à rentrer.",
        sheet_missing: "Disparu",
        sheet_found_safe: "Retrouvé sain et sauf",
        sheet_reward: "Récompense",
        sheet_contact_owner: "Contacter le propriétaire",
        sheet_privacy: "Les positions ne sont partagées que si quelqu'un décide d'aider.",
        sheet_reunion_h: "Rentré à la maison, sain et sauf",
        sheet_reunion_sub: "{name} a récemment retrouvé sa famille grâce à la communauté PawLink. 🐾",
        live: "En direct",
        live_rescue_network: "Réseau de secours en direct",
        avatars_caption: "Gardiens à proximité — anonymes par défaut 🐾",
        helper_ready_h: "Aide PawLink — prêt à aider",
        helper_ready_sub: "Anonyme par défaut. Si un animal se perd tout près, ce voisin peut vous aider à le retrouver.",
        ticker_area_generic: "votre quartier",
        ticker_joined: "🐾 {name} vient de rejoindre la communauté PawLink",
        ticker_reunited: "❤️ {name} est rentré sain et sauf",
        ticker_someone_helping: "🔍 Quelqu'un aide à retrouver un animal perdu tout près",
        ticker_helper_joined_area: "📍 Un aide PawLink a rejoint à {area}",
        ticker_helpers_watching: "🛡️ {count} gardiens veillent sur {area}",
        ticker_helping_lost: "🐾 Des voisins aident à retrouver un animal perdu près d'ici",
        ticker_guardian_active: "✨ {name} est devenu(e) Gardien PawLink",
        rescue_alert_h: "🚨 {count} animal(aux) à secourir tout près",
        rescue_alert_sub: "Ouvrez la carte, signalez une observation ou appelez le propriétaire. Chaque seconde compte.",
        rescue_help_now: "Aider",
        locate_me: "Me localiser sur la carte",
        empty_first_guardian_h: "Soyez le premier Gardien PawLink de votre quartier 🐾",
        empty_first_guardian_sub: "Aucun animal perdu, aucun aidant, aucune retrouvaille autour de vous pour l'instant. Activez le mode Aidant pour devenir le premier regard qui veille sur les animaux du quartier.",
        empty_needs_location_h: "Votre carte de sauvetage vous attend",
        empty_needs_location_sub: "Ajoutez votre zone approximative pour voir les vrais membres PawLink, les alertes en direct et les retrouvailles autour de vous. Votre adresse exacte n'est jamais stockée.",
        empty_share_cta: "Ajouter ma zone approximative",
        empty_become_helper: "Devenir Aidant PawLink",
    },
    pricing: {
        eyebrow: "Tarifs",
        h1: "Simple et juste.",
        sub: "Découvrez PawLink gratuitement. Quand vous êtes prêt à protéger votre meilleur ami, activez PawLink Protection.",
        free_title: "GRATUIT",
        free_price: "$0",
        free_period: "",
        free_desc: "Découvrez PawLink et créez votre première carte d’identité numérique.",
        premium_title: "PAWLINK PROTECTION 🐾",
        premium_desc: "Parce que les perdre n’est pas une option ❤️",
        premium_line: "Un système de protection intelligent qui ramène votre meilleur ami à la maison en toute sécurité.",
        billing_monthly: "Mensuel",
        billing_yearly: "Annuel",
        price_monthly: "9.90 CHF",
        per_month: "/ mois",
        price_yearly: "79.00 CHF",
        per_year: "/ an",
        save_badge: "Meilleure valeur · $1.67/mois",
        recommended: "⭐ Meilleure valeur",
        free_list: [
            "Créez 1 profil",
            "Ajoutez photo et détails de base",
            "Aperçu de votre Smart ID",
            "Découvrez comment fonctionne la protection",
        ],
        free_footer: "L’activation du QR et les outils premium de sécurité nécessitent PawLink Protection.",
        premium_benefits: [
            { emoji: "🚨", title: "Mode Sauvetage Perdu", sub: "Alertes instantanées + lieu du scan quand quelqu'un retrouve votre meilleur ami." },
            { emoji: "📍", title: "Smart QR ID", sub: "N'importe qui peut scanner et vous contacter instantanément — sans app." },
            { emoji: "✈️", title: "Passeport numérique", sub: "Vaccins, dossiers vétérinaires et documents de voyage toujours prêts." },
            { emoji: "❤️", title: "Profil Santé & Urgence", sub: "Allergies, besoins médicaux et personnalité au même endroit." },
            { emoji: "👨‍👩‍👧", title: "Contacts famille de confiance", sub: "Vos proches peuvent aider à les ramener sains et saufs." },
            { emoji: "🐾", title: "Protection multi-animaux", sub: "Protégez chaque chien ou chat que vous aimez depuis un seul compte." },
        ],
        one_scan: "Un scan peut les ramener à la maison 🐾",
        your_plan: "Votre plan",
        upgrade: "Activer PawLink Protection",
        get_free: "Commencer gratuitement",
        go_dash: "Aller au tableau",
        redirecting: "Redirection…",
        on_premium: "Vous êtes protégé",
        secure: "Paiement sécurisé Paddle. Annulez à tout moment.",
    },
    payment: {
        checking_h: "Confirmation du paiement…",
        checking_sub: "Une petite seconde.",
        paid_h: "Bienvenue en Premium !",
        paid_sub: "Vous avez débloqué le téléchargement QR (PNG & PDF), les alertes de scan instantanées, la dernière position et les réponses vocales.",
        go_dash: "Aller au tableau",
        expired_h: "Session expirée",
        expired_sub: "Votre session a expiré. Réessayez.",
        back_pricing: "Retour aux tarifs",
        pending_h: "Traitement en cours…",
        pending_sub: "Cela prend plus de temps que d’habitude.",
        continue: "Continuer",
        error_h: "Un souci",
        error_sub: "Impossible de vérifier le paiement. Contactez le support si vous avez été débité.",
    },
    langpicker: {
        title: "Choisissez votre langue",
        sub: "Vous pouvez la changer plus tard.",
        continue: "Continuer",
    },
    theme: { light: "Clair", dark: "Sombre", system: "Système" },
    account: {
        eyebrow: "Votre compte",
        title_greeting: "Bonjour, {name}",
        header_edit: "Modifier le profil",
        section_profile: "Informations personnelles",
        section_prefs: "Préférences",
        section_privacy: "Confidentialité et sécurité",
        community_vis_h: "Visibilité sur la carte de la communauté",
        community_vis_sub: "Contrôle votre apparition sous « Communauté proche » sur la carte partagée. La position exacte et les coordonnées personnelles ne sont jamais partagées.",
        community_vis_hidden: "Masqué",
        community_vis_approximate: "Visible approximativement",
        section_help: "Aide et support",
        section_legal: "Mentions légales",
        section_help_legal: "Aide et mentions légales",
        f_name: "Nom complet",
        f_name_ph: "Votre nom",
        f_name_hint_google: "Importé depuis votre compte Google.",
        f_email: "Email",
        f_email_hint: "Contactez le support pour changer votre email.",
        f_phone: "Numéro de téléphone",
        f_phone_ph: "Optionnel — utilisé pour les alertes",
        f_country: "Pays",
        f_country_ph: "France",
        save: "Enregistrer",
        saving: "Enregistrement…",
        saved: "Enregistré",
        pref_language: "Langue",
        pref_appearance: "Apparence",
        pref_appearance_hint: "Suivez votre système ou choisissez.",
        pref_notifications: "Notifications dans l'app",
        pref_notifications_hint: "Recevez les alertes de scan dans PawLink.",
        priv_public_h: "Profil public de l'animal",
        priv_public_sub: "Lorsqu'un inconnu scanne votre QR, il ne voit que la photo, le nom et le contact choisis. Votre adresse n'est jamais partagée.",
        priv_public_manage: "Gérez la visibilité par animal dans Mes animaux.",
        priv_password_h: "Changer le mot de passe",
        priv_password_google: "Vous vous connectez avec Google — pas de mot de passe à changer ici.",
        priv_password_current: "Mot de passe actuel",
        priv_password_new: "Nouveau mot de passe (min. 8 caractères)",
        priv_password_save: "Mettre à jour",
        priv_password_ok: "Mot de passe mis à jour.",
        priv_delete_h: "Supprimer le compte",
        priv_delete_sub: "Supprimer définitivement votre compte, vos animaux, l'historique et les messages. Irréversible.",
        priv_delete_help: "Besoin d’aide pour la suppression du compte ? Contactez-nous à",
        priv_delete_btn: "Supprimer mon compte",
        priv_delete_confirm_h: "Vraiment sûr ?",
        priv_delete_confirm_sub: "Tapez DELETE pour confirmer. Tout sera effacé.",
        priv_delete_placeholder: "Tapez DELETE",
        priv_delete_yes: "Oui, supprimer",
        priv_delete_cancel: "Garder mon compte",
        help_center: "Centre d'aide",
        help_contact: "Contacter le support",
        help_faq: "FAQ",
        help_report: "Signaler un problème",
        legal_terms: "Conditions d'utilisation",
        legal_privacy: "Politique de confidentialité",
        logout: "Déconnexion",
    },
    qr: { locked_h: "Téléchargement QR : Premium", locked_sub: "Passez à 9.90 CHF/mois pour télécharger PNG et PDF imprimable.", locked_cta: "Débloquer", png: "Télécharger PNG", pdf: "PDF imprimable", scan_hint: "Imprimez ce QR sur une médaille, un collier ou un autocollant.", downloading: "Préparation…", pdf_headline: "Si vous m'avez trouvé, scannez-moi", pdf_sub: "Cette médaille est protégée par PawLink — la personne qui vous scanne verra la photo, les allergies, les notes médicales et pourra vous contacter en un tap.", pdf_scan_here: "SCANNEZ ICI", pdf_url_label: "Ou visitez", pdf_footer: "PawLink — Médaille QR intelligente · getpawlink.com", page_h: "Vos QR intelligents", page_sub: "Téléchargez, imprimez ou partagez la médaille de chaque animal — collier, autocollant, poster ou carte de secours.", public_link: "Lien public", empty_h: "Aucun QR pour l'instant", empty_sub: "Créez d'abord un animal — nous générerons un QR intelligent qui ramène les animaux à la maison." },
    pets_page: {
        hero_kicker: "Votre famille",
        hero_h: "Tous à la maison. Tous en sécurité.",
        hero_sub: "Chaque animal a un QR intelligent. S'il se perd, une personne peut le ramener en quelques secondes.",
        add_pet: "Ajouter un membre",
        error_title: "Impossible de charger vos animaux",
        error_sub: "Le serveur ne répond pas. Vérifiez votre connexion et réessayez — vos données sont en sécurité.",
        error_retry: "Réessayer",
        status_active: "Protégé",
        status_lost: "Perdu",
        status_sub: "Identité numérique active",
        status_ready: "Prêt si {name} se perd",
        badge_qr: "QR actif",
        act_view: "Voir le profil",
        act_qr: "Code QR",
        act_edit: "Modifier",
        act_delete: "Supprimer",
        protected_line: "{name} est protégé",
        lost_line: "{name} est perdu — l'aide est en route",
        safety_h: "Centre de sécurité",
        safety_sub: "Mode perdu · Personnalité · Passeport",
        safety_lost_h: "{name} est en mode perdu",
        safety_lost_sub: "Ouvrir le tableau d'urgence",
        confirm_delete: "Supprimer le profil de {name} ? Irréversible.",
        cancel: "Annuler",
        empty_h: "Rencontrez votre meilleur ami",
        empty_sub: "Créez son passeport numérique. 2 minutes pour peut-être le ramener à la maison à jamais.",
        empty_cta: "Protéger mon animal",
        trust_h_one: "Votre meilleur ami est en sécurité.",
        trust_h_many: "Vos {count} meilleurs amis sont en sécurité.",
        trust_sub: "Chaque scan vous envoie sa position en direct. Vous n'êtes jamais qu'à un tap de le ramener.",
    },
    home_story: {
        hero_eyebrow: "PawLink · ID intelligent",
        hero_h_a: "Quand ils se perdent…",
        hero_h_a2: "Ils ne peuvent dire à personne où est la maison.",
        hero_h_b: "PawLink le peut.",
        hero_sub: "Parce que l'amour est le chemin le plus rapide vers la maison.",
        hero_cta_primary: "Protéger mon meilleur ami",
        hero_cta_secondary: "Voir comment ça marche",
        hero_scroll: "Voir comment ça marche",
        pill_scan: "Scan · Contact · Retrouvailles",
        s1_kicker: "Scène 01 · Le scan",
        s1_h: "Quelqu'un trouve votre meilleur ami.",
        s1_sub: "Un inconnu scanne l'étiquette PawLink. La seconde d'après, il voit sa photo, entend votre voix et vous joint en un tap. Aucune appli à installer, aucune inscription. Juste de la gentillesse — connectée à l'instant.",
        s1_note_title: "Nouveau scan · Centre-ville",
        s1_note_body: "Un passant vient de scanner l'étiquette de Milo.",
        s2_kicker: "Scène 02 · Mode Perdu",
        s2_h: "Votre meilleur ami est perdu.",
        s2_sub: "Activez le Mode Perdu. Chaque scan vous envoie une position GPS. Votre quartier devient une équipe de recherche — votre récompense, votre message et sa photo voyagent partout où va l'étiquette.",
        s2_chip: "PERDU · Aidez-nous",
        s2_stat: "Recherche en direct",
        how_kicker: "Comment PawLink fonctionne",
        how_h: "Trois étapes simples pour le ramener à la maison.",
        how_sub: "PawLink est un service numérique — votre QR intelligent est prêt en quelques minutes, pas des jours.",
        how_1_h: "Créez le profil PawLink de votre animal",
        how_1_sub: "Ajoutez la photo de l'animal, son nom, les options de contact du propriétaire, ses informations médicales et les détails que le propriétaire choisit de partager.",
        how_2_h: "Générez et attachez le QR intelligent",
        how_2_sub: "PawLink génère un QR unique que le propriétaire peut télécharger, imprimer et attacher au collier ou à la médaille de l'animal.",
        how_3_h: "Un scan connecte celui qui l'a trouvé au propriétaire",
        how_3_sub: "Quand quelqu'un scanne le QR, il voit immédiatement la Rescue Card avec la photo, le nom et les boutons de contact approuvés par le propriétaire. Le propriétaire reçoit une alerte de scan instantanée avec la localisation lorsque disponible.",
        benefits_kicker: "Pourquoi PawLink",
        benefits_h: "Tout ce dont vous avez besoin pour les ramener à la maison.",
        big_b1_h: "Passeport numérique de votre animal",
        big_b1_sub: "Plus besoin de transporter des documents. Le passeport, le carnet de vaccinations, l'assurance, le certificat antirabique et l'historique médical de votre animal sont toujours avec vous — prêts pour un voyage ou une visite chez le vétérinaire.",
        big_b2_h: "Centre de sauvetage",
        big_b2_sub: "Signalez votre chien perdu et activez le mode Perdu. Suivez sa position GPS en direct et obtenez un itinéraire précis pour le ramener à la maison en toute sécurité.",
        big_b3_h: "QR intelligent",
        big_b3_sub: "Téléchargez le QR numérique unique de votre animal et utilisez-le comme vous voulez — imprimez-le à la maison, ajoutez-le à une médaille ou un accessoire que vous possédez déjà, ou partagez-le sous forme d'autocollant. Quand quelqu'un le scanne, vous recevez une notification instantanée et la personne peut vous contacter immédiatement pour vous aider à retrouver votre animal.",
        big_b4_h: "Carte PawLink",
        big_b4_sub: "Connectez-vous avec les membres PawLink à proximité qui peuvent vous aider à rechercher et à retrouver votre animal.",
        benefits_close: "Ne vous inquiétez pas. Nous sommes là chaque fois que vous en avez besoin.",
        // Legacy 6-tile benefits — kept for backward compatibility (not currently rendered on Home)
        hb1_h: "Communauté de Sauvetage PawLink",
        hb1_sub: "Si votre animal disparaît, vous n'êtes pas seul. Les membres PawLink à proximité peuvent rejoindre les recherches et aider à le ramener à la maison.",
        hb2_h: "QR Intelligent + Alertes de Scan Instantanées",
        hb2_sub: "Créez un QR unique pour votre animal et recevez une alerte immédiate dans l'appli et par email dès qu'on le scanne — avec l'heure et la localisation quand disponibles.",
        hb3_h: "Rescue Card Intelligente",
        hb3_sub: "Après le scan, la personne voit une rescue card sobre contenant uniquement ce que le propriétaire a choisi — photo, nom, bouton d'appel, WhatsApp, avertissement médical, récompense et notes d'urgence.",
        hb4_h: "Passeport Numérique de l'Animal",
        hb4_sub: "Regroupez les informations essentielles de vaccination, de voyage et d'identification dans un seul endroit numérique sécurisé.",
        hb5_h: "Carte de Sauvetage PawLink",
        hb5_sub: "Découvrez les membres PawLink à proximité et l'activité de sauvetage autour de vous, pour que l'aide soit plus proche quand votre animal disparaît.",
        hb6_h: "Dossiers Médicaux Toujours Disponibles",
        hb6_sub: "Conservez allergies, médicaments, informations médicales et coordonnées vétérinaires afin qu'ils soient disponibles lors des visites, urgences et voyages.",
        reviews_kicker: "Aimé par les propriétaires",
        reviews_h: "De vraies retrouvailles. De vraies familles.",
        review_1_body: "Quelqu'un a scanné le QR de Luna et elle était de retour à la maison le jour même. J'en pleure encore.",
        review_1_author: "Emily · Maman de chien",
        review_2_body: "La meilleure protection que j'ai achetée pour mon chien. Simple, ça vaut chaque euro, et je dors mieux la nuit.",
        review_2_author: "James · Membre PawLink",
        family_kicker: "Rejoignez la famille PawLink 🐾❤️",
        family_h_none: "Des maîtres qui protègent leur meilleur ami — avant qu'il n'arrive quelque chose.",
        family_h_one: "Vous en faites partie. Un nom, un cœur, un filet de sécurité.",
        family_h_many: "Vous en faites partie. {count} noms. {count} cœurs. Un filet de sécurité.",
        family_sub: "Une communauté discrète de familles qui choisissent d'être prêtes. Tout le monde à la maison. Tout le monde en sécurité.",
        family_cta: "Ajouter un autre animal",
        family_cta_manage: "Gérer mes animaux",
        family_cta_first: "Créer votre premier animal",
        final_kicker: "PawLink Protection",
        final_h: "Si vous aimez vraiment votre meilleur ami, protégez-le aujourd'hui ❤️",
        final_sub: "N'attendez pas le jour où vous regretterez de ne pas l'avoir fait plus tôt. 4,99 $ / mois · 29,99 $ / an. Annulez à tout moment.",
        final_cta_upgrade: "Protéger mon meilleur ami",
        final_cta_manage: "Gérer l'abonnement",
        final_active: "Protection active",
    },
    home_protection: {
        eyebrow: "Une seule protection. Une seule famille.",
        heading: "Offrez-leur le chemin le plus sûr vers la maison",
        body: "Voyez exactement ce que débloque la Protection PawLink — des alertes de scan instantanées à une communauté de sauvetage qui aide à ramener les animaux perdus plus vite.",
        cta: "Voir PawLink Protection",
    },
    install: {
        title: "Protégez votre animal en moins d'une minute.",
        subtitle: "Installez PawLink directement depuis notre site et commencez à protéger votre animal dès aujourd'hui. Pas de recherche sur l'App Store. Pas de configuration compliquée. Vous installez, vous créez le profil, c'est prêt.",
        cta: "Installer PawLink",
        cta_installing: "Installation…",
        cta_installed: "Installé",
        cta_open: "Ouvrir PawLink",
        desktop_qr_title: "Scannez pour installer PawLink instantanément.",
        desktop_qr_sub: "Pointez la caméra de votre téléphone vers ce code — vous continuerez l'installation sur votre appareil.",
        badge_secure: "Installation sécurisée",
        badge_free: "Téléchargement gratuit",
        badge_fast: "Configuration rapide",
        badge_updates: "Mises à jour automatiques",
        ios_modal_title: "Installer PawLink sur iPhone",
        ios_modal_sub: "Dans Safari, touchez l'icône Partager puis \"Sur l'écran d'accueil\".",
        ios_step_1: "Touchez l'icône Partager en bas de Safari.",
        ios_step_2: "Choisissez \"Sur l'écran d'accueil\".",
        ios_step_3: "Appuyez sur Ajouter — PawLink est maintenant sur votre écran d'accueil.",
        ios_modal_close: "Compris",
        already_installed_hint: "Déjà installé ? Ouvrez PawLink depuis votre écran d'accueil.",
        phone_caption: "La carte de secours que votre animal portera.",
        ios_coming_kicker: "Bientôt sur l'App Store",
        ios_coming_title: "PawLink pour iPhone arrive.",
        ios_coming_sub: "Nous finalisons la version App Store. En attendant, vous pouvez déjà protéger votre animal — toutes les fonctionnalités marchent parfaitement sur le web.",
        ios_meanwhile_label: "En attendant",
        ios_meanwhile_body: "Créez votre compte PawLink maintenant et protégez votre animal depuis Safari — aucune installation requise.",
        share_cta: "Partager PawLink",
        share_title: "Partager PawLink",
        share_sub: "Aidez un autre animal à rentrer chez lui sain et sauf — partagez PawLink avec vos amis et votre famille.",
        share_message: "PawLink — l'identifiant QR intelligent qui aide à ramener les animaux perdus à la maison. Essayez gratuitement :",
        share_whatsapp: "WhatsApp",
        share_facebook: "Facebook",
        share_x: "X",
        share_email: "E-mail",
        share_copy: "Copier le lien",
        share_copied: "Lien copié",
        share_close: "Fermer",
        petcard_verified: "PawLink Vérifié",
        petcard_qr_id: "ID QR",
        petcard_vaccinations: "Vaccinations",
        petcard_up_to_date: "À jour",
        petcard_allergies: "Allergies",
        petcard_medical: "Notes médicales",
        petcard_owner: "Propriétaire",
        petcard_emergency: "Urgence",
        petcard_documents: "Documents",
        petcard_passport: "Passeport · Carnet vétérinaire",
        petcard_updated: "Mise à jour",
        petcard_updated_time: "il y a 2 jours",
        petcard_pet_name: "Coco",
        petcard_pet_breed: "Caniche Toy · Femelle",
        petcard_allergy_value: "Protéine de poulet",
        petcard_medical_value: "Aucune",
        petcard_owner_value: "Léa M.",
        petcard_none: "Aucune",
        // Rescue scan mockup (public finder view shown on Home)
        petcard_scan_title: "QR scanné avec succès",
        petcard_scan_sub: "Cet animal a une famille qui l'attend.",
        petcard_age: "Âge",
        petcard_age_value: "3 ans",
        petcard_gender: "Sexe",
        petcard_gender_value: "Femelle",
        petcard_reward: "Récompense au retour",
        petcard_reward_value: "200 $",
        petcard_notes: "Notes d'urgence",
        petcard_notes_value: "Très douce. Merci de la garder calme et hydratée jusqu'à notre arrivée.",
        petcard_call: "Appeler le propriétaire",
        petcard_whatsapp: "WhatsApp",
    },
    home_pricing: {
        eyebrow: "Tarifs simples et honnêtes",
        heading: "Gratuit à vie — Protection quand ça compte le plus",
        sub: "Commencez gratuitement. Passez au premium seulement quand vous voulez les extras qui font de PawLink un vrai réseau de sauvetage.",
        hero_get_started: "Commencer — c'est gratuit",
        free_title: "Gratuit",
        free_price: "0 €",
        free_sub: "Tout ce qu'il faut pour les ramener à la maison.",
        free_f1: "1 profil animal avec QR intelligent",
        free_f2: "Alertes de scan en temps réel",
        free_f3: "Outils de contact de base",
        free_cta: "Créer un compte gratuit",
        pro_title: "Protection PawLink",
        pro_price: "29,99 €",
        pro_period: "/an",
        pro_sub: "Ou 4,99 €/mois · annulable à tout moment",
        pro_badge: "Le plus aimé",
        pro_f1: "Animaux et profils illimités",
        pro_f2: "Passeport numérique et dossier médical",
        pro_f3: "Carte de sauvetage communautaire",
        pro_f4: "Messages vocaux bidirectionnels",
        pro_f5: "Support de réunion prioritaire",
        pro_cta: "Obtenir la Protection",
        see_all: "Comparer toutes les fonctionnalités",
    },
    home_faq: {
        eyebrow: "Questions & réponses",
        heading: "Tout ce qu'un propriétaire demande avant de rejoindre PawLink",
        q1_q: "Comment fonctionne le QR intelligent ?",
        q1_a: "Vous téléchargez le QR numérique unique de votre animal depuis sa page et l'utilisez comme vous voulez — imprimez-le à la maison, ajoutez-le à une médaille ou un collier que vous possédez déjà, ou partagez-le comme autocollant. Toute personne qui pointe son téléphone dessus ouvre une belle page publique avec le nom de votre animal et comment vous joindre — sans app ni compte de son côté.",
        q2_q: "Que se passe-t-il quand mon animal est scanné ?",
        q2_a: "Vous recevez une notification instantanée avec la localisation du bon samaritain (traduite en ville / rue), tout message vocal laissé, et un moyen direct de le rappeler.",
        q3_q: "Partagez-vous mon adresse exacte ?",
        q3_a: "Jamais. Le trouveur ne voit que ce que vous choisissez d'afficher. La Carte utilise une localisation approximative — votre adresse reste toujours privée.",
        q4_q: "Puis-je annuler la Protection à tout moment ?",
        q4_a: "Oui. Gérez ou annulez en un tap depuis Réglages. Votre profil gratuit — et tout l'historique de scans — reste à vous pour toujours.",
        see_all: "Voir la FAQ complète",
    },
    rescue: {
        title: "Chaque sauvetage, au même endroit.",
        sub: "Alertes, scans et contacts — toute l'activité de sauvetage de votre animal, réunie.",
        tab_alerts: "Alertes",
        tab_scans: "Historique des scans",
        filter_all: "Tous les animaux",
        call_finder: "Appeler",
        sms_finder: "Envoyer SMS",
        empty_alerts_h: "Vous êtes à jour.",
        empty_alerts_sub: "Aucune alerte pour le moment. Dès qu'une personne scanne votre QR intelligent, vous le verrez ici en direct avec la position GPS et son message éventuel.",
        empty_scans_h: "Aucun scan pour le moment.",
        empty_scans_sub: "Imprimez votre QR intelligent sur une médaille ou un collier. Dès qu'il sera scanné, vous verrez où et quand — ici même.",
        finder_voice_h: "Message vocal de la personne qui l'a trouvé",
        rescue_alert_line: "🚨 Un animal près de chez vous a besoin d'aide — {pet} · {km} km",
        rescue_alert_open: "Voir les détails du sauvetage",
        delete_alert: "Supprimer l'alerte",
        confirm_delete: "Supprimer cette alerte ? Cette action est irréversible.",
    },
    legal: {
        back: "Retour au compte",
        updated: "Mise à jour",
        privacy_kicker: "Légal · Confidentialité",
        privacy_title: "Vos données, protégées.",
        privacy_sub: "Exactement ce que PawLink collecte, comment nous l'utilisons et vos contrôles.",
        terms_kicker: "Légal · Conditions",
        terms_title: "Conditions d'utilisation",
        terms_sub: "Des conditions simples et humaines pour utiliser PawLink.",
        faq_kicker: "Support · FAQ",
        faq_title: "Les questions des propriétaires.",
        faq_sub: "Tout ce que vous pourriez vous demander sur les QR intelligents et la Protection.",
        support_kicker: "Support",
        support_title: "Nous sommes là pour vous et votre animal.",
        support_sub: "Envoyez-nous un message, réponse sous un jour ouvré généralement.",
    },
    support: {
        email_label: "Écrivez-nous",
        email_hint: "Pour les cas urgents, un email atteint toujours un humain.",
        faq_label: "En autonomie",
        faq_title: "Consulter la FAQ",
        faq_hint: "Les réponses que nous donnons chaque semaine.",
        form_title: "Envoyez-nous un message",
        form_sub: "Dites-nous ce qui se passe, nous prenons le relais.",
        cat_account: "Compte",
        cat_billing: "Facturation",
        cat_bug: "Bug",
        cat_safety: "Sécurité animale",
        cat_other: "Autre",
        f_category: "Catégorie",
        f_email: "Votre email",
        f_subject: "Sujet",
        f_subject_ph: "Un court résumé",
        f_message: "Message",
        f_message_ph: "Partagez le plus de détails possible — les IDs de commande ou de scan aident à vous aider plus vite.",
        send: "Envoyer",
        sending: "Envoi…",
        sent_ok: "Message envoyé. À bientôt.",
    },
    qr_detail: {
        back: "Retour aux animaux",
        kicker: "ID numérique de l'animal",
        protection_badge: "Protégé par PawLink",
        pet_id: "ID PawLink",
        scan_h: "Comment utiliser ce QR",
        scan_1: "Imprimez-le sur une médaille, un autocollant, un collier ou une carte",
        scan_2: "Attachez-le à ce que votre animal porte toujours",
        scan_3: "S'il se perd, celui qui le trouve vous joint en un tap",
        actions_download_png: "Télécharger PNG",
        actions_download_pdf: "Télécharger PDF",
        actions_print: "Imprimer",
        actions_share: "Partager",
        share_title_prefix: "Trouver",
        share_text: "Si vous m'avez trouvé, scannez ce QR et ramenez-moi à la maison ❤️",
        tags_h: "Voir sur de vraies médailles",
        tags_sub: "Imaginez votre animal portant votre QR PawLink. Téléchargez le QR à tout moment et imprimez-le vous-même sur une médaille ou un collier que vous possédez déjà — PawLink est un service numérique et ne vend aucun produit physique.",
        tag_stainless: "Acier inox",
        tag_bone: "Forme os",
        tag_black: "Noir premium",
        tag_gold: "Or premium",
        tag_silicone: "Silicone",
        tag_sticker: "Autocollant",
        tag_wallet: "Carte portefeuille",
        premium_gate_h: "Télécharger le QR de {name} — Premium",
        premium_gate_sub: "Passez à 9.90 CHF/mois pour télécharger, imprimer et partager le QR de {name} partout.",
        premium_gate_cta: "Débloquer ce QR",
        premium_gate_preview: "Vous pouvez prévisualiser le design — le téléchargement se débloque avec Protection.",
        passport_reassure: "Si {name} est trouvé, ce code le ramène à vous.",
        live_indicator: "En direct",
    },
    safety: {
        kicker: "Centre de sécurité",
        title: "Protéger {name}",
        sub: "Mode urgence, traits de personnalité et documents prêts pour le voyage — tout ce qui garde {name} en sécurité chaque jour.",
        back_to_pets: "Retour aux animaux",
        pet_not_found: "Animal introuvable",
        tab_emergency: "Alerte",
        tab_personality: "Traits",
        tab_passport: "Passeport",
        tab_health: "Santé",
        hero_safe: "Actuellement en sécurité",
        sos_kicker: "Mode urgence",
        sos_h: "Si {name} venait à se perdre",
        sos_sub: "Un tap transforme le QR public de {name} en page d'alerte complète — avec votre contact, dernier endroit vu et récompense.",
        sos_cta: "Signaler {name} disparu",
        sos_reassure: "Vous pouvez le désactiver dès que {name} est de retour à la maison.",
        step_s1_h: "Appuyez sur SOS",
        step_s1_d: "Un bouton bascule le QR en mode urgence instantanément.",
        step_s2_h: "Les inconnus voient votre alerte",
        step_s2_d: "Bannière rouge, bouton d'appel, récompense et dernier lieu.",
        step_s3_h: "Vous ramenez {name}",
        step_s3_d: "Chaque scan vous alerte. Réunissez la famille.",
        modal_h: "Signaler {name} disparu",
        modal_sub: "Cela change la page QR publique en mode urgence instantanément.",
        f_last_seen: "Dernier lieu vu",
        f_last_seen_ph: "ex. Parc Riverside près de la porte ouest",
        f_reward: "Récompense (optionnel)",
        f_reward_ph: "ex. $200",
        f_instructions: "Note pour la personne qui le trouve",
        f_instructions_ph: "ex. {name} est timide — ne le poursuivez pas. Appelez-moi et je viendrai.",
        gps_sharing: "Lecture de votre position…",
        gps_ok: "Votre position enregistrée comme point de départ",
        gps_off: "Localisation désactivée — ce n'est pas grave, vous pouvez taper une adresse.",
        gps_idle: "Nous capturons votre position si vous le permettez.",
        activate_now: "Activer le mode Perdu",
        activating: "Activation…",
        activate_error: "Activation impossible. Réessayez.",
        activate_fineprint: "Vous pouvez marquer {name} en sécurité à tout moment.",
        status_lost: "Mode perdu actif",
        missing_for: "Perdu depuis {time}",
        missing_now: "Signalé à l'instant",
        stat_scans: "Scans depuis la disparition",
        stat_qr: "QR public",
        stat_qr_on: "En mode urgence",
        share_h: "Partager l'alerte",
        copied: "Lien copié",
        copy_link: "Copier le lien",
        share_msg: "Au secours — mon chien {name} est perdu ! Partagez ce lien pour qu'on le ramène : {url}",
        mark_safe_cta: "{name} est en sécurité — le ramener",
        rescue_alert_h: "Alerter les Gardiens à proximité",
        rescue_alert_sub: "Notifiez chaque Gardien PawLink volontaire dans le rayon choisi. Ils voient la photo et la zone approximative — jamais votre téléphone ni votre adresse.",
        rescue_alert_send: "Envoyer l'alerte aux Gardiens à {r} km",
        rescue_alert_sending: "Envoi de l'alerte…",
        rescue_alert_result: "Alerte envoyée à {n} Gardien(s) dans un rayon de {r} km ❤️",
        rescue_alert_error: "Envoi impossible. Réessayez.",
        rescue_alert_privacy: "Nous partageons uniquement le nom, la photo et la zone approximative. Votre identité reste privée.",
        confirm_safe: "Marquer {name} retrouvé et en sécurité ? Cela désactive le mode perdu.",
        preview_h: "Ce que voit un sauveteur maintenant",
        preview_line1: "🚨 {name} est perdu — aidez s'il vous plaît.",
        preview_line2: "Le bouton d'appel, la récompense et vos instructions sont bien en évidence.",
        preview_cta: "Prévisualiser la page publique",
        elapsed_d: "{d}j",
        elapsed_h: "{h}h",
        elapsed_m: "{m}min",
        elapsed_now: "à l'instant",
        personality: {
            h: "Comment approcher {name}",
            sub: "Cochez chaque étiquette qui correspond à {name}. Les inconnus qui scannent le QR les verront — pour savoir comment interagir.",
            g_friendly: "Bonnes vibes",
            g_friendly_sub: "Dites aux sauveteurs ce que {name} aime.",
            g_careful: "Avec précaution",
            g_careful_sub: "Ce à quoi un inconnu doit faire attention.",
            g_medical: "Médical & alimentation",
            g_medical_sub: "Pour que personne ne se trompe de nourriture ou de médicament.",
            save_cta: "Enregistrer",
            no_changes: "Tout est à jour",
        },
        p: {
            friendly_people: "Amical avec les humains",
            friendly_dogs: "Amical avec les chiens",
            friendly_cats: "Amical avec les chats",
            good_children: "Bien avec les enfants",
            trained: "Bien dressé",
            energetic: "Énergique et joueur",
            nervous: "Anxieux / nerveux",
            needs_space: "A besoin d'espace",
            do_not_approach: "Ne pas approcher sans propriétaire",
            medical_needs: "A des besoins médicaux",
            special_diet: "Régime spécial",
            needs_medication: "A besoin de médicaments",
        },
        passport: {
            brand: "Passeport numérique",
            g_health: "Vaccins & santé",
            g_vet: "Vétérinaire & certificats",
            g_insurance: "Assurance",
            g_travel: "Voyage & autres",
            empty_h: "Aucun document",
            empty_sub: "Téléchargez le certificat antirabique de {name}, les vaccins ou l'assurance — plus de papier à porter.",
            add_h: "Ajouter un document",
            add_sub: "PDF ou photo. Vous seul le voyez sauf si vous le rendez public.",
            upload_cta: "Ajouter le document",
        },
        dockind: {
            vaccine: "Vaccination",
            rabies: "Certificat antirabique",
            vet: "Document vétérinaire",
            medical: "Dossier médical",
            insurance: "Assurance",
            travel: "Document de voyage",
            other: "Autre",
        },
        f_doc_name: "Nom du document",
        f_doc_name_ph: "ex. Rage 2026",
        f_doc_kind: "Type",
        uploading: "Envoi…",
        upload_error: "Échec du téléchargement. Réessayez.",
        saved: "Enregistré",
        view: "Voir",
        public_on: "Visible aux sauveteurs (public)",
        public_off: "Vous seul le voyez (privé)",
        public_on_hint: "La personne qui scanne le QR peut voir ce document.",
        public_off_hint: "Privé — pour vous seulement.",
        tt_public: "Public — visible aux sauveteurs",
        tt_private: "Privé — pour vous seulement",
        confirm_remove_doc: 'Supprimer "{name}" ? Irréversible.',
    },
    premium_soon: {
        badge: "Bientôt disponible",
        chip: "Premium",
        title: "Premium arrive bientôt 🐾",
        body: "Cette fonctionnalité fait partie de PawLink Premium. Les abonnements Premium seront bientôt disponibles.",
        free_hint: "En attendant, vous pouvez continuer à utiliser les fonctionnalités gratuites de PawLink.",
        ok: "Compris",
    },
    subscription: {
        title_active: "PawLink Protection est actif",
        title_choose: "Parce que les perdre n'est pas une option ❤️",
        sub_active: "Vous protégez votre meilleur ami avec notre plan le plus avancé. Merci de veiller sur lui.",
        sub_choose: "Une façon plus intelligente de protéger ceux qui sont toujours à vos côtés.",
        current_plan: "Votre plan actuel",
        plan_free_name: "Plan gratuit",
        plan_premium_name: "PawLink Protection",
        plan_free_meta: "1 profil d'animal · Aperçu uniquement",
        plan_premium_meta: "Renouvellement automatique · Annulez à tout moment",
        active: "Actif",
        upgrade_cta: "Passer à Protection",
        benefits_h: "Ce qui est inclus",
        emotional_sub: "Une façon plus intelligente de protéger ceux qui sont toujours à vos côtés.",
        cancel_anytime: "Annulez à tout moment",
        get_started: "Commencer",
        best_value_sub: "Meilleure valeur · ~$1.25/mois",
        choose_yearly: "Choisir l'annuel",
        family_reassure: "Vous protégez un membre de la famille — pas un simple QR code.",
        emo_hero_title: "Et si votre animal se perdait aujourd'hui ?",
        emo_hero_sub: "Il ne peut pas donner votre numéro à un inconnu. PawLink peut le ramener chez vous.",
        compact_title: "Et s'il se perdait ?",
        compact_sub: "Soyez alerté. Voyez sa position. Retrouvez-le plus vite.",
        hero_new_title: "Protégez votre meilleur ami — même quand vous n'êtes pas là",
        hero_new_sub: "Un seul scan permet à celui qui le retrouve de vous joindre plus vite.",
        b1_title: "Alerte perte instantanée",
        b1_sub: "Sachez au moment où quelqu'un retrouve votre meilleur ami.",
        b2_title: "Lieu du scan",
        b2_sub: "Voyez exactement où le QR a été scanné.",
        b3_title: "Contact en un tap",
        b3_sub: "La personne qui l'a trouvé vous joint instantanément — aucune appli requise.",
        b4_title: "Passeport numérique",
        b4_sub: "Dossier vétérinaire, vaccins et papiers de voyage toujours avec vous.",
        b5_title: "Message vocal",
        b5_sub: "Laissez votre voix le rassurer jusqu'à vos retrouvailles.",
        b6_title: "Protection QR intelligente",
        b6_sub: "Un chemin plus rapide vers la maison quand ils ont besoin de vous.",
        // v7.41 — 6 features (FR)
        f1_title: "Communauté de Sauvetage PawLink",
        f1_tagline: "Si votre animal disparaît, vous n'êtes jamais seul. Les membres PawLink à proximité peuvent aider à le chercher via la Communauté de Sauvetage.",
        f1_line1: "Une seule famille.",
        f1_line2: "Une seule mission.",
        f1_line3: "Ramener chaque animal à la maison.",
        f2_title: "Protection QR Intelligente & Alertes Instantanées",
        f2_tagline: "Dès que quelqu'un scanne le QR de votre animal, vous recevez instantanément une notification et un e-mail — pour agir en secondes, pas en heures.",
        f2_line1: "Notification push",
        f2_line2: "Notification email",
        f2_line3: "Heure du scan",
        f2_footer: "Sachez immédiatement quand quelqu'un a trouvé votre meilleur ami.",
        f3_title: "Carte de Sauvetage Intelligente",
        f3_tagline: "Un scan révèle une belle carte de sauvetage — photo, nom, alertes médicales, récompense, et boutons Appel et WhatsApp qui vous joignent instantanément.",
        f3_line1: "Photo de l'animal",
        f3_line2: "Nom de l'animal",
        f3_line3: "Bouton d'appel",
        f3_line4: "Bouton WhatsApp",
        f3_line5: "Alerte médicale",
        f3_line6: "Récompense (optionnel)",
        f3_line7: "Notes d'urgence",
        f3_footer: "Le propriétaire contrôle complètement ce qui est visible. La confidentialité passe toujours en premier.",
        f4_title: "Passeport Numérique",
        f4_tagline: "Gardez les informations importantes de votre animal en un seul endroit sécurisé. Vaccinations, informations de voyage et dossiers essentiels toujours disponibles.",
        f5_title: "Carte de Sauvetage PawLink",
        f5_tagline: "Voyez les membres PawLink à proximité et l'activité de sauvetage autour de vous. Quand votre animal disparaît, la carte vous met en contact avec des utilisateurs proches qui peuvent l'aider à revenir plus vite.",
        f6_title: "Dossiers Médicaux Toujours Avec Vous",
        f6_tagline: "Vaccinations, allergies, médicaments et coordonnées du vétérinaire — stockés en sécurité et prêts quand cela compte.",
        f6_line1: "Informations médicales",
        f6_line2: "Allergies",
        f6_line3: "Médicaments",
        f6_line4: "Informations vétérinaires",
        f6_footer: "Plus de papiers à transporter. Tout est disponible instantanément lors des visites, urgences ou voyages.",
        emotional_close: "Rejoignez la communauté PawLink — protégez votre animal dès aujourd'hui.",
        // v7.42 — Two-plan selector (FR)
        pick_a_plan_aria: "Choisir un plan",
        plan_monthly_label: "Mensuel",
        plan_yearly_label: "Annuel",
        plan_monthly_note: "Annulez à tout moment",
        plan_yearly_note: "Économisez 50 % vs mensuel",
        plan_yearly_badge: "Meilleure offre",
        per_month: "/ mois",
        per_year: "/ an",
        selected_prefix: "Vous avez choisi :",
        cta_new: "Commencez votre essai gratuit de 7 jours 🐾",
        cta_open_browser: "Ouvrir dans le navigateur pour s'abonner →",
        store_free_h: "PawLink est gratuit sur cette application",
        store_free_sub: "Vous pouvez utiliser toutes les fonctionnalités principales de PawLink sur Android gratuitement — aucun abonnement n'est requis dans cette application. Les profils de vos animaux, le QR intelligent, le mode Perdu et les notifications sont tous disponibles gratuitement.",
        early_access_chip: "Membre fondateur · Accès anticipé",
        early_access_h: "Bienvenue dans PawLink Accès Anticipé 🐾",
        early_access_sub: "PawLink est nouveau — et vous êtes en avance. Profitez des fonctionnalités de protection de PawLink pendant notre période d'accès anticipé pendant que nous continuons à construire PawLink pour les familles d'animaux du monde entier.",
        early_access_note: "Vous êtes l'un des premiers membres de PawLink. Des offres Premium et des fonctionnalités supplémentaires arriveront à l'avenir.",
        ea_welcome_h: "Vous êtes un membre PawLink de la première heure 🧡",
        ea_welcome_sub: "Merci de nous rejoindre tôt. Configurez le profil de votre animal et son QR intelligent sans frais — les fonctionnalités PawLink Premium supplémentaires (mode Perdu, carte PawLink de sauvetage, suivi en direct) arrivent bientôt.",
        ea_welcome_dismiss: "Compris",
        trial_title: "Votre essai gratuit de 7 jours",
        trial_day0: "Jour 0 — Toutes les fonctionnalités débloquées, gratuitement.",
        trial_day5: "Jour 5 — Nous vous rappelons avant la fin de l'essai.",
        trial_day7: "Jour 7 — La protection PawLink commence.",
        urgency_line: "Les animaux perdus n'attendent pas. Soyez prêt avant que ça n'arrive. ❤️",
        family_line: "Parce qu'ils font partie de la famille — et la famille mérite un chemin de retour",
        billing_help: "Questions de facturation ou d’abonnement ? Écrivez-nous à",
        benefit_short_1: "Alerte live",
        benefit_short_2: "Position live",
        benefit_short_3: "Vie privée",
        journey_kicker: "Le parcours de sauvetage",
        journey_title: "Perdu → Scan → Alerte → À la maison",
        journey_1_title: "Quelqu'un a trouvé Max",
        journey_1_sub: "Alerte instantanée sur votre téléphone.",
        journey_2_title: "Dernière position connue",
        journey_2_sub: "Sachez exactement où le QR a été scanné.",
        journey_3_title: "Contact en un tap",
        journey_3_sub: "La personne qui l'a trouvé vous joint aussitôt.",
        journey_4_title: "Privé et sécurisé",
        journey_4_sub: "Votre adresse reste toujours cachée.",
        best_protection: "Meilleure protection",
        cancel_line: "Aucun débit aujourd'hui · Annulez en un clic à tout moment.",
        cardholder_hint: "Veuillez saisir le nom exactement comme il apparaît sur votre carte — lettres, espaces, tirets (-) et apostrophes (') uniquement. Les chiffres ou symboles ne sont pas acceptés par notre prestataire de paiement.",
        cardholder_helper: "Astuce : saisissez le nom du titulaire de la carte en lettres latines — les espaces, tirets (-) et apostrophes (') sont acceptés.",
        invalid_browser_locale: "Votre navigateur signale un paramètre de langue inhabituel qui empêche le chargement du paiement sécurisé. Veuillez modifier la langue du navigateur ou du système pour une valeur standard (p. ex. Français) et recharger, ou contactez support@getpawlink.com et nous activerons la Protection pour vous.",
        checkout_config_missing_token: "Le paiement sécurisé est temporairement indisponible — notre configuration de paiement manque sur ce déploiement. Contactez support@getpawlink.com et nous activerons la Protection pour vous.",
        checkout_config_wrong_env: "Le paiement sécurisé est temporairement indisponible — notre prestataire de paiement n'est pas entièrement configuré pour ce domaine. Contactez support@getpawlink.com et nous activerons la Protection pour vous.",
        checkout_config_test_token: "Le paiement sécurisé est temporairement indisponible — notre prestataire de paiement fonctionne en mode test sur ce domaine. Contactez support@getpawlink.com et nous activerons la Protection pour vous.",
        checkout_config_missing_price: "Le paiement sécurisé est temporairement indisponible — la tarification n'est pas entièrement configurée. Contactez support@getpawlink.com et nous activerons la Protection pour vous.",
        cancel_manage: "Gérer ou annuler l'abonnement",
        cancel_confirm: "Oui, annuler à la fin de la période",
        cancel_back: "Garder ma Protection",
        canceling: "Annulation…",
        cancel_ok: "L'abonnement prendra fin à la fin de la période en cours.",
        cancel_error: "Annulation impossible pour l'instant. Réessayez dans un instant.",
        emo_cta: "Protéger mon animal",
        emo_cta_premium: "La protection est active",
        or_monthly: "Préférez le mensuel ?",
        billing_h: "Facturation",
        billing_sub: "Nous utilisons Paddle pour une facturation sécurisée. Pour mettre à jour votre carte, annuler ou voir vos factures, cliquez ci-dessous.",
        billing_contact: "Contacter le support facturation",
        // Premium page copy
        kicker_protection: "Forfaits PawLink",
        hero_title_pre: "Parce que les perdre n'est pas une option",
        hero_sub: "Une façon plus intelligente de protéger ceux qui sont toujours à vos côtés.",
        protection_name: "PAWLINK PROTECTION",
        protection_name_short: "PawLink Protection",
        best: "Le mieux",
        best_value: "Meilleure valeur",
        yearly_save_line: "Économisez 33 % · 6,58 CHF/mois, facturé annuellement",
        monthly_flex_line: "Annulez à tout moment — sans engagement",
        cta: "Activer Protection",
        redirecting: "Redirection vers le paiement sécurisé…",
        checkout_error: "Impossible de démarrer le paiement. Réessayez.",
        secure: "Paiement sécurisé avec Paddle",
        features: {
            smart_qr: {
                title: "QR intelligent + Localisation live",
                sub: "Quand quelqu'un scanne le QR de votre animal, recevez la localisation instantanément et connectez-vous en un tap.",
            },
            passport: {
                title: "Passeport numérique",
                sub: "Gardez les carnets vétérinaires, vaccins, papiers de voyage et documents importants toujours prêts — à l'aéroport, chez le vétérinaire ou partout.",
            },
            rescue: {
                title: "Alerte de sauvetage communautaire",
                sub: "Si votre animal disparaît, alertez les utilisateurs PawLink à proximité qui peuvent aider.",
            },
            identity: {
                title: "Identité animale complète",
                sub: "Toutes les infos importantes dans un profil sécurisé : soins, besoins, contacts d'urgence et personnalité.",
            },
        },
    },


    footer: { product: "Produit", pricing: "Tarifs", create_profile: "Créer un profil", sign_in: "Connexion", trust: "Confiance & Légal", trust1: "Vie privée d’abord.", trust2: "QR dynamique — modifiez quand vous voulez.", trust3: "Fait avec soin pour animaux et humains.", tag: "Ramenez-les à la maison.", support: "Support", contact_us: "Nous contacter", help_center: "Centre d’aide" },
    scanloc: {
        exact: "GPS exact",
        exact_acc: "GPS exact · ±{m} m",
        coarse: "GPS approx.",
        coarse_acc: "GPS approx. · ±{m} m",
        approx: "Localisation approximative",
        unknown: "Localisation inconnue",
        open_exact: "Ouvrir le point exact sur Google Maps",
        open_coarse: "Ouvrir le point approx. sur Google Maps",
        open_area: "Ouvrir la zone sur Google Maps",
        open_in_maps: "Ouvrir dans Google Maps",
        page_title: "Deux façons de protéger votre animal.",
        page_sub: "Commencez gratuitement. Passez au niveau supérieur pour des alertes plus rapides et un soutien plus large.",
        free_name: "PawLink Free",
        free_tagline: "Un premier pas simple pour rester connecté à votre animal.",
        free_price: "0,00 CHF",
        free_billing_label: "Pour toujours",
        free_feat_1_title: "1 profil numérique d’animal",
        free_feat_1_sub: "Rassemblez identité et contacts essentiels au même endroit.",
        free_feat_2_title: "QR Code intelligent unique",
        free_feat_2_sub: "Téléchargez-le, imprimez-le et fixez-le sur une médaille ou un collier.",
        free_feat_3_title: "Page de secours instantanée",
        free_feat_3_sub: "Aidez la personne qui le retrouve à le reconnaître et à vous joindre.",
        free_feat_4_title: "Aucune application requise",
        free_feat_4_sub: "N’importe qui peut scanner le QR code directement avec son téléphone.",
        free_cta_web: "Créer mon profil gratuit",
        free_cta_android: "Continuer en gratuit",
        recommended_badge: "Recommandé",
        protection_name: "PawLink Protection",
        protection_tagline: "Alertes plus rapides, soutien plus large, plus de sérénité.",
        protection_price_monthly: "9,90 CHF",
        protection_price_annual: "79,00 CHF",
        save_33: "Économisez 33 %",
        pro_feat_1_title: "Tout PawLink Free",
        pro_feat_1_sub: "Toute la protection essentielle reste incluse.",
        pro_feat_2_title: "Partage de position du finder",
        pro_feat_2_sub: "Recevez sa position s’il choisit de la partager.",
        pro_feat_3_title: "Alertes de scan instantanées",
        pro_feat_3_sub: "Un e-mail dès que le QR code est scanné.",
        pro_feat_4_title: "Mode Perdu",
        pro_feat_4_sub: "Transformez le profil en page de recherche urgente en quelques secondes.",
        pro_feat_5_title: "Carte de la communauté de secours",
        pro_feat_5_sub: "Élargissez la recherche avec l’aide des membres PawLink à proximité.",
        pro_feat_6_title: "Alertes de proximité",
        pro_feat_6_sub: "Touchez les personnes proches de la zone signalée quand le temps compte.",
        pro_feat_7_title: "Fiche de secours complète",
        pro_feat_7_sub: "Donnez aux sauveteurs les infos médicales et comportementales utiles.",
        pro_feat_8_title: "Vaccins et passeport",
        pro_feat_8_sub: "Organisez les documents de santé et de voyage importants.",
        pro_feat_9_title: "Plusieurs profils d’animaux",
        pro_feat_9_sub: "Gérez et protégez tous vos animaux depuis un seul compte.",
        pro_feat_10_title: "Signalements et activité",
        pro_feat_10_sub: "Suivez les scans et signalements disponibles pendant la recherche.",
        cancel_anytime: "Annulez à tout moment",
        cta_choose_monthly: "Choisir Protection mensuelle",
        cta_choose_annual: "Choisir Protection annuelle",
        premium_active_line: "PawLink Protection est actif.",
        annual_equivalent: "6,58 CHF / mois, facturé annuellement",
        checkout_awaiting_chf_configuration: "Paiement en attente de la configuration Paddle CHF.",
        cta_protect_monthly: "Protéger mon animal — Mensuel",
        cta_protect_annual: "Protéger mon animal — Annuel",
        android_info_text: "Les abonnements PawLink Protection sont disponibles sur le site officiel PawLink.",
        android_already_subscribed: "Je suis déjà abonné",
        android_signin: "Se connecter",
        android_refresh: "Actualiser l’abonnement",
        android_refreshing: "Actualisation…",
        android_refresh_ok: "Abonnement actualisé.",
        android_refresh_err: "Impossible d’actualiser maintenant. Veuillez réessayer.",
        trust_line: "Tarifs clairs en CHF. Pas de frais cachés. Annulez à tout moment. Aucune installation d’app requise pour la personne qui retrouve votre animal.",
        free_price: "0,00 CHF",
    },
    scan_upgrade: {
        default_pet: "votre animal",
        title: "Quelqu'un a trouvé {pet} ❤️",
        subtitle: "C'est pour ce moment que PawLink existe. Activez la protection complète pour que la prochaine main qui l'aide à rentrer puisse vous joindre en quelques secondes.",
        u1_title: "Alertes de scan instantanées",
        u1_sub: "Dès qu'on scanne le QR, votre téléphone s'allume.",
        u2_title: "Localisation du sauveteur",
        u2_sub: "Voyez exactement où il a été retrouvé, sur une vraie carte.",
        u3_title: "Message vocal à double sens",
        u3_sub: "Votre voix le rassure jusqu'à votre arrivée.",
        u4_title: "Passeport numérique",
        u4_sub: "Carnet de santé, vaccins et papiers de voyage, toujours avec vous.",
        u5_title: "Animaux illimités",
        u5_sub: "Protégez chaque compagnon avec un seul abonnement.",
        reassure: "Parce qu'ils font partie de la famille — et la famille mérite un chemin de retour.",
        cta_primary: "Activer la Protection",
        cta_later: "Plus tard",
        close: "Fermer",
    },
    trial_offer: {
        title: "Votre animal est protégé ❤️",
        subtitle: "Débloquez la protection complète PawLink gratuitement pendant 7 jours. Annulez à tout moment — aucun débit avant le 8ème jour.",
        p1_title: "Alertes de scan instantanées",
        p1_sub: "Dès qu'on scanne le QR, votre téléphone s'allume.",
        p2_title: "Dernière localisation",
        p2_sub: "Voyez exactement où il a été aperçu sur une carte en temps réel.",
        p3_title: "Messages vocaux",
        p3_sub: "Votre voix le rassure jusqu'à votre arrivée.",
        p4_title: "Passeport numérique",
        p4_sub: "Carnet de santé, vaccins et papiers de voyage, toujours avec vous.",
        p5_title: "Partage familial",
        p5_sub: "Toute la famille reçoit les alertes, pas juste un téléphone.",
        p6_title: "Protection avancée",
        p6_sub: "Animaux multiples, badges de récompense, documents médicaux.",
        billing_note: "Vous choisirez Mensuel ou Annuel à l'écran suivant. Nous ne facturons qu'après vos 7 jours d'essai — sans surprise.",
        cta_primary: "Démarrer 7 jours de Protection gratuite",
        cta_later: "Plus tard",
        close: "Fermer",
    },
    thankyou: {
        title: "Merci de faire confiance à PawLink ❤️🐾",
        body: "Votre animal est entièrement protégé. C'est un honneur de vous aider à garder votre meilleur ami en sécurité.",
        badge: "Protection PawLink Active",
        cta: "Continuer",
        close: "Fermer",
    magic: {
        loading_title: "Iniciando sesión…",
        loading_body: "Estamos verificando tu enlace de acceso.",
        ok_title: "¡Bienvenido a PawLink!",
        ok_body: "Sesión iniciada. Llevándote al panel…",
        error_title: "Enlace no válido",
        error_generic: "Este enlace de acceso ya no es válido. Solicita uno nuevo desde el correo o vuelve a iniciar sesión.",
        missing_title: "Falta el enlace",
        missing_body: "No encontramos un enlace de acceso válido en esta URL. Usa el botón del correo que te enviamos.",
        go_login: "Iniciar sesión",
        get_help: "Obtener ayuda",
    },
    paddle_success: {
        headline: "¡Pago recibido!",
        body: "Gracias por suscribirte a PawLink Protection. Todas las funciones Premium ya están activas.",
        check_inbox: "Revisa tu correo — te enviamos un enlace mágico para acceder a tu cuenta al instante.",
        no_email: "¿No lo ves? Revisa spam o",
        contact_support: "contáctanos",
    },
    },
    downgrade: {
        default_pet: "votre animal",
        title: "Le profil de sauvetage de base de {pet} reste actif ❤️",
        sub: "Réactivez à tout moment pour restaurer la protection complète PawLink.",
        cta: "Restaurer la Protection",
        dismiss: "Pas maintenant",
    },
    protection: {
        active: "Protection PawLink active",
        canceled_pending: "La protection reste active jusqu'à la date de renouvellement",
        trial_days: "Protection PawLink active — encore {days} jour{s} d'essai",
        trial_chip: "Essai gratuit",
        plural_s: "s",
        sub: "Alertes instantanées, localisation précise, messages vocaux, passeport numérique.",
    },

    health: {
        kicker: "Santé & soins",
        setup_kicker: "Pour commencer",
        setup_h: "Créez le dossier santé de votre animal",
        setup_sub: "Choisissez comment démarrer — vous pourrez toujours ajouter plus tard. Seuls le nom et l'espèce sont requis.",
        setup_manual_h: "Ajouter manuellement",
        setup_manual_sub: "Remplissez de courtes sections à votre rythme.",
        setup_scan_h: "Scanner un document",
        setup_scan_sub: "Photographiez un carnet de vaccination ou un passeport et nous pré-remplirons les champs.",
        ai_badge: "IA",
        overview_h: "Aperçu",
        stat_vaccinations: "Vaccinations",
        stat_documents: "Documents",
        stat_reminders: "Rappels",
        manual_h: "Santé & identité",
        sec_identification: "Identification",
        sec_health: "Notes de santé",
        sec_vet: "Vétérinaire",
        sec_vaccinations: "Vaccinations & rendez-vous",
        sec_reminders: "Rappels",
        sec_documents: "Documents",
        sec_timeline: "Chronologie",
        save: "Enregistrer",
        cancel: "Annuler",
        view: "Voir",
        scan_title: "Scanner un document",
        scanning: "Extraction des détails…",
        review_title: "Vérifiez les détails extraits",
        review_sub: "Rien n'est encore enregistré. Corrigez les champs surlignés, puis enregistrez.",
        please_verify: "À vérifier",
        review_ai_note: "L'IA peut se tromper. Vérifiez toujours les dates et identifiants.",
        no_diagnosis_note: "PawLink stocke vos notes telles quelles, sans diagnostic médical.",

        // Rappel proposé (à confirmer par l'utilisateur)
        rem_suggest_h: "Créer un rappel ?",
        rem_suggest_h_vaccination: "Créer un rappel pour la prochaine dose ?",
        rem_suggest_h_appointment: "Créer un rappel pour ce rendez-vous ?",
        rem_suggest_sub: "Nous l'ajouterons à vos rappels pour ne rien oublier. Modifiez tout avant de confirmer.",
        rem_suggest_open: "Créer un rappel",
        rem_suggest_existing: "Rappel déjà défini",
        rem_dialog_title: "Nouveau rappel",
        rem_dialog_sub: "PawLink vous préviendra avant l'échéance. Modifiez ce que vous voulez ci-dessous.",
        rem_field_title: "Titre",
        rem_field_date: "Date",
        rem_field_time: "Heure",
        rem_field_note: "Note (optionnelle)",
        rem_field_notify: "Prévenez-moi",
        rem_offset_7d: "7 jours avant",
        rem_offset_1d: "1 jour avant",
        rem_offset_0d: "Le jour même",
        rem_confirm: "Confirmer le rappel",
        rem_confirming: "Confirmation…",
        rem_never_auto: "Rien n'est créé automatiquement — vous décidez.",

        // Rendez-vous vétérinaires
        sec_appointments: "Rendez-vous vétérinaires",
        apt_add: "Ajouter un RDV",
        apt_empty: "Aucun rendez-vous.",
        apt_f_date: "Date",
        apt_f_time: "Heure",
        apt_f_clinic: "Clinique",
        apt_f_vet: "Vétérinaire",
        apt_f_reason: "Motif",
        apt_f_reason_ph: "ex. visite annuelle, détartrage",
        apt_f_notes: "Notes",
        apt_f_notes_ph: "Autre chose à retenir",
        apt_also_reminder: "Créer aussi un rappel",
        apt_status_scheduled: "Prévu",
        apt_status_completed: "Terminé",
        apt_status_cancelled: "Annulé",
        apt_mark_done: "Marquer terminé",
        apt_edit: "Modifier",
        apt_delete: "Supprimer",
        apt_confirm_delete: "Supprimer ce rendez-vous ?",
        apt_date_req: "Choisissez une date de rendez-vous.",
        apt_reason_default: "Visite vétérinaire",
    },

    walks: {
        kicker: "Balades locales",
        h1: "Voyez qui est dehors près de vous",
        tagline: "Transformez une balade ordinaire en un moment PawLink chaleureux.",
        cta_start: "On se balade 🐾",
        start_title: "Démarrer une balade locale",
        pet: "Animal",
        duration: "Durée",
        min: "min",
        consent_text: "PawLink montrera votre animal dans une zone approximative proche, pour la durée choisie. Votre position exacte et vos coordonnées personnelles resteront privées.",
        cancel: "Annuler",
        confirm_start: "Démarrer",
        starting: "Démarrage…",
        end: "Terminer",
        remaining: "restantes",
        you_are_walking: "Vous vous baladez avec {name}",
        your_pet: "votre animal",
        need_pet: "Ajoutez un animal pour démarrer une balade.",
        nearby_kicker: "À proximité maintenant",
        nearby_loading: "Recherche…",
        nearby_none: "Aucun ami PawLink en balade à proximité.",
        nearby_count: "{n} amis PawLink se baladent à proximité 🐾",
        upgrade_to_see_pins: "Passez à PawLink Protection pour voir les animaux à proximité sur la carte.",
        friend: "Ami PawLink",
        privacy_note: "Seule une zone approximative est affichée. PawLink ne révèle jamais votre nom, téléphone, adresse, position exacte ou itinéraire.",
        err_no_location: "L'autorisation de localisation est nécessaire pour démarrer ou voir les amis à proximité.",
        err_start: "Impossible de démarrer. Veuillez réessayer.",
        left_short: "restant",
        need_pet_h: "Ajoutez un animal avant de démarrer",
        need_pet_sub: "Créez un profil rapide : nom, photo, un numéro pour l'étiquette QR. Moins d'une minute.",
        create_pet_cta: "Créer un profil animal",
        missing_pet: "animal",
        missing_duration: "durée",
        missing_consent: "consentement",
        missing_location: "position",
        missing_location_hint: "Nous avons besoin de votre position en direct pour flouter le repère. Appuyez d'abord sur «Centrer sur moi».",
    },
    care: {
        kicker: "PawLink Care",
        title: "Rappels de soins",
        add: "Ajouter",
        empty_no_pets: "Ajoutez d'abord un animal pour créer un rappel.",
        pet: "Animal",
        type: "Type",
        title_label: "Titre",
        title_placeholder: "ex. Rappel de vaccin antirabique",
        when: "Quand",
        note: "Note (optionnel)",
        notify_me: "Me notifier",
        offset_7d: "7 jours avant",
        offset_1d: "1 jour avant",
        offset_0d: "Le jour même",
        save: "Enregistrer",
        saving: "Enregistrement…",
        cancel: "Annuler",
        err_save: "Impossible d'enregistrer. Réessayez.",
        tab_upcoming: "À venir",
        tab_overdue: "En retard",
        tab_completed: "Terminés",
        empty_upcoming: "Rien à venir.",
        empty_overdue: "Rien en retard.",
        empty_completed: "Pas encore de rappels terminés.",
        type_vaccination: "Vaccination",
        type_vet: "Visite véto",
        type_medication: "Médicament",
        type_grooming: "Toilettage",
        type_other: "Autre",
        mark_done: "Terminer",
        delete: "Supprimer",
    },
};

const es = {
    lang: { name: "Español", dir: "ltr" },
    nav: { home: "Inicio", pricing: "Precios", dashboard: "Panel", login: "Iniciar sesión", register: "Empezar", create_account: "Crear cuenta", signout: "Cerrar sesión", plan_free: "Gratis", plan_premium: "Premium", plan_trial: "Prueba", menu: "Menú", back: "Atrás", my_pets: "Mis mascotas", my_qr: "Mis QR", scan_history: "Escaneos", notifications: "Notificaciones", account: "Cuenta", subscription: "Suscripción", protection: "Seguridad PawLink", safety: "Seguridad PawLink", rescue_center: "Centro de rescate", community: "Comunidad PawLink",
        local_walks: "Paseos locales", lost_pets: "Mascotas perdidas", help: "Ayuda", faq: "FAQ", support: "Soporte", how_it_works: "Cómo funciona", view_all: "Ver todas las notificaciones", open_scan: "Abrir escaneo", view_map: "Ver en mapa", no_pets_yet: "Aún no hay mascotas — añade la primera", dash_pets: "Mascotas", dash_status: "Estado", dash_status_safe: "Todas a salvo", dash_status_lost: "{n} mascota perdida", bn_home: "Inicio", bn_pets: "Mascotas", bn_lost: "Perdidas", bn_community: "Grupo", bn_safety: "Seguridad", bn_account: "Cuenta" },
    brand: { tagline: "Tu mascota. Siempre encontrando el camino a casa." },
    common: { save: "Guardar", cancel: "Cancelar", delete: "Eliminar", edit: "Editar", back: "Volver", next: "Siguiente", loading: "Cargando…", saving: "Guardando…", remove: "Quitar", upload: "Subir", record: "Grabar", stop: "Detener", close: "Cerrar" },
    landing: {
        chip: "ID QR inteligente",
        h1a: "Si tu mascota se pierde,",
        h1b: "ayúdala a encontrar el camino a casa ❤️",
        sub: "PawLink le da a tu mejor amigo una ID QR inteligente. Si se pierde, cualquier persona amable puede escanear y contactarte en segundos — sin app.",
        cta_primary: "Crea el perfil",
        cta_secondary: "Ver cómo funciona",
        badge_privacy: "Privacidad primero",
        badge_dynamic: "QR dinámico",
        badge_love: "Hecho con amor",
        story_scan: "Alguien escaneó la placa de Milo",
        story_when: "Ahora mismo · calle X",
        story_reunited: "Milo va camino a casa 🐾",
        protect_h: "Protege a tu mejor amigo hoy 🐾",
        protect_price: "9.90 CHF/mes  ·  79.00 CHF/año",
        protect_line: "Tranquilidad — porque perderlos no es una opción.",
        protect_cta: "Activar PawLink Protection",
        how_over: "Cómo funciona",
        how_h2: "Tres pasos entre perdido y en casa.",
        step1_t: "🐶 Crea perfil",
        step1_d: "Foto, nombre, notas de salud y un mensaje del corazón.",
        step2_t: "📱 Coloca el Smart QR",
        step2_d: "Impreso en placa, collar o pegatina. Actualiza cuando quieras.",
        step3_t: "❤️ Reencuentro",
        step3_d: "Escanean, te avisan con ubicación — voz, llamada, listo.",
        why_over: "Tranquilidad, incluida",
        why_h2: "Todo lo que necesitan para volver a casa.",
        why_sub: "Cada segundo cuenta cuando una mascota se pierde. PawLink es tu plan.",
        f1_t: "🔔 Alertas instantáneas",
        f1_d: "Entérate en cuanto alguien escanea el QR.",
        f2_t: "📍 Última ubicación",
        f2_d: "GPS o ciudad — en tu panel.",
        f3_t: "🎙 Mensajes de voz",
        f3_d: "Tu voz calma; la del finder llega rápido.",
        f4_t: "📞 Llamada & WhatsApp",
        f4_d: "El finder te alcanza en un toque.",
        f5_t: "🔒 Privacidad",
        f5_d: "Tú decides qué ve un desconocido.",
        cta_h2: "Ellos no pueden llamarte. Pero un desconocido sí.",
        cta_sub: "Dale a tu mascota la red de seguridad que merece.",
        cta_btn: "Empieza gratis",
        cta_compare: "Ver precios",
    },
    auth: {
        welcome: "Bienvenido",
        sign_sub: "Inicia sesión para gestionar los perfiles.",
        create: "Crea tu cuenta",
        create_sub: "Empieza a proteger a tu mascota en menos de dos minutos.",
        email: "Correo",
        password: "Contraseña",
        password_hint: "Al menos 6 caracteres",
        name: "Tu nombre",
        signin: "Iniciar sesión",
        signing: "Iniciando…",
        creating: "Creando…",
        create_btn: "Crear cuenta",
        no_account: "¿Sin cuenta?",
        have_account: "¿Ya tienes cuenta?",
        create_one: "Crea una",
        trouble_signing_in: "¿Problemas para iniciar sesión? Escríbenos a",
        sign_in: "Iniciar sesión",
        or_continue: "o continúa con correo",
        google_signin: "Iniciar sesión con Google",
        google_signup: "Regístrate con Google",
        welcome_h: "Bienvenido a PawLink",
        welcome_sub: "Protege a tu mascota en segundos.",
        welcome_hi: "¡Hola! 👋",
        welcome_footer: "Al continuar aceptas nuestros términos y política de privacidad.",
        forgot_password: "¿Olvidada?",
        forgot_title: "Restablecer tu contraseña",
        forgot_sub: "Ingresa tu correo — te enviaremos un enlace seguro para elegir una nueva contraseña.",
        forgot_submit: "Enviar enlace",
        forgot_sending: "Enviando…",
        forgot_sent_title: "Revisa tu bandeja",
        forgot_sent_sub: "Si existe una cuenta con ese correo, acabamos de enviar un enlace de restablecimiento. Expira en 1 hora.",
        forgot_back_login: "Volver a iniciar sesión",
        reset_title: "Elige una nueva contraseña",
        reset_sub: "Elige una contraseña fuerte de al menos 6 caracteres. Se iniciará sesión automáticamente.",
        reset_new: "Nueva contraseña",
        reset_confirm: "Confirmar contraseña",
        reset_submit: "Restablecer",
        reset_saving: "Guardando…",
        reset_success: "Contraseña actualizada. Redirigiendo…",
        reset_mismatch: "Las contraseñas no coinciden.",
        reset_invalid_link: "Este enlace no es válido o ha expirado. Solicita uno nuevo.",
        reset_no_token: "Falta el token. Vuelve a abrir el enlace desde tu correo.",
    },
    dash: {
        welcome: "Bienvenido",
        sub: "Gestiona las IDs digitales y comparte los QR.",
        add_pet: "Añadir mascota",
        upgrade: "Pasar a Premium",
        empty_h: "Aún no hay mascotas",
        empty_sub: "Creemos la ID digital. Solo tarda un minuto — y puede salvarles la vida.",
        empty_cta: "Crear la primera mascota",
        pet_qr_h: " — QR",
        scan_share: "Escanea o comparte este enlace:",
        select_pet: "Selecciona una mascota para ver su QR.",
        loading: "Cargando…",
        upgrade_download: "Pasa a Premium para descargar el QR (PNG/PDF) y desbloquear las alertas de escaneo instantáneas.",
        upgrade_inline: "Actualizar",
        no_phone: "Sin teléfono",
        finder_url: "URL:",
        recent_scans: "Escaneos recientes",
        no_scans: "Aún no hay escaneos. Imprime y comparte el QR para empezar.",
        scan_gps: "GPS",
        scan_ip: "Ubicación IP",
        notifications: "Notificaciones",
        no_notifications: "Estás al día.",
        mark_all_read: "Marcar todo como leído",
        notif_scan: "Alguien escaneó el QR de {pet}",
        notif_found: "{finder} encontró a {pet}",
        just_now: "ahora mismo",
        min_ago: "hace {n} min",
        hr_ago: "hace {n} h",
        day_ago: "hace {n} d",
    },
    petform: {
        new_over: "Nueva mascota", edit_over: "Editar",
        new_h: "Crear perfil",
        edit_h: "Actualizar {name}",
        photo_h: "Foto",
        photo_sub: "Una foto clara ayuda a reconocer a tu mascota.",
        upload_photo: "Subir foto",
        about_h: "Sobre tu mascota",
        pet_name: "Nombre *",
        type: "Tipo *",
        type_dog: "Perro", type_cat: "Gato", type_other: "Otro",
        finder_message: "Mensaje para quien la encuentre",
        contact_h: "Contacto",
        contact_sub: "El teléfono es obligatorio. Lo demás es opcional.",
        owner_name: "Tu nombre",
        phone: "Número *",
        whatsapp: "WhatsApp (opcional)",
        city: "Ciudad",
        address: "Dirección completa (opcional)",
        health_h: "Salud y Cuidado",
        allergies: "Alergias / alimentos prohibidos",
        allergies_ph: "Alergia al pollo. Nada de chocolate.",
        medical: "Notas médicas",
        medical_ph: "Toma medicación. Ansioso con ruidos fuertes.",
        voice_h: "Mensaje de voz y recompensa",
        voice_sub: "Graba una voz tranquilizadora para tu mascota.",
        voice_label: "Mensaje de voz",
        reward: "Recompensa (opcional)",
        reward_ph: "100€ por su vuelta a salvo",
        privacy_h: "Privacidad",
        privacy_sub: "Elige qué ve quien escanee el QR.",
        p_phone: "Mostrar mi teléfono",
        p_name: "Mostrar mi nombre",
        p_city_only: "Solo ciudad (recomendado)",
        p_address: "Dirección completa (avanzado)",
        p_allergies: "Mostrar alergias",
        p_medical: "Mostrar notas médicas",
        p_reward: "Mostrar recompensa",
        submit_create: "Crear",
        submit_edit: "Guardar",
        default_msg: "Si me encontraste, llama a mi humano. ¡Gracias por ser amable!",
        back_to_dash: "Volver al panel",
        step_of: "Paso {n} de {total}",
        continue: "Continuar",
        back: "Atrás",
        protect_btn: "Proteger a {name} 🐾",
        protect_generic: "Proteger a mi mascota 🐾",
        s1_h: "Conoce a tu mejor amigo",
        s1_emoji: "🐾",
        s1_sub: "Vamos a crear un perfil hermoso para ese miembro de la familia que no puede hablar por sí mismo.",
        s1_photo_label: "Toca para añadir una foto",
        s1_photo_hint: "Una foto clara ayuda a reconocer a tu mascota en segundos.",
        s1_change_photo: "Cambiar foto",
        s1_name_ph: "ej. Milo",
        s1_breed_label: "Raza (opcional)",
        s1_breed_ph: "ej. Golden Retriever",
        s1_gender_label: "Sexo (opcional)",
        gender_male: "Macho",
        gender_female: "Hembra",
        gender_unknown: "Prefiero no decir",
        s2_h: "Ayúdales a volver a casa",
        s2_emoji: "❤️",
        s2_sub: "Si alguien encuentra a tu mascota, así te la devuelve.",
        s2_privacy_note: "La dirección completa está oculta por defecto. Puedes cambiarlo luego.",
        s3_h: "Lo que un rescatador debe saber",
        s3_emoji: "🩺",
        s3_sub: "Detalles que pueden salvar la vida de tu mascota.",
        s3_notes_label: "Notas especiales (opcional)",
        s3_notes_ph: "ej. Se asusta fácilmente · Ama las caricias · No darle pollo",
        s4_h: "Un mensaje del corazón",
        s4_emoji: "🎤",
        s4_sub: "Graba un mensaje de voz que la persona escuchará al escanear.",
        s4_example: "«Hola, soy la mamá de Milo. Gracias por encontrarlo. Llámame ❤️»",
        s4_written_label: "O escribe un mensaje corto",
        s4_reward_label: "Recompensa (opcional)",
        s4_reward_hint: "Opcional. Un pequeño gracias motiva a quien la encuentre.",
        s5_h: "Control de privacidad",
        s5_emoji: "🔒",
        s5_sub: "Elige lo que ven los desconocidos al escanear el QR de {name}.",
        s5_sub_generic: "Elige lo que ven los desconocidos al escanear el QR.",
        success_h: "{name} está protegido",
        success_h_generic: "Tu mascota está protegida",
        success_sub: "Tu QR inteligente está listo. Imprímelo, ponlo en su collar.",
        success_card_over: "Pasaporte digital de mascota",
        success_card_id: "ID PawLink",
        success_view_profile: "Ver perfil público",
        success_go_dashboard: "Ir al panel",
        edit_saved: "Cambios guardados ❤️",
    },
    finder: {
        im_lost: "Estoy perdido, ayúdame a volver a casa",
        call: "Llamar al dueño",
        whatsapp: "WhatsApp",
        text: "SMS",
        whatsapp_optional: "¿Prefieres WhatsApp? Enviar mensaje por WhatsApp",
        owner: "Dueño:",
        message_h: "Un mensaje de mi humano",
        voice_h: "Mensaje de voz",
        voice_sub: "Oír a mi humano me tranquiliza.",
        voice_unsupported: "Tu navegador no puede reproducir este audio.",
        voice_open_new: "Abrir el audio en otra pestaña",
        default_plea: "¡Hola! Soy {name}. Si me encontraste, contacta a mi familia para que pueda volver a casa a salvo. ¡Gracias! ❤️",
        allergies_h: "Alergias y alimentos prohibidos",
        medical_h: "Notas médicas",
        location_h: "Dónde vivo",
        reward_h: "Recompensa",
        personality_h: "Cómo acercarse a {name}",
        passport_h: "Pasaporte de {name}",
        passport_sub: "Compartido por el dueño por si el veterinario o autoridad lo necesita.",
        passport_view: "Ver",
        lost: {
            badge: "Perdido · Ayuda",
            pawlink_verified: "Verificado por PawLink",
            headline_kicker: "Ayúdame a volver a casa",
            headline: "Soy {name} — mi familia me está buscando.",
            missing_for: "Perdido desde hace {time}",
            call_cta: "Llama a mi familia",
            sms_cta: "Envía SMS a mi familia",
            whatsapp_cta: "Mensaje por WhatsApp",
            plea_h: "Cuídame — tengo miedo",
            plea_default: "Mantenme a salvo hasta que llegue mi familia. Llama al número de arriba y pronto estaré en casa. Gracias, amable persona. ❤️",
            reward_h: "Recompensa por devolverlo",
            lastseen_h: "Última vez visto",
            view_on_map: "Ver en el mapa",
            medical_h: "Importante — tengo necesidades médicas",
        },
        found_h: "¿Acabas de encontrar a {name}?",
        found_sub: "Pulsa el botón y avisamos al dueño al instante.",
        found_btn: "He encontrado a esta mascota",
        thanks_h: "Gracias — eres un héroe.",
        thanks_sub: "Hemos avisado a {owner}. Quédate cerca de la mascota si puedes.",
        owner_generic: "el dueño",
        powered: "Con",
        tagline: "Llevamos mascotas perdidas a casa",
        tech_help: "¿Problema técnico en esta página? Escribe a PawLink en",
        modal_h: "Dile al dueño dónde estás",
        modal_sub: "Tus datos ayudan a encontrarte rápido.",
        f_name: "Tu nombre (opcional)",
        f_phone: "Tu teléfono (opcional)",
        f_location: "¿Dónde estás?",
        f_location_ph: "Esquina de X y Y",
        f_message: "Mensaje (opcional)",
        f_voice: "Respuesta de voz (opcional)",
        share_location: "Compartir mi ubicación",
        location_sharing: "Compartiendo…",
        location_shared: "Ubicación compartida",
        submit: "Avisar al dueño",
        sending: "Enviando…",
        cancel: "Cancelar",
        not_found_h: "Perfil no encontrado",
        not_found_sub: "Este QR quizá fue eliminado.",
        go_home: "Inicio",
        voice_shortcut_h: "¿No puedes escribir? Envía un mensaje de voz 🎙️",
        voice_shortcut_sub: "Respuesta de voz con un toque — el dueño de {name} lo escuchará en segundos.",
        voice_shortcut_send: "Enviar voz al dueño",
        voice_shortcut_sending: "Enviando…",
        voice_shortcut_sent_h: "Mensaje de voz enviado ❤️",
        voice_shortcut_sent_sub: "El dueño de {name} acaba de recibir una notificación con tu voz.",
        voice_shortcut_default_msg: "Mensaje de voz de alguien que lo encontró.",
        voice_shortcut_error: "No se pudo enviar. Inténtalo de nuevo.",
        sighting_h: "Lo vi 👀",
        sighting_sub: "Alerta de avistamiento con un toque. El dueño de {name} recibe tu ubicación exacta y puede ir de inmediato.",
        sighting_send: "Lo vi — enviar mi ubicación",
        sighting_locating: "Ubicándote…",
        sighting_privacy: "🔒 Tu ubicación se comparte una sola vez, solo con el dueño de esta mascota.",
        sighting_default_msg: "Acabo de ver a {name} cerca.",
        sighting_sent_h: "Avistamiento enviado 📍",
        sighting_sent_sub: "El dueño de {name} va en camino. ¡Gracias por ayudar!",
        sighting_error: "No se pudo enviar. Inténtalo de nuevo.",
    },
    community: {
        title: "Comunidad PawLink",
        sub: "Un solo mapa para mascotas perdidas, paseos locales y la comunidad PawLink cerca de ti.",
        privacy_h: "Tu presencia en el mapa",
        privacy_sub: "Tú eliges qué ven los demás. Tu dirección exacta nunca se guarda — solo un pin difuso cerca de tu barrio.",
        vis_invisible: "Invisible",
        vis_invisible_sub: "No apareces en ningún mapa.",
        vis_approximate: "Aproximado",
        vis_approximate_sub: "Un pin suave cerca de tu barrio — nunca tu dirección.",
        vis_helper: "Ayudante PawLink 🐾",
        vis_helper_sub: "Aparece como ayudante para que los vecinos sepan que pueden contar contigo.",
        location_needed_h: "Añade tu barrio al mapa",
        location_needed_sub: "Un toque. Redondeamos tu ubicación a ~1 km — no se guardan direcciones.",
        share_approx_location: "Añadir mi zona aproximada",
        locating: "Ubicando…",
        location_error: "No se pudo guardar tu zona.",
        location_denied: "Permiso de ubicación denegado.",
        geo_unsupported: "Tu navegador no soporta ubicación.",
        visibility_error: "No se pudo actualizar la visibilidad.",
        your_area: "Tu zona: {area}",
        helpers_near: "{count} ayudantes PawLink cerca de {area}",
        helpers_generic: "{count} ayudantes PawLink cerca",
        helpers_sub: "Anónimos. Listos para ayudar si una mascota se pierde en tu zona.",
        protectors_near: "{count} protectores PawLink cerca de ti 🐾",
        protectors_generic: "{count} protectores PawLink cerca de ti 🐾",
        protectors_sub: "Una familia silenciosa de dueños que se cuidan entre sí — anónimos en el mapa, reales cuando importa.",
        stat_helpers: "Ayudantes",
        stat_lost: "Perdidos",
        stat_found: "Reencontrados",
        filter_all: "Todos",
        filter_lost: "Perdidos",
        filter_walking_now: "Paseando ahora",
        walks_legend: "Marcadores cálidos = mascotas paseando ahora. Los marcadores de perdidos y rescate siguen visibles.",
        filter_helpers: "Comunidad cercana",
        filter_found: "Reencontrados",
        refresh: "Actualizar",
        legend_helper: "Ayudante",
        legend_lost: "Perdido",
        legend_found: "Reencontrado",
        legend_walking: "Paseando",
        you_are_here: "Tú",
        find_my_location: "Encontrarme",
        center_on_me: "Centrarme",
        distance_h: "Distancia",
        map_visibility_h: "Visibilidad en el mapa",
        map_visibility_hidden: "Oculta",
        map_visibility_approximate: "Aproximada",
        map_visibility_live_approx: "En vivo aproximada",
        map_visibility_change: "Cambiar",
        km_unit: "km",
        pin_helper: "Ayudante PawLink",
        pin_helper_anon: "Guardián anónimo",
        pin_member: "Miembro PawLink",
        avail_available: "Disponible",
        avail_busy: "Ocupado",
        avail_offline: "Sin conexión",
        availability_h: "Mi disponibilidad",
        rescue_count: "{n} rescates",
        radius_h: "Radio",
        receive_alerts_h: "Recibir alertas de mascotas perdidas",
        receive_alerts_sub: "Recibe un aviso cuando una mascota cercana necesite ayuda. Nunca compartes tus datos.",
        delete_location_cta: "Borrar mi ubicación guardada",
        delete_location_confirm: "¿Borrar tu ubicación comunitaria? Serás invisible en el mapa.",
        lost_pet: "Mascota perdida",
        recently_found: "Reencontrada",
        last_seen: "Visto por última vez",
        distance_km: "a {km} km",
        view_pet: "Ver perfil",
        lost_nearby_h: "{count} mascotas perdidas cerca de ti",
        found_nearby_h: "{count} reencontradas",
        location_unknown: "Ubicación desconocida",
        popup_isaw: "Lo vi",
        popup_ifound: "Yo lo encontré",
        popup_sighting_sending: "Enviando tu ubicación…",
        popup_sighting_sent: "Avistamiento enviado ❤️ Dueño avisado.",
        guardians_city: "{count} guardianes PawLink protegiendo mascotas en {city} 🐾",
        guardians_sub: "Tu mascota tiene miles de ojos ayudándolo a volver a casa.",
        sheet_missing: "Perdido",
        sheet_found_safe: "Reencontrado a salvo",
        sheet_reward: "Recompensa",
        sheet_contact_owner: "Contactar al dueño",
        sheet_privacy: "Las ubicaciones se comparten solo cuando alguien decide ayudar.",
        sheet_reunion_h: "De vuelta en casa, sano y salvo",
        sheet_reunion_sub: "{name} se reencontró con su familia recientemente gracias a la comunidad PawLink. 🐾",
        helper_ready_h: "Ayudante PawLink — listo para ayudar",
        helper_ready_sub: "Anónimo por defecto. Si una mascota se pierde cerca, este vecino puede ayudarte a encontrarla.",
        ticker_area_generic: "tu zona",
        ticker_joined: "🐾 {name} se acaba de unir a la comunidad PawLink",
        ticker_reunited: "❤️ {name} volvió a casa sano y salvo",
        ticker_someone_helping: "🔍 Alguien está ayudando a encontrar una mascota perdida cerca",
        ticker_helper_joined_area: "📍 Un ayudante PawLink se unió en {area}",
        ticker_helpers_watching: "🛡️ {count} guardianes cuidando de {area}",
        ticker_helping_lost: "🐾 Vecinos ayudando a buscar una mascota perdida cerca",
        ticker_guardian_active: "✨ {name} se convirtió en Guardián PawLink",
        rescue_alert_h: "🚨 {count} mascota(s) necesitan ayuda cerca",
        rescue_alert_sub: "Abre el mapa, comparte un avistamiento o llama al dueño. Cada segundo cuenta.",
        rescue_help_now: "Ayudar",
        locate_me: "Centrar en mi ubicación",
        empty_first_guardian_h: "Sé el primer Guardián PawLink de tu zona 🐾",
        empty_first_guardian_sub: "Aún no hay mascotas perdidas, ayudantes ni reencuentros reportados cerca de ti. Activa el modo Ayudante para ser el primer par de ojos que cuide a las mascotas de tu barrio.",
        empty_needs_location_h: "Tu mapa de rescate te espera",
        empty_needs_location_sub: "Añade tu zona aproximada para ver miembros reales de PawLink, alertas en vivo de mascotas perdidas y reencuentros cerca de ti. Tu dirección exacta nunca se almacena.",
        empty_share_cta: "Añadir mi zona aproximada",
        empty_become_helper: "Convertirme en Ayudante PawLink",
    },
    pricing: {
        eyebrow: "Precios",
        h1: "Simple y justo.",
        sub: "Descubre PawLink gratis. Cuando estés listo para proteger a tu mejor amigo, activa PawLink Protection.",
        free_title: "GRATIS",
        free_price: "$0",
        free_period: "",
        free_desc: "Descubre PawLink y crea tu primera identificación digital.",
        premium_title: "PAWLINK PROTECTION 🐾",
        premium_desc: "Porque perderlos no es una opción ❤️",
        premium_line: "Un sistema de protección inteligente que ayuda a traer a tu mejor amigo a casa a salvo.",
        billing_monthly: "Mensual",
        billing_yearly: "Anual",
        price_monthly: "9.90 CHF",
        per_month: "/ mes",
        price_yearly: "79.00 CHF",
        per_year: "/ año",
        save_badge: "La mejor · $1.67/mes",
        recommended: "⭐ La mejor",
        free_list: [
            "Crea 1 perfil",
            "Añade foto y datos básicos",
            "Previsualiza tu Smart ID",
            "Descubre cómo funciona la protección",
        ],
        free_footer: "La activación del QR y las herramientas premium de seguridad requieren PawLink Protection.",
        premium_benefits: [
            { emoji: "🚨", title: "Modo Rescate Perdido", sub: "Alertas instantáneas + ubicación del escaneo cuando alguien encuentra a tu mejor amigo." },
            { emoji: "📍", title: "Smart QR ID", sub: "Cualquiera puede escanear y contactarte al instante — sin necesidad de app." },
            { emoji: "✈️", title: "Pasaporte digital", sub: "Vacunas, historial veterinario y documentos de viaje siempre listos." },
            { emoji: "❤️", title: "Perfil de Salud y Emergencia", sub: "Alergias, necesidades médicas y personalidad en un solo lugar." },
            { emoji: "👨‍👩‍👧", title: "Contactos de Familia de Confianza", sub: "Tus seres queridos pueden ayudar a traerlos a casa sanos y salvos." },
            { emoji: "🐾", title: "Protección multi-mascota", sub: "Protege a cada perro o gato que amas desde una sola cuenta." },
        ],
        one_scan: "Un escaneo puede traerlos a casa 🐾",
        your_plan: "Tu plan",
        upgrade: "Activar PawLink Protection",
        get_free: "Empieza gratis",
        go_dash: "Ir al panel",
        redirecting: "Redirigiendo…",
        on_premium: "Estás protegido",
        secure: "Pago seguro con Paddle. Cancela cuando quieras.",
    },
    payment: {
        checking_h: "Confirmando tu pago…",
        checking_sub: "Un segundo.",
        paid_h: "¡Bienvenido a Premium!",
        paid_sub: "Has desbloqueado descarga QR (PNG y PDF), alertas de escaneo instantáneas, última ubicación y respuestas por voz.",
        go_dash: "Ir al panel",
        expired_h: "Sesión expirada",
        expired_sub: "La sesión terminó. Vuelve a intentarlo.",
        back_pricing: "Volver a precios",
        pending_h: "Aún procesando…",
        pending_sub: "Tarda más de lo habitual.",
        continue: "Continuar",
        error_h: "Un problema",
        error_sub: "No pudimos verificar el pago. Contacta a soporte si te cobraron.",
    },
    langpicker: {
        title: "Elige tu idioma",
        sub: "Puedes cambiarlo luego.",
        continue: "Continuar",
    },
    theme: { light: "Claro", dark: "Oscuro", system: "Sistema" },
    account: {
        eyebrow: "Tu cuenta",
        title_greeting: "Hola, {name}",
        header_edit: "Editar perfil",
        section_profile: "Información personal",
        section_prefs: "Preferencias",
        section_privacy: "Privacidad y seguridad",
        community_vis_h: "Visibilidad en el mapa de la comunidad",
        community_vis_sub: "Controla si apareces bajo « Comunidad cercana » en el mapa compartido. La ubicación exacta y los datos de contacto personales nunca se comparten.",
        community_vis_hidden: "Oculto",
        community_vis_approximate: "Visible aproximado",
        section_help: "Ayuda y soporte",
        section_legal: "Legal",
        section_help_legal: "Ayuda y legal",
        f_name: "Nombre completo",
        f_name_ph: "Tu nombre",
        f_name_hint_google: "Importado de tu cuenta de Google.",
        f_email: "Correo electrónico",
        f_email_hint: "Contacta con soporte para cambiar el correo.",
        f_phone: "Teléfono",
        f_phone_ph: "Opcional — para alertas de escaneo",
        f_country: "País",
        f_country_ph: "España",
        save: "Guardar cambios",
        saving: "Guardando…",
        saved: "Guardado",
        pref_language: "Idioma",
        pref_appearance: "Apariencia",
        pref_appearance_hint: "Sigue tu sistema o elige un modo.",
        pref_notifications: "Notificaciones en la app",
        pref_notifications_hint: "Recibe alertas de escaneo dentro de PawLink.",
        priv_public_h: "Perfil público de la mascota",
        priv_public_sub: "Cuando alguien escanea tu QR, solo ve la foto, el nombre y el contacto que elijas. Tu dirección nunca se comparte.",
        priv_public_manage: "Gestiona la visibilidad por mascota en Mis mascotas.",
        priv_password_h: "Cambiar contraseña",
        priv_password_google: "Inicias sesión con Google — no hay contraseña que cambiar aquí.",
        priv_password_current: "Contraseña actual",
        priv_password_new: "Nueva contraseña (mín. 8 caracteres)",
        priv_password_save: "Actualizar contraseña",
        priv_password_ok: "Contraseña actualizada.",
        priv_delete_h: "Eliminar cuenta",
        priv_delete_sub: "Eliminar permanentemente tu cuenta, mascotas, historial y mensajes. No se puede deshacer.",
        priv_delete_help: "¿Necesitas ayuda para eliminar la cuenta? Escríbenos a",
        priv_delete_btn: "Eliminar mi cuenta",
        priv_delete_confirm_h: "¿Estás totalmente seguro?",
        priv_delete_confirm_sub: "Escribe DELETE para confirmar. Todo se borrará.",
        priv_delete_placeholder: "Escribe DELETE",
        priv_delete_yes: "Sí, eliminar",
        priv_delete_cancel: "Conservar mi cuenta",
        help_center: "Centro de ayuda",
        help_contact: "Contactar soporte",
        help_faq: "Preguntas frecuentes",
        help_report: "Reportar un problema",
        legal_terms: "Términos de uso",
        legal_privacy: "Política de privacidad",
        logout: "Cerrar sesión",
    },
    qr: { locked_h: "Descarga de QR es Premium", locked_sub: "Pasa a 9.90 CHF/mes para descargar PNG y PDF imprimible.", locked_cta: "Desbloquear", png: "Descargar PNG", pdf: "PDF imprimible", scan_hint: "Imprime este QR en placa, collar o etiqueta.", downloading: "Preparando…", pdf_headline: "Si me encuentras, escanéame", pdf_sub: "Esta placa está protegida por PawLink — quien te encuentre verá la foto, alergias, notas médicas y podrá contactarte en un toque.", pdf_scan_here: "ESCANEA AQUÍ", pdf_url_label: "O visita", pdf_footer: "PawLink — Placa QR inteligente · getpawlink.com", page_h: "Tus QR inteligentes", page_sub: "Descarga, imprime o comparte la placa de cada mascota — collar, adhesivo, póster o tarjeta de respaldo.", public_link: "Enlace público", empty_h: "Aún no tienes QRs", empty_sub: "Crea primero una mascota — generaremos un QR inteligente que la traiga a casa." },
    pets_page: {
        hero_kicker: "Tu familia",
        hero_h: "Todos en casa. Todos a salvo.",
        hero_sub: "Cada mascota lleva un QR inteligente. Si se pierde, un desconocido puede traerla de vuelta en segundos.",
        add_pet: "Añadir otro miembro",
        error_title: "No pudimos cargar tus mascotas",
        error_sub: "El servidor no respondió. Verifica tu conexión e intenta de nuevo — tus datos están a salvo.",
        error_retry: "Reintentar",
        status_active: "Protegido",
        status_lost: "Perdido",
        status_sub: "Identidad digital activa",
        status_ready: "Listo si {name} se pierde",
        badge_qr: "QR activo",
        act_view: "Ver perfil",
        act_qr: "Código QR",
        act_edit: "Editar",
        act_delete: "Eliminar",
        protected_line: "{name} está protegido",
        lost_line: "{name} está perdido — la ayuda va en camino",
        safety_h: "Centro de seguridad",
        safety_sub: "Modo perdido · Personalidad · Pasaporte",
        safety_lost_h: "{name} está en modo perdido",
        safety_lost_sub: "Abrir el panel de emergencia",
        confirm_delete: "¿Eliminar el perfil de {name}? No se puede deshacer.",
        cancel: "Cancelar",
        empty_h: "Conoce a tu mejor amigo",
        empty_sub: "Crea su pasaporte digital de seguridad. 2 minutos para traerlo a casa para siempre.",
        empty_cta: "Proteger a mi mascota",
        trust_h_one: "Tu mejor amigo está a salvo.",
        trust_h_many: "Tus {count} mejores amigos están a salvo.",
        trust_sub: "Cada escaneo te envía su ubicación en vivo al instante. Estás a un toque de traerlo a casa.",
    },
    home_story: {
        hero_eyebrow: "PawLink · ID inteligente",
        hero_h_a: "Cuando se pierden…",
        hero_h_a2: "No pueden decirle a nadie dónde está su casa.",
        hero_h_b: "PawLink sí.",
        hero_sub: "Porque el amor es el camino más rápido a casa.",
        hero_cta_primary: "Proteger a mi mejor amigo",
        hero_cta_secondary: "Ver cómo funciona",
        hero_scroll: "Ver cómo funciona",
        pill_scan: "Escaneo · Contacto · Reencuentro",
        s1_kicker: "Escena 01 · El escaneo",
        s1_h: "Alguien encuentra a tu mejor amigo.",
        s1_sub: "Un extraño escanea la etiqueta PawLink. Un segundo después ve su foto, escucha tu voz y te contacta con un toque. Sin app que instalar, sin registro. Solo bondad — conectada al instante.",
        s1_note_title: "Nuevo escaneo · Centro",
        s1_note_body: "Alguien acaba de escanear la etiqueta de Milo.",
        s2_kicker: "Escena 02 · Modo Perdido",
        s2_h: "Tu mejor amigo está desaparecido.",
        s2_sub: "Activa el Modo Perdido. Cada escaneo envía GPS a tu teléfono. Tu vecindario se convierte en un equipo de búsqueda — tu recompensa, tu mensaje y su foto viajan a donde va la etiqueta.",
        s2_chip: "DESAPARECIDO · Por favor ayuda",
        s2_stat: "Búsqueda en vivo",
        how_kicker: "Cómo funciona PawLink",
        how_h: "Tres pasos simples para traerlo a casa.",
        how_sub: "PawLink es un servicio digital — tu QR inteligente está listo en minutos, no en días.",
        how_1_h: "Crea el perfil PawLink de tu mascota",
        how_1_sub: "Añade la foto de la mascota, su nombre, opciones de contacto del dueño, información médica y los detalles que el dueño elija compartir.",
        how_2_h: "Genera y adjunta el QR inteligente",
        how_2_sub: "PawLink genera un QR único que el dueño puede descargar, imprimir y adjuntar al collar o la placa de la mascota.",
        how_3_h: "Un escaneo conecta a quien lo encuentra con el dueño",
        how_3_sub: "Cuando alguien escanea el QR, ve al instante la Rescue Card con la foto, el nombre y los botones de contacto aprobados por el dueño. El dueño recibe una alerta de escaneo instantánea con la ubicación cuando esté disponible.",
        benefits_kicker: "Por qué PawLink",
        benefits_h: "Todo lo que necesitas para traerlos a casa.",
        big_b1_h: "Pasaporte digital de tu mascota",
        big_b1_sub: "No más cargar documentos contigo. El pasaporte, cartilla de vacunación, seguro, certificado antirrábico e historial médico de tu mascota siempre te acompañan — listos para un viaje o una visita al veterinario.",
        big_b2_h: "Centro de Rescate",
        big_b2_sub: "Reporta a tu perro como perdido y activa el modo Perdido. Sigue su ubicación GPS en vivo y obtén indicaciones precisas para traerlo a casa a salvo.",
        big_b3_h: "QR Inteligente",
        big_b3_sub: "Descarga el código QR digital único de tu mascota y úsalo como quieras — imprímelo en casa, añádelo a una placa o accesorio que ya tengas, o compártelo como pegatina. Cuando alguien lo escanea, recibes una notificación instantánea y la persona puede contactarte de inmediato para ayudarte a reunirte con tu mascota.",
        big_b4_h: "Mapa PawLink",
        big_b4_sub: "Conéctate con los miembros de PawLink cercanos que pueden ayudarte a buscar y reunirte con tu mascota.",
        benefits_close: "No te preocupes. Estamos contigo cuando nos necesites.",
        // Legacy 6-tile benefits — kept for backward compatibility (not currently rendered on Home)
        hb1_h: "Comunidad de Rescate PawLink",
        hb1_sub: "Si tu mascota se pierde, no estás solo. Los miembros PawLink cercanos pueden unirse a la búsqueda y ayudar a traer a tu amigo a casa.",
        hb2_h: "QR Inteligente + Alertas de Escaneo Instantáneas",
        hb2_sub: "Crea un QR único para tu mascota y recibe una alerta inmediata en la app y por email cuando alguien lo escanee — con hora y ubicación del escaneo cuando estén disponibles.",
        hb3_h: "Rescue Card Inteligente",
        hb3_sub: "Tras el escaneo, la persona ve una rescue card limpia con solo lo que el dueño decidió compartir — foto, nombre, botón de llamada, WhatsApp, aviso médico, recompensa y notas de emergencia.",
        hb4_h: "Pasaporte Digital de Mascota",
        hb4_sub: "Guarda información esencial de vacunación, viaje e identificación en un lugar digital seguro.",
        hb5_h: "Mapa de Rescate PawLink",
        hb5_sub: "Descubre miembros PawLink cercanos y actividad de rescate donde estés, para que la ayuda esté más cerca si tu mascota se pierde.",
        hb6_h: "Historial Médico Siempre Disponible",
        hb6_sub: "Guarda alergias, medicamentos, información médica y datos veterinarios para que estén disponibles durante visitas, emergencias y viajes.",
        reviews_kicker: "Amado por los dueños",
        reviews_h: "Reencuentros reales. Familias reales.",
        review_1_body: "Alguien escaneó el QR de Luna y volvió a casa el mismo día. Todavía lloro al recordarlo.",
        review_1_author: "Emily · Mamá canina",
        review_2_body: "La mejor protección que compré para mi perro. Simple, vale cada dólar y duermo mejor por la noche.",
        review_2_author: "James · Miembro PawLink",
        family_kicker: "Únete a la familia PawLink 🐾❤️",
        family_h_none: "Dueños que protegen a su mejor amigo — antes de que algo suceda.",
        family_h_one: "Eres uno de ellos. Un nombre, un corazón, una red de seguridad.",
        family_h_many: "Eres uno de ellos. {count} nombres. {count} corazones. Una red de seguridad.",
        family_sub: "Una comunidad tranquila de familias que eligen estar listas. Todos en casa. Todos a salvo.",
        family_cta: "Añadir otra mascota",
        family_cta_manage: "Gestionar mis mascotas",
        family_cta_first: "Crea tu primera mascota",
        final_kicker: "PawLink Protection",
        final_h: "Si de verdad amas a tu mejor amigo, protégelo hoy ❤️",
        final_sub: "No esperes al día en que desearás haberlo hecho antes. 9.90 CHF / mes · 79.00 CHF / año. Cancela cuando quieras.",
        final_cta_upgrade: "Proteger a mi mejor amigo",
        final_cta_manage: "Gestionar plan",
        final_active: "Protección activa",
    },
    home_protection: {
        eyebrow: "Una sola protección. Una sola familia.",
        heading: "Dales el camino más seguro a casa",
        body: "Ve exactamente lo que desbloquea la Protección PawLink — desde alertas de escaneo instantáneas hasta una comunidad de rescate que ayuda a traer a las mascotas perdidas más rápido.",
        cta: "Ver PawLink Protection",
    },
    install: {
        title: "Protege a tu mascota en menos de un minuto.",
        subtitle: "Instala PawLink directamente desde nuestra web y comienza a proteger a tu mascota hoy. Sin búsquedas en la App Store. Sin configuraciones complicadas. Instalas, creas el perfil y listo.",
        cta: "Instalar PawLink",
        cta_installing: "Instalando…",
        cta_installed: "Instalado",
        cta_open: "Abrir PawLink",
        desktop_qr_title: "Escanea para instalar PawLink al instante.",
        desktop_qr_sub: "Apunta la cámara de tu móvil a este código — continuarás la instalación en tu dispositivo.",
        badge_secure: "Instalación segura",
        badge_free: "Descarga gratis",
        badge_fast: "Configuración rápida",
        badge_updates: "Actualizaciones automáticas",
        ios_modal_title: "Instalar PawLink en iPhone",
        ios_modal_sub: "En Safari, toca el botón Compartir y luego \"Añadir a pantalla de inicio\".",
        ios_step_1: "Toca el icono Compartir en la parte inferior de Safari.",
        ios_step_2: "Elige \"Añadir a pantalla de inicio\".",
        ios_step_3: "Toca Añadir — PawLink ya está en tu pantalla de inicio.",
        ios_modal_close: "Entendido",
        already_installed_hint: "¿Ya instalado? Abre PawLink desde tu pantalla de inicio.",
        phone_caption: "La tarjeta de rescate que llevará tu mascota.",
        ios_coming_kicker: "Próximamente en la App Store",
        ios_coming_title: "PawLink para iPhone está en camino.",
        ios_coming_sub: "Estamos finalizando el lanzamiento en la App Store. Mientras tanto, ya puedes proteger a tu mascota — todas las funciones funcionan perfectamente en la web.",
        ios_meanwhile_label: "Mientras tanto",
        ios_meanwhile_body: "Crea tu cuenta PawLink ahora y protege a tu mascota desde Safari — sin instalación necesaria.",
        share_cta: "Compartir PawLink",
        share_title: "Compartir PawLink",
        share_sub: "Ayuda a otra mascota a volver a casa a salvo — comparte PawLink con tus amigos y familia.",
        share_message: "PawLink — la identificación QR inteligente que ayuda a devolver a las mascotas perdidas a casa. Pruébalo gratis:",
        share_whatsapp: "WhatsApp",
        share_facebook: "Facebook",
        share_x: "X",
        share_email: "Correo",
        share_copy: "Copiar enlace",
        share_copied: "Enlace copiado",
        share_close: "Cerrar",
        petcard_verified: "PawLink Verificado",
        petcard_qr_id: "ID QR",
        petcard_vaccinations: "Vacunas",
        petcard_up_to_date: "Al día",
        petcard_allergies: "Alergias",
        petcard_medical: "Notas médicas",
        petcard_owner: "Dueño",
        petcard_emergency: "Emergencia",
        petcard_documents: "Documentos",
        petcard_passport: "Pasaporte · Cartilla",
        petcard_updated: "Actualizado",
        petcard_updated_time: "hace 2 días",
        petcard_pet_name: "Coco",
        petcard_pet_breed: "Caniche Toy · Hembra",
        petcard_allergy_value: "Proteína de pollo",
        petcard_medical_value: "Ninguna",
        petcard_owner_value: "Léa M.",
        petcard_none: "Ninguna",
        // Rescue scan mockup (public finder view shown on Home)
        petcard_scan_title: "QR escaneado con éxito",
        petcard_scan_sub: "Esta mascota tiene una familia esperándola.",
        petcard_age: "Edad",
        petcard_age_value: "3 años",
        petcard_gender: "Sexo",
        petcard_gender_value: "Hembra",
        petcard_reward: "Recompensa por devolución",
        petcard_reward_value: "$200",
        petcard_notes: "Notas de emergencia",
        petcard_notes_value: "Muy amigable. Manténgala tranquila e hidratada hasta que lleguemos.",
        petcard_call: "Llamar al dueño",
        petcard_whatsapp: "WhatsApp",
        android_soon_kicker: "APK Android — muy pronto",
        android_soon_title: "PawLink Android está casi listo.",
        android_soon_sub: "Nuestra app nativa de Android está en pruebas finales. Mientras tanto, instala PawLink como app web — misma protección, lista en un toque.",
        android_install_pwa: "Instalar como app web",
        android_dismiss: "Ahora no",
    },
    home_pricing: {
        eyebrow: "Precios simples y honestos",
        heading: "Gratis para siempre — Protección cuando más importa",
        sub: "Empieza gratis. Sube al premium solo cuando quieras los extras que hacen de PawLink una verdadera red de rescate.",
        hero_get_started: "Comenzar — es gratis",
        free_title: "Gratis",
        free_price: "0 $",
        free_sub: "Todo lo esencial para devolverlos a casa.",
        free_f1: "1 perfil de mascota con QR inteligente",
        free_f2: "Alertas de escaneo en tiempo real",
        free_f3: "Herramientas de contacto básicas",
        free_cta: "Crear cuenta gratis",
        pro_title: "Protección PawLink",
        pro_price: "29,99 $",
        pro_period: "/año",
        pro_sub: "O 9,90 CHF/mes · cancela cuando quieras",
        pro_badge: "El más querido",
        pro_f1: "Mascotas y perfiles ilimitados",
        pro_f2: "Pasaporte digital y expediente médico",
        pro_f3: "Mapa de Rescate Comunitario",
        pro_f4: "Mensajes de voz bidireccionales",
        pro_f5: "Soporte prioritario de reencuentro",
        pro_cta: "Obtener Protección",
        see_all: "Comparar todas las funciones",
    },
    home_faq: {
        eyebrow: "Preguntas y respuestas",
        heading: "Todo lo que un dueño pregunta antes de unirse a PawLink",
        q1_q: "¿Cómo funciona el QR inteligente?",
        q1_a: "Descargas el QR digital único de tu mascota desde su página y lo usas como quieras — imprímelo en casa, añádelo a una placa o collar que ya tengas, o compártelo como pegatina. Cuando alguien apunta su teléfono, abre una página pública con el nombre de tu mascota y cómo contactarte — sin app ni cuenta de su parte.",
        q2_q: "¿Qué pasa cuando escanean a mi mascota?",
        q2_a: "Recibes una notificación instantánea con la ubicación del rescatista (traducida a ciudad/calle), cualquier mensaje de voz y una forma directa de devolverle la llamada.",
        q3_q: "¿Comparten mi dirección exacta?",
        q3_a: "Nunca. El rescatista solo ve lo que tú eliges mostrar. El Mapa usa ubicación aproximada — tu dirección siempre queda privada.",
        q4_q: "¿Puedo cancelar la Protección cuando quiera?",
        q4_a: "Sí. Gestiona o cancela en un toque desde Ajustes. Tu perfil gratis — y todo el historial — es tuyo para siempre.",
        see_all: "Ver la FAQ completa",
    },
    rescue: {
        title: "Cada rescate, en un solo lugar.",
        sub: "Alertas, escaneos y contactos — toda la actividad de rescate de tu mascota, unida.",
        tab_alerts: "Alertas",
        tab_scans: "Historial de escaneos",
        filter_all: "Todas las mascotas",
        call_finder: "Llamar",
        sms_finder: "Enviar SMS",
        empty_alerts_h: "Estás al día.",
        empty_alerts_sub: "Sin alertas todavía. En cuanto alguien escanee tu QR inteligente, lo verás aquí al instante con GPS y su mensaje.",
        empty_scans_h: "Aún no hay escaneos.",
        empty_scans_sub: "Imprime tu QR inteligente en una placa o collar. En cuanto lo escaneen, verás dónde y cuándo — aquí mismo.",
        finder_voice_h: "Mensaje de voz de quien lo encontró",
        rescue_alert_line: "🚨 Una mascota cerca necesita ayuda — {pet} · {km} km",
        rescue_alert_open: "Ver detalles del rescate",
        delete_alert: "Eliminar alerta",
        confirm_delete: "¿Eliminar esta alerta? No se puede deshacer.",
    },
    legal: {
        back: "Volver a la cuenta",
        updated: "Actualizado",
        privacy_kicker: "Legal · Privacidad",
        privacy_title: "Tus datos, protegidos.",
        privacy_sub: "Exactamente qué recopila PawLink, cómo lo usamos y tus controles.",
        terms_kicker: "Legal · Términos",
        terms_title: "Términos de uso",
        terms_sub: "Términos simples y humanos para usar PawLink y proteger a tu mascota.",
        faq_kicker: "Soporte · FAQ",
        faq_title: "Preguntas de los dueños.",
        faq_sub: "Todo lo que podrías preguntarte sobre el QR inteligente y la Protección.",
        support_kicker: "Soporte",
        support_title: "Estamos contigo y con tu mascota.",
        support_sub: "Envíanos un mensaje y te responderemos, normalmente en un día hábil.",
    },
    support: {
        email_label: "Escríbenos",
        email_hint: "Para casos urgentes, un correo siempre llega a un humano.",
        faq_label: "Auto-servicio",
        faq_title: "Consultar la FAQ",
        faq_hint: "Las respuestas que damos cada semana.",
        form_title: "Envíanos un mensaje",
        form_sub: "Dinos qué pasa y nos ocuparemos.",
        cat_account: "Cuenta",
        cat_billing: "Facturación",
        cat_bug: "Error",
        cat_safety: "Seguridad de la mascota",
        cat_other: "Otro",
        f_category: "Categoría",
        f_email: "Tu correo",
        f_subject: "Asunto",
        f_subject_ph: "Un breve resumen",
        f_message: "Mensaje",
        f_message_ph: "Cuenta todo lo que puedas — los IDs de pedido o escaneo ayudan a atenderte antes.",
        send: "Enviar mensaje",
        sending: "Enviando…",
        sent_ok: "Mensaje enviado. Te contactaremos pronto.",
    },
    qr_detail: {
        back: "Volver a mascotas",
        kicker: "ID digital de la mascota",
        protection_badge: "Protegido por PawLink",
        pet_id: "ID PawLink",
        scan_h: "Cómo usar este QR",
        scan_1: "Imprímelo en una placa, adhesivo, collar o tarjeta",
        scan_2: "Colócalo en algo que tu mascota siempre lleve",
        scan_3: "Si se pierde, quien la encuentre te contactará al instante",
        actions_download_png: "Descargar PNG",
        actions_download_pdf: "Descargar PDF",
        actions_print: "Imprimir",
        actions_share: "Compartir",
        share_title_prefix: "Encontrar a",
        share_text: "Si me encontraste, escanea este QR y llévame a casa ❤️",
        tags_h: "Míralo en placas reales",
        tags_sub: "Imagina a tu mascota con tu QR PawLink. Descarga el QR en cualquier momento e imprímelo tú mismo en una placa o collar que ya tengas — PawLink es un servicio digital y no vende ningún producto físico.",
        tag_stainless: "Acero inoxidable",
        tag_bone: "Forma de hueso",
        tag_black: "Negro premium",
        tag_gold: "Dorado premium",
        tag_silicone: "Silicona",
        tag_sticker: "Adhesivo",
        tag_wallet: "Tarjeta cartera",
        premium_gate_h: "Descargar el QR de {name} — Premium",
        premium_gate_sub: "Pasa a 9.90 CHF/mes para descargar, imprimir y compartir el QR de {name} en cualquier lugar.",
        premium_gate_cta: "Desbloquear este QR",
        premium_gate_preview: "Puedes previsualizar el diseño — la descarga se desbloquea con Protection.",
        passport_reassure: "Si encuentran a {name}, este código lo trae de vuelta a ti.",
        live_indicator: "En vivo",
    },
    safety: {
        kicker: "Centro de seguridad",
        title: "Protege a {name}",
        sub: "Modo emergencia, rasgos de personalidad y documentos listos para viajar — todo lo que mantiene a {name} a salvo cada día.",
        back_to_pets: "Volver a mascotas",
        pet_not_found: "Mascota no encontrada",
        tab_emergency: "Alerta",
        tab_personality: "Rasgos",
        tab_passport: "Pasaporte",
        tab_health: "Salud",
        hero_safe: "A salvo ahora",
        sos_kicker: "Modo emergencia",
        sos_h: "Si {name} llega a perderse",
        sos_sub: "Un toque convierte el QR público de {name} en una página de mascota perdida — con tu contacto, último lugar y recompensa.",
        sos_cta: "Reportar a {name} perdido",
        sos_reassure: "Puedes desactivarlo cuando {name} esté de vuelta a salvo.",
        step_s1_h: "Toca SOS",
        step_s1_d: "Un botón activa el modo emergencia al instante.",
        step_s2_h: "Los desconocidos ven tu alerta",
        step_s2_d: "Banner rojo grande, llamada, recompensa y último lugar.",
        step_s3_h: "Traes a {name} a casa",
        step_s3_d: "Cada escaneo te alerta. Reúne a tu familia.",
        modal_h: "Reportar a {name} perdido",
        modal_sub: "Esto cambia la página QR pública a modo emergencia al instante.",
        f_last_seen: "Último lugar visto",
        f_last_seen_ph: "ej. Parque Riverside junto a la puerta oeste",
        f_reward: "Recompensa (opcional)",
        f_reward_ph: "ej. $200",
        f_instructions: "Nota para quien lo encuentre",
        f_instructions_ph: "ej. {name} es tímido — no lo persigas. Llámame y voy.",
        gps_sharing: "Leyendo tu ubicación…",
        gps_ok: "Tu ubicación guardada como punto de partida",
        gps_off: "Ubicación desactivada — no pasa nada, puedes escribir una dirección.",
        gps_idle: "Capturamos tu ubicación si lo permites.",
        activate_now: "Activar modo perdido",
        activating: "Activando…",
        activate_error: "No se pudo activar. Inténtalo de nuevo.",
        activate_fineprint: "Puedes marcar a {name} como a salvo en cualquier momento.",
        status_lost: "Modo perdido activo",
        missing_for: "Perdido hace {time}",
        missing_now: "Reportado ahora",
        stat_scans: "Escaneos desde que se perdió",
        stat_qr: "QR público",
        stat_qr_on: "En modo emergencia",
        share_h: "Comparte la alerta",
        copied: "Enlace copiado",
        copy_link: "Copiar enlace",
        share_msg: "¡Ayuda — mi perro {name} está perdido! Comparte este enlace para traerlo a casa: {url}",
        mark_safe_cta: "{name} está a salvo — traerlo a casa",
        rescue_alert_h: "Alertar a los Guardianes cercanos",
        rescue_alert_sub: "Avisa a cada Guardián PawLink voluntario dentro del radio elegido. Verán la foto de la mascota y la zona aproximada — nunca tu teléfono ni dirección.",
        rescue_alert_send: "Enviar alerta a Guardianes en {r} km",
        rescue_alert_sending: "Enviando alerta…",
        rescue_alert_result: "Alerta enviada a {n} Guardián(es) en {r} km ❤️",
        rescue_alert_error: "No se pudo enviar. Vuelve a intentarlo.",
        rescue_alert_privacy: "Sólo compartimos el nombre, la foto y la zona aproximada. Tu identidad queda privada.",
        confirm_safe: "¿Marcar a {name} como encontrado y a salvo? Se desactivará el modo perdido.",
        preview_h: "Lo que ve quien lo encuentra ahora",
        preview_line1: "🚨 {name} está perdido — por favor ayuda.",
        preview_line2: "Botón de llamada, recompensa e instrucciones en primer plano.",
        preview_cta: "Previsualizar página pública",
        elapsed_d: "{d}d",
        elapsed_h: "{h}h",
        elapsed_m: "{m}m",
        elapsed_now: "ahora",
        personality: {
            h: "Cómo acercarse a {name}",
            sub: "Marca cada etiqueta que le corresponda a {name}. Los desconocidos que escaneen el QR las verán — para saber cómo interactuar.",
            g_friendly: "Buena onda",
            g_friendly_sub: "Dile a quien lo encuentre qué le gusta a {name}.",
            g_careful: "Con cuidado",
            g_careful_sub: "Algo a lo que un desconocido debe ir con calma.",
            g_medical: "Médico y dieta",
            g_medical_sub: "Para que nadie le dé comida equivocada ni olvide el medicamento.",
            save_cta: "Guardar personalidad",
            no_changes: "Todo al día",
        },
        p: {
            friendly_people: "Amigable con personas",
            friendly_dogs: "Amigable con perros",
            friendly_cats: "Amigable con gatos",
            good_children: "Bueno con niños",
            trained: "Bien entrenado",
            energetic: "Enérgico y juguetón",
            nervous: "Nervioso / ansioso",
            needs_space: "Necesita espacio",
            do_not_approach: "No acercarse sin el dueño",
            medical_needs: "Necesidades médicas",
            special_diet: "Dieta especial",
            needs_medication: "Necesita medicamento",
        },
        passport: {
            brand: "Pasaporte digital",
            g_health: "Vacunas y salud",
            g_vet: "Veterinario y certificados",
            g_insurance: "Seguro",
            g_travel: "Viaje y otros",
            empty_h: "Sin documentos aún",
            empty_sub: "Sube el certificado antirrábico de {name}, vacunas o seguro — deja de cargar papeles.",
            add_h: "Añadir un documento nuevo",
            add_sub: "PDF o foto. Solo tú lo ves salvo que lo hagas público.",
            upload_cta: "Subir documento",
        },
        dockind: {
            vaccine: "Vacunación",
            rabies: "Certificado antirrábico",
            vet: "Documento veterinario",
            medical: "Historial médico",
            insurance: "Seguro",
            travel: "Documento de viaje",
            other: "Otro",
        },
        f_doc_name: "Nombre del documento",
        f_doc_name_ph: "ej. Rabia 2026",
        f_doc_kind: "Tipo",
        uploading: "Subiendo…",
        upload_error: "Error al subir. Intenta de nuevo.",
        saved: "Guardado",
        view: "Ver",
        public_on: "Visible para quien lo encuentre (público)",
        public_off: "Solo tú lo ves (privado)",
        public_on_hint: "Quien escanee el QR puede ver este documento.",
        public_off_hint: "Privado — solo para ti.",
        tt_public: "Público — visible a quien lo encuentre",
        tt_private: "Privado — solo tú",
        confirm_remove_doc: '¿Quitar "{name}"? No se puede deshacer.',
    },
    premium_soon: {
        badge: "Próximamente",
        chip: "Premium",
        title: "Premium llega pronto 🐾",
        body: "Esta función es parte de PawLink Premium. Las suscripciones Premium estarán disponibles pronto.",
        free_hint: "Por ahora, puedes seguir usando las funciones gratuitas de PawLink.",
        ok: "Entendido",
    },
    subscription: {
        title_active: "PawLink Protection está activo",
        title_choose: "Porque perderlos no es una opción ❤️",
        sub_active: "Estás protegiendo a tu mejor amigo con nuestro plan más avanzado. Gracias por cuidarlo.",
        sub_choose: "Una forma más inteligente de proteger a los que siempre están a tu lado.",
        current_plan: "Tu plan actual",
        plan_free_name: "Plan gratuito",
        plan_premium_name: "PawLink Protection",
        plan_free_meta: "1 perfil · Solo vista previa",
        plan_premium_meta: "Renovación automática · Cancela cuando quieras",
        active: "Activo",
        upgrade_cta: "Pasar a Protection",
        benefits_h: "Qué incluye",
        emotional_sub: "Una forma más inteligente de proteger a los que siempre están a tu lado.",
        cancel_anytime: "Cancela cuando quieras",
        get_started: "Empieza",
        best_value_sub: "La mejor · ~$1.25/mes",
        choose_yearly: "Elegir anual",
        family_reassure: "Estás protegiendo a un miembro de la familia — no comprando un QR.",
        emo_hero_title: "¿Y si tu mascota se pierde hoy?",
        emo_hero_sub: "No puede darle tu número a un extraño. PawLink puede traerla de vuelta a casa.",
        compact_title: "¿Y si se pierde?",
        compact_sub: "Recibe alerta. Ubica al momento. Vuelve a casa antes.",
        hero_new_title: "Protege a tu mejor amigo — incluso cuando no estás",
        hero_new_sub: "Un escaneo ayuda a que quien la encuentre te contacte antes.",
        b1_title: "Alerta de pérdida al instante",
        b1_sub: "Entérate en el momento en que alguien encuentra a tu mejor amigo.",
        b2_title: "Ubicación del escaneo",
        b2_sub: "Ve exactamente dónde se escaneó el QR.",
        b3_title: "Contacto en un toque",
        b3_sub: "Quien lo encuentre te llama al instante — sin app requerida.",
        b4_title: "Pasaporte digital",
        b4_sub: "Historial veterinario, vacunas y papeles de viaje siempre contigo.",
        b5_title: "Mensaje de voz",
        b5_sub: "Deja que tu voz lo calme hasta que se reencuentren.",
        b6_title: "Protección QR inteligente",
        b6_sub: "Un camino más rápido a casa cuando te necesitan.",
        // v7.41 — 6 features (ES)
        f1_title: "Comunidad de Rescate PawLink",
        f1_tagline: "Si tu mascota se pierde, nunca estás solo. Los miembros de PawLink cercanos pueden ayudar a buscarla a través de la Comunidad de Rescate.",
        f1_line1: "Una sola familia.",
        f1_line2: "Una sola misión.",
        f1_line3: "Traer a cada mascota a casa.",
        f2_title: "Protección QR Inteligente y Alertas Instantáneas",
        f2_tagline: "En el instante en que alguien escanea el QR de tu mascota, recibes una notificación y un correo — para actuar en segundos, no en horas.",
        f2_line1: "Notificación push",
        f2_line2: "Notificación por email",
        f2_line3: "Hora del escaneo",
        f2_footer: "Sabe de inmediato cuando alguien ha encontrado a tu mejor amigo.",
        f3_title: "Tarjeta de Rescate Inteligente",
        f3_tagline: "Un escaneo revela una hermosa tarjeta de rescate — foto, nombre, alertas médicas, recompensa, y botones de Llamada y WhatsApp que te alcanzan al instante.",
        f3_line1: "Foto de la mascota",
        f3_line2: "Nombre de la mascota",
        f3_line3: "Botón para llamar",
        f3_line4: "Botón de WhatsApp",
        f3_line5: "Alerta médica",
        f3_line6: "Recompensa (opcional)",
        f3_line7: "Notas de emergencia",
        f3_footer: "El dueño controla completamente qué información se muestra. La privacidad siempre es lo primero.",
        f4_title: "Pasaporte Digital",
        f4_tagline: "Guarda la información importante de tu mascota en un lugar seguro. Vacunas, información de viaje y documentos esenciales siempre disponibles.",
        f5_title: "Mapa de Rescate PawLink",
        f5_tagline: "Ve a los miembros de PawLink cercanos y la actividad de rescate a tu alrededor. Cuando tu mascota se pierde, el mapa te conecta con usuarios cercanos que pueden ayudar a traerla de vuelta más rápido.",
        f6_title: "Historial Médico Siempre Contigo",
        f6_tagline: "Vacunas, alergias, medicamentos y contacto del veterinario — guardados con seguridad y listos cuando importa.",
        f6_line1: "Información médica",
        f6_line2: "Alergias",
        f6_line3: "Medicamentos",
        f6_line4: "Información veterinaria",
        f6_footer: "Sin papeles que llevar. Todo disponible al instante en las visitas al veterinario, emergencias o viajes.",
        emotional_close: "Únete a la comunidad PawLink — protege a tu mascota hoy.",
        // v7.42 — Two-plan selector (ES)
        pick_a_plan_aria: "Elige un plan",
        plan_monthly_label: "Mensual",
        plan_yearly_label: "Anual",
        plan_monthly_note: "Cancela cuando quieras",
        plan_yearly_note: "Ahorra 50% vs mensual",
        plan_yearly_badge: "Mejor Valor",
        per_month: "/ mes",
        per_year: "/ año",
        selected_prefix: "Elegiste:",
        cta_new: "Empieza tu prueba gratis de 7 días 🐾",
        cta_open_browser: "Abrir en el navegador para suscribirse →",
        store_free_h: "PawLink es gratis en esta aplicación",
        store_free_sub: "Puedes usar todas las funciones principales de PawLink en Android sin costo — no se requiere ninguna suscripción dentro de esta aplicación. Los perfiles de tus mascotas, el QR inteligente, el modo Perdido y las notificaciones están disponibles gratis.",
        early_access_chip: "Miembro fundador · Acceso anticipado",
        early_access_h: "Bienvenido al Acceso Anticipado de PawLink 🐾",
        early_access_sub: "PawLink es nuevo — y tú eres de los primeros. Disfruta de las funciones de protección de PawLink durante nuestro período de acceso anticipado mientras seguimos construyendo PawLink para las familias con mascotas de todo el mundo.",
        early_access_note: "Eres uno de los primeros miembros de PawLink. Los planes Premium y funciones adicionales llegarán en el futuro.",
        ea_welcome_h: "Eres un miembro temprano de PawLink 🧡",
        ea_welcome_sub: "Gracias por unirte temprano. Configura el perfil de tu mascota y su QR inteligente sin costo — las funciones adicionales de PawLink Premium (modo Perdido, mapa de rescate PawLink, rastreo en vivo) llegan pronto.",
        ea_welcome_dismiss: "Entendido",
        trial_title: "Cómo funciona tu prueba gratis de 7 días",
        trial_day0: "Día 0 — Se desbloquean todas las funciones, gratis.",
        trial_day5: "Día 5 — Te avisamos antes de que termine la prueba.",
        trial_day7: "Día 7 — Empieza la protección PawLink.",
        urgency_line: "Las mascotas perdidas no esperan. Prepárate antes de que ocurra. ❤️",
        family_line: "Porque son familia — y la familia merece un camino de vuelta",
        billing_help: "¿Preguntas de facturación o suscripción? Escríbenos a",
        benefit_short_1: "Alerta al instante",
        benefit_short_2: "Ubicación viva",
        benefit_short_3: "Privacidad total",
        journey_kicker: "El viaje del rescate",
        journey_title: "Perdido → Escaneo → Alerta → En casa",
        journey_1_title: "Alguien encontró a Max",
        journey_1_sub: "Alerta instantánea en tu teléfono.",
        journey_2_title: "Última ubicación",
        journey_2_sub: "Sabes exactamente dónde se escaneó el QR.",
        journey_3_title: "Contacto en un toque",
        journey_3_sub: "Quien lo encuentre te llama al instante.",
        journey_4_title: "Privado y seguro",
        journey_4_sub: "Tu dirección se queda oculta — siempre.",
        best_protection: "Mejor protección",
        cancel_line: "Cancela cuando quieras · Pagos seguros con Paddle.",
        cardholder_hint: "Por favor, introduce el nombre exactamente como aparece impreso en tu tarjeta — solo letras, espacios, guiones (-) y apóstrofes ('). Nuestro procesador de pagos no acepta números ni símbolos.",
        cardholder_helper: "Consejo: escribe el nombre del titular en letras latinas — se admiten espacios, guiones (-) y apóstrofes (').",
        invalid_browser_locale: "Tu navegador está reportando una configuración de idioma inusual que impide cargar el pago seguro. Cambia el idioma del navegador o del sistema a uno estándar (p. ej. Español) y recarga, o escríbenos a support@getpawlink.com y activaremos la Protección manualmente.",
        checkout_config_missing_token: "El pago seguro no está disponible temporalmente — falta nuestra configuración de pagos en esta versión. Escribe a support@getpawlink.com y activaremos la Protección para ti.",
        checkout_config_wrong_env: "El pago seguro no está disponible temporalmente — nuestro proveedor de pagos no está totalmente configurado para este dominio. Escribe a support@getpawlink.com y activaremos la Protección para ti.",
        checkout_config_test_token: "El pago seguro no está disponible temporalmente — nuestro proveedor de pagos está funcionando en modo prueba en este dominio. Escribe a support@getpawlink.com y activaremos la Protección para ti.",
        checkout_config_missing_price: "El pago seguro no está disponible temporalmente — la configuración de precios está incompleta. Escribe a support@getpawlink.com y activaremos la Protección para ti.",
        cancel_manage: "Gestionar o cancelar suscripción",
        cancel_confirm: "Sí, cancelar al final del período",
        cancel_back: "Conservar mi Protección",
        canceling: "Cancelando…",
        cancel_ok: "La suscripción terminará al final del período actual.",
        cancel_error: "No pudimos cancelar ahora. Inténtalo en un momento.",
        emo_cta: "Proteger a mi mascota",
        emo_cta_premium: "La protección está activa",
        or_monthly: "¿Prefieres pago mensual?",
        billing_h: "Facturación",
        billing_sub: "Usamos Paddle para facturación segura. Para actualizar tu tarjeta, cancelar o ver facturas, toca abajo.",
        billing_contact: "Contactar soporte de facturación",
        // Premium page copy
        kicker_protection: "Planes PawLink",
        hero_title_pre: "Porque perderlos no es una opción",
        hero_sub: "Una forma más inteligente de proteger a los que siempre están a tu lado.",
        protection_name: "PAWLINK PROTECTION",
        protection_name_short: "PawLink Protection",
        best: "La mejor",
        best_value: "La mejor",
        yearly_save_line: "Ahorra 50% · Solo $2.50/mes",
        monthly_flex_line: "Cancela cuando quieras — sin compromiso",
        cta: "Activar Protection",
        redirecting: "Redirigiendo al pago seguro…",
        checkout_error: "No se pudo iniciar el pago. Inténtalo de nuevo.",
        secure: "Pago seguro con Paddle",
        features: {
            smart_qr: {
                title: "QR inteligente + Ubicación en vivo",
                sub: "Cuando alguien escanea el QR de tu mascota, recibes la ubicación al instante y conectas con un toque.",
            },
            passport: {
                title: "Pasaporte digital",
                sub: "Guarda historial veterinario, vacunas, papeles de viaje y documentos importantes siempre listos — en el aeropuerto, veterinario o donde sea.",
            },
            rescue: {
                title: "Alerta de rescate comunitario",
                sub: "Si tu mascota se pierde, notifica a los usuarios PawLink cercanos que pueden ayudar.",
            },
            identity: {
                title: "Identidad completa",
                sub: "Toda la info importante en un perfil seguro: cuidados, necesidades, contactos de emergencia y personalidad.",
            },
        },
    },


    footer: { product: "Producto", pricing: "Precios", create_profile: "Crear perfil", sign_in: "Iniciar sesión", trust: "Confianza y Legal", trust1: "Privacidad primero.", trust2: "QR dinámico — edita cuando quieras.", trust3: "Hecho con cariño.", tag: "Devuélvelos a casa.", support: "Soporte", contact_us: "Contáctanos", help_center: "Centro de ayuda" },
    scanloc: {
        exact: "GPS exacto",
        exact_acc: "GPS exacto · ±{m} m",
        coarse: "GPS aprox.",
        coarse_acc: "GPS aprox. · ±{m} m",
        approx: "Ubicación aproximada",
        unknown: "Ubicación desconocida",
        open_exact: "Abrir punto exacto en Google Maps",
        open_coarse: "Abrir punto aprox. en Google Maps",
        open_area: "Abrir zona en Google Maps",
        open_in_maps: "Abrir en Google Maps",
        page_title: "Dos formas de proteger a tu mascota.",
        page_sub: "Empieza gratis. Sube de plan cuando quieras alertas más rápidas y más apoyo.",
        free_name: "PawLink Free",
        free_tagline: "Un primer paso sencillo para mantener a tu mascota conectada contigo.",
        free_price: "0,00 CHF",
        free_billing_label: "Para siempre",
        free_feat_1_title: "1 perfil digital de mascota",
        free_feat_1_sub: "Reúne identidad y contacto esenciales en un solo lugar.",
        free_feat_2_title: "Código QR inteligente único",
        free_feat_2_sub: "Descárgalo, imprímelo y colócalo en cualquier chapa o collar.",
        free_feat_3_title: "Página de rescate instantánea",
        free_feat_3_sub: "Ayuda a quien la encuentre a reconocerla y contactarte enseguida.",
        free_feat_4_title: "Sin necesidad de app",
        free_feat_4_sub: "Cualquiera puede escanear el QR directamente con su móvil.",
        free_cta_web: "Crear mi perfil gratis",
        free_cta_android: "Continuar gratis",
        recommended_badge: "Recomendado",
        protection_name: "PawLink Protection",
        protection_tagline: "Alertas más rápidas, más apoyo y mayor tranquilidad.",
        protection_price_monthly: "9,90 CHF",
        protection_price_annual: "79,00 CHF",
        save_33: "Ahorra 33 %",
        pro_feat_1_title: "Todo lo de PawLink Free",
        pro_feat_1_sub: "Conservas toda la protección esencial incluida.",
        pro_feat_2_title: "Ubicación del finder",
        pro_feat_2_sub: "Recibe su ubicación si decide compartirla.",
        pro_feat_3_title: "Alertas de escaneo instantáneas",
        pro_feat_3_sub: "Un correo en el instante en que se escanea el QR.",
        pro_feat_4_title: "Modo Perdido",
        pro_feat_4_sub: "Convierte el perfil en una página de rescate urgente en segundos.",
        pro_feat_5_title: "Mapa comunitario de rescate",
        pro_feat_5_sub: "Amplía la búsqueda con miembros PawLink cercanos.",
        pro_feat_6_title: "Alertas cercanas",
        pro_feat_6_sub: "Llega a quien está cerca de la zona reportada cuando el tiempo apremia.",
        pro_feat_7_title: "Tarjeta de rescate completa",
        pro_feat_7_sub: "Da a los rescatadores los datos médicos y de comportamiento clave.",
        pro_feat_8_title: "Vacunas y pasaporte",
        pro_feat_8_sub: "Organiza los documentos de salud y viaje importantes.",
        pro_feat_9_title: "Perfiles múltiples",
        pro_feat_9_sub: "Gestiona y protege a todas tus mascotas desde una sola cuenta.",
        pro_feat_10_title: "Avistamientos y actividad",
        pro_feat_10_sub: "Sigue las actualizaciones de escaneos y avistamientos durante la búsqueda.",
        cancel_anytime: "Cancela cuando quieras",
        cta_choose_monthly: "Elegir Protección mensual",
        cta_choose_annual: "Elegir Protección anual",
        premium_active_line: "PawLink Protection está activo.",
        annual_equivalent: "6,58 CHF / mes, facturado anualmente",
        checkout_awaiting_chf_configuration: "Pago en espera de la configuración de Paddle en CHF.",
        cta_protect_monthly: "Proteger mi mascota — Mensual",
        cta_protect_annual: "Proteger mi mascota — Anual",
        android_info_text: "Las suscripciones a PawLink Protection están disponibles en el sitio oficial de PawLink.",
        android_already_subscribed: "Ya estoy suscrito",
        android_signin: "Iniciar sesión",
        android_refresh: "Actualizar suscripción",
        android_refreshing: "Actualizando…",
        android_refresh_ok: "Suscripción actualizada.",
        android_refresh_err: "No se pudo actualizar. Por favor, inténtalo de nuevo.",
        trust_line: "Precios claros en CHF. Sin cargos ocultos. Cancela cuando quieras. Quien encuentre a tu mascota nunca necesita instalar la app.",
        free_price: "0,00 CHF",
    },
    scan_upgrade: {
        default_pet: "tu mascota",
        title: "Alguien encontró a {pet} ❤️",
        subtitle: "Este momento es la razón por la que PawLink existe. Activa la protección completa para que la próxima mano amable pueda contactarte en segundos.",
        u1_title: "Alertas de escaneo instantáneas",
        u1_sub: "En cuanto escanean el QR, tu móvil se ilumina.",
        u2_title: "Ubicación del rescatador",
        u2_sub: "Ve exactamente dónde fue avistado, en un mapa real.",
        u3_title: "Mensaje de voz de doble vía",
        u3_sub: "Tu voz lo calma hasta que llegues.",
        u4_title: "Pasaporte digital",
        u4_sub: "Historial veterinario, vacunas y documentos de viaje, siempre contigo.",
        u5_title: "Mascotas ilimitadas",
        u5_sub: "Protege a cada compañero con un solo plan.",
        reassure: "Porque son familia — y la familia merece un camino a casa.",
        cta_primary: "Activar Protección",
        cta_later: "Quizás más tarde",
        close: "Cerrar",
    },
    trial_offer: {
        title: "Tu mascota está protegida ❤️",
        subtitle: "Desbloquea la protección completa de PawLink gratis por 7 días. Cancela cuando quieras — no cobramos hasta el día 8.",
        p1_title: "Alertas de escaneo instantáneas",
        p1_sub: "En cuanto escanean el QR, tu móvil se ilumina.",
        p2_title: "Última ubicación",
        p2_sub: "Ve exactamente dónde fue avistado en un mapa en vivo.",
        p3_title: "Mensajes de voz",
        p3_sub: "Tu voz lo calma hasta que llegues.",
        p4_title: "Pasaporte digital",
        p4_sub: "Historial veterinario, vacunas y documentos de viaje, siempre contigo.",
        p5_title: "Compartir en familia",
        p5_sub: "Toda la familia recibe alertas, no solo un móvil.",
        p6_title: "Protección avanzada",
        p6_sub: "Múltiples mascotas, insignias de recompensa, documentos médicos.",
        billing_note: "Elegirás Mensual o Anual en la siguiente pantalla. Solo cobramos cuando terminan los 7 días — sin sorpresas.",
        cta_primary: "Comenzar 7 días de Protección gratis",
        cta_later: "Quizás más tarde",
        close: "Cerrar",
    },
    thankyou: {
        title: "Gracias por confiar en PawLink ❤️🐾",
        body: "Tu mascota está completamente protegida. Es un honor ayudarte a mantener a tu mejor amigo a salvo.",
        badge: "Protección PawLink Activa",
        cta: "Continuar",
        close: "Cerrar",
    },
    downgrade: {
        default_pet: "tu mascota",
        title: "El perfil de rescate básico de {pet} sigue activo ❤️",
        sub: "Actualiza cuando quieras para restaurar la protección completa de PawLink.",
        cta: "Restaurar Protección",
        dismiss: "Ahora no",
    },
    protection: {
        active: "Protección PawLink activa",
        canceled_pending: "La protección sigue activa hasta la fecha de renovación",
        trial_days: "Protección PawLink activa — quedan {days} día{s} de prueba",
        trial_chip: "Prueba gratis",
        plural_s: "s",
        sub: "Alertas instantáneas, ubicación precisa, mensajes de voz, pasaporte digital.",
    },

    health: {
        kicker: "Salud y cuidados",
        setup_kicker: "Empezar",
        setup_h: "Crea el historial de salud de tu mascota",
        setup_sub: "Elige cómo empezar — puedes añadir más luego. Solo el nombre y la especie son obligatorios.",
        setup_manual_h: "Añadir manualmente",
        setup_manual_sub: "Rellena secciones cortas a tu ritmo.",
        setup_scan_h: "Escanear un documento",
        setup_scan_sub: "Fotografía la cartilla o el pasaporte y rellenaremos los campos.",
        ai_badge: "IA",
        overview_h: "Resumen",
        stat_vaccinations: "Vacunas",
        stat_documents: "Documentos",
        stat_reminders: "Recordatorios",
        manual_h: "Salud e identidad",
        sec_identification: "Identificación",
        sec_health: "Notas de salud",
        sec_vet: "Veterinario",
        sec_vaccinations: "Vacunas y citas",
        sec_reminders: "Recordatorios",
        sec_documents: "Documentos",
        sec_timeline: "Cronología",
        save: "Guardar",
        cancel: "Cancelar",
        view: "Ver",
        scan_title: "Escanear un documento",
        scanning: "Extrayendo detalles…",
        review_title: "Revisa los datos extraídos",
        review_sub: "Nada se ha guardado aún. Corrige los campos resaltados y pulsa Guardar.",
        please_verify: "Verifica",
        review_ai_note: "La IA puede equivocarse. Comprueba siempre fechas e identificadores.",
        no_diagnosis_note: "PawLink guarda tus notas tal cual, sin diagnóstico médico.",

        // Recordatorio sugerido (a confirmar por el usuario)
        rem_suggest_h: "¿Crear un recordatorio?",
        rem_suggest_h_vaccination: "¿Crear un recordatorio para la próxima dosis?",
        rem_suggest_h_appointment: "¿Crear un recordatorio para esta cita?",
        rem_suggest_sub: "Lo añadiremos a tus recordatorios para que no se te olvide. Edita lo que quieras antes de confirmar.",
        rem_suggest_open: "Crear recordatorio",
        rem_suggest_existing: "Recordatorio ya configurado",
        rem_dialog_title: "Nuevo recordatorio",
        rem_dialog_sub: "PawLink te avisará antes de la fecha. Cambia lo que quieras aquí.",
        rem_field_title: "Título",
        rem_field_date: "Fecha",
        rem_field_time: "Hora",
        rem_field_note: "Nota (opcional)",
        rem_field_notify: "Avísame",
        rem_offset_7d: "7 días antes",
        rem_offset_1d: "1 día antes",
        rem_offset_0d: "El mismo día",
        rem_confirm: "Confirmar recordatorio",
        rem_confirming: "Confirmando…",
        rem_never_auto: "Nada se crea automáticamente — tú decides.",

        // Citas veterinarias
        sec_appointments: "Citas veterinarias",
        apt_add: "Añadir cita",
        apt_empty: "Sin citas aún.",
        apt_f_date: "Fecha",
        apt_f_time: "Hora",
        apt_f_clinic: "Clínica",
        apt_f_vet: "Veterinario",
        apt_f_reason: "Motivo",
        apt_f_reason_ph: "p. ej. chequeo anual, limpieza dental",
        apt_f_notes: "Notas",
        apt_f_notes_ph: "Cualquier otra cosa que quieras recordar",
        apt_also_reminder: "Crear también un recordatorio",
        apt_status_scheduled: "Programada",
        apt_status_completed: "Realizada",
        apt_status_cancelled: "Cancelada",
        apt_mark_done: "Marcar como hecha",
        apt_edit: "Editar",
        apt_delete: "Eliminar",
        apt_confirm_delete: "¿Eliminar esta cita?",
        apt_date_req: "Elige una fecha para la cita.",
        apt_reason_default: "Visita al veterinario",
    },

    walks: {
        kicker: "Paseos locales",
        h1: "Descubre quién está cerca",
        tagline: "Convierte un paseo cualquiera en un momento PawLink amistoso.",
        cta_start: "Estamos paseando 🐾",
        start_title: "Iniciar un paseo local",
        pet: "Mascota",
        duration: "Duración",
        min: "min",
        consent_text: "PawLink mostrará a tu mascota en una zona aproximada cercana durante el tiempo seleccionado. Tu ubicación exacta y tus datos personales seguirán siendo privados.",
        cancel: "Cancelar",
        confirm_start: "Iniciar paseo",
        starting: "Iniciando…",
        end: "Terminar paseo",
        remaining: "restante",
        you_are_walking: "Estás paseando con {name}",
        your_pet: "tu mascota",
        need_pet: "Añade una mascota antes de iniciar un paseo.",
        nearby_kicker: "Cerca ahora",
        nearby_loading: "Buscando…",
        nearby_none: "Ningún amigo PawLink paseando cerca ahora.",
        nearby_count: "{n} amigos PawLink están paseando cerca 🐾",
        upgrade_to_see_pins: "Suscríbete a PawLink Protection para ver las mascotas cercanas en el mapa.",
        friend: "Amigo PawLink",
        privacy_note: "Sólo se muestran zonas aproximadas. PawLink nunca revela tu nombre, teléfono, dirección, posición exacta ni ruta.",
        err_no_location: "Se necesita permiso de ubicación para iniciar un paseo o ver amigos cercanos.",
        err_start: "No se pudo iniciar el paseo. Inténtalo de nuevo.",
        left_short: "restantes",
        need_pet_h: "Agrega una mascota antes de pasear",
        need_pet_sub: "Crea un perfil rápido: nombre, foto y un teléfono para la etiqueta QR. Menos de un minuto.",
        create_pet_cta: "Crear perfil de mascota",
        missing_pet: "mascota",
        missing_duration: "duración",
        missing_consent: "consentimiento",
        missing_location: "ubicación",
        missing_location_hint: "Necesitamos tu ubicación en vivo para difuminar el pin. Pulsa «Centrarme» en el mapa primero.",
    },
    care: {
        kicker: "PawLink Care",
        title: "Recordatorios de cuidado",
        add: "Añadir",
        empty_no_pets: "Añade una mascota antes de crear un recordatorio.",
        pet: "Mascota",
        type: "Tipo",
        title_label: "Título",
        title_placeholder: "ej. Refuerzo antirrábico",
        when: "Cuándo",
        note: "Nota (opcional)",
        notify_me: "Avísame",
        offset_7d: "7 días antes",
        offset_1d: "1 día antes",
        offset_0d: "El mismo día",
        save: "Guardar",
        saving: "Guardando…",
        cancel: "Cancelar",
        err_save: "No se pudo guardar. Inténtalo de nuevo.",
        tab_upcoming: "Próximos",
        tab_overdue: "Vencidos",
        tab_completed: "Completados",
        empty_upcoming: "Nada próximo.",
        empty_overdue: "Nada vencido.",
        empty_completed: "Aún no hay completados.",
        type_vaccination: "Vacunación",
        type_vet: "Visita al veterinario",
        type_medication: "Medicación",
        type_grooming: "Peluquería",
        type_other: "Otro",
        mark_done: "Marcar hecho",
        delete: "Eliminar",
    },
};

export const LANGUAGES = [
    { code: "en", flag: "🇬🇧", label: "English" },
    { code: "fr", flag: "🇫🇷", label: "Français" },
    { code: "de", flag: "🇩🇪", label: "Deutsch" },
    { code: "it", flag: "🇮🇹", label: "Italiano" },
    { code: "ar", flag: "🇸🇦", label: "العربية" },
    { code: "es", flag: "🇪🇸", label: "Español" },
];

// German + Italian: start with an English fallback so every existing key
// keeps a working label. On top we override the strings that MUST read
// natively (nav, filter chips, care + walks module, legal). More strings
// can be translated in later passes without a code change.
const _de_overrides = {
    nav: { community: "Community", local_walks: "Lokale Spaziergänge" },
    safety: {
        tab_emergency: "Alarm",
        tab_personality: "Charakter",
        tab_passport: "Ausweis",
        tab_health: "Gesundheit",
    },
    community: {
        filter_all: "Alle",
        filter_lost: "Vermisste Tiere",
        filter_walking_now: "Gerade unterwegs",
        filter_helpers: "In der Nähe",
        filter_found: "Gefunden",
        walks_legend: "Warme Marker = Tiere, die gerade laufen. Vermisste- und Rettungsmarker bleiben sichtbar.",
        legend_walking: "Gerade unterwegs",
        find_my_location: "Standort finden",
        center_on_me: "Auf mich zentrieren",
        distance_h: "Entfernung",
        map_visibility_h: "Sichtbarkeit auf der Karte",
        map_visibility_hidden: "Versteckt",
        map_visibility_approximate: "Ungefähr",
        map_visibility_live_approx: "Live ungefähr",
        map_visibility_change: "Ändern",
        km_unit: "km",
    },
    health: {
        kicker: "Gesundheit & Pflege",
        setup_kicker: "Loslegen",
        setup_h: "Erstelle die Gesundheitsakte deines Tiers",
        setup_sub: "Wähle den Start — du kannst später mehr hinzufügen. Nur Name und Art sind erforderlich.",
        setup_manual_h: "Manuell eingeben",
        setup_manual_sub: "Fülle kurze Abschnitte in deinem Tempo.",
        setup_scan_h: "Dokument scannen",
        setup_scan_sub: "Foto vom Impfpass oder EU-Heimtierausweis — wir füllen die Felder vor.",
        ai_badge: "KI",
        overview_h: "Übersicht",
        stat_vaccinations: "Impfungen",
        stat_documents: "Dokumente",
        stat_reminders: "Erinnerungen",
        manual_h: "Gesundheit & Identität",
        sec_identification: "Identifikation",
        sec_health: "Gesundheitsnotizen",
        sec_vet: "Tierarzt",
        sec_vaccinations: "Impfungen & Termine",
        sec_reminders: "Erinnerungen",
        sec_documents: "Dokumente",
        sec_timeline: "Zeitleiste",
        save: "Speichern",
        cancel: "Abbrechen",
        view: "Ansehen",
        scan_title: "Dokument scannen",
        scanning: "Details werden extrahiert…",
        review_title: "Extrahierte Angaben prüfen",
        review_sub: "Noch nichts gespeichert. Markierte Felder korrigieren, dann speichern.",
        please_verify: "Bitte prüfen",
        review_ai_note: "KI kann irren. Datumsangaben und Nummern immer prüfen.",
        no_diagnosis_note: "PawLink speichert deine Notizen unverändert und gibt keine medizinische Diagnose.",

        // Vorgeschlagene Erinnerung (muss vom Nutzer bestätigt werden)
        rem_suggest_h: "Erinnerung anlegen?",
        rem_suggest_h_vaccination: "Erinnerung für die nächste Impfdosis anlegen?",
        rem_suggest_h_appointment: "Erinnerung für diesen Termin anlegen?",
        rem_suggest_sub: "Wir fügen sie deinen Erinnerungen hinzu, damit du nichts vergisst. Ändere alles vor der Bestätigung.",
        rem_suggest_open: "Erinnerung anlegen",
        rem_suggest_existing: "Erinnerung ist bereits gesetzt",
        rem_dialog_title: "Neue Erinnerung",
        rem_dialog_sub: "PawLink benachrichtigt dich vor dem Termin. Ändere unten, was du möchtest.",
        rem_field_title: "Titel",
        rem_field_date: "Datum",
        rem_field_time: "Uhrzeit",
        rem_field_note: "Notiz (optional)",
        rem_field_notify: "Benachrichtige mich",
        rem_offset_7d: "7 Tage vorher",
        rem_offset_1d: "1 Tag vorher",
        rem_offset_0d: "Am selben Tag",
        rem_confirm: "Erinnerung bestätigen",
        rem_confirming: "Bestätigung…",
        rem_never_auto: "Nichts wird automatisch angelegt — du entscheidest.",

        // Tierarzttermine
        sec_appointments: "Tierarzttermine",
        apt_add: "Termin hinzufügen",
        apt_empty: "Noch keine Termine.",
        apt_f_date: "Datum",
        apt_f_time: "Uhrzeit",
        apt_f_clinic: "Klinik",
        apt_f_vet: "Tierarzt",
        apt_f_reason: "Grund",
        apt_f_reason_ph: "z. B. Jahres-Check, Zahnreinigung",
        apt_f_notes: "Notizen",
        apt_f_notes_ph: "Sonstiges, das du dir merken willst",
        apt_also_reminder: "Auch Erinnerung anlegen",
        apt_status_scheduled: "Geplant",
        apt_status_completed: "Erledigt",
        apt_status_cancelled: "Abgesagt",
        apt_mark_done: "Als erledigt markieren",
        apt_edit: "Bearbeiten",
        apt_delete: "Löschen",
        apt_confirm_delete: "Diesen Termin löschen?",
        apt_date_req: "Wähle ein Termindatum.",
        apt_reason_default: "Tierarztbesuch",
    },

    walks: {
        kicker: "Lokale Spaziergänge",
        h1: "Sieh, wer gerade unterwegs ist",
        tagline: "Aus einem gewöhnlichen Spaziergang wird ein freundlicher PawLink-Moment.",
        cta_start: "Wir gehen jetzt spazieren 🐾",
        start_title: "Spaziergang starten",
        pet: "Tier",
        duration: "Dauer",
        min: "Min",
        consent_text: "PawLink zeigt dein Tier für die gewählte Zeit in einem ungefähren Bereich in der Nähe. Deine genaue Position und persönlichen Daten bleiben privat.",
        cancel: "Abbrechen",
        confirm_start: "Spaziergang starten",
        starting: "Wird gestartet…",
        end: "Beenden",
        remaining: "verbleibend",
        you_are_walking: "Du gehst mit {name} spazieren",
        your_pet: "deinem Tier",
        need_pet: "Füge zuerst ein Tier hinzu.",
        nearby_kicker: "Gerade in der Nähe",
        nearby_loading: "Suche…",
        nearby_none: "Gerade keine PawLink-Freunde in der Nähe unterwegs.",
        nearby_count: "{n} PawLink-Freunde spazieren in der Nähe 🐾",
        upgrade_to_see_pins: "Upgrade auf PawLink Protection, um nahegelegene Tiere auf der Karte zu sehen.",
        friend: "PawLink-Freund",
        privacy_note: "Es werden nur ungefähre Bereiche angezeigt. PawLink zeigt nie deinen Namen, deine Adresse, deine genaue Position oder Route.",
        err_no_location: "Zum Starten oder Anzeigen wird die Standortberechtigung benötigt.",
        err_start: "Spaziergang konnte nicht gestartet werden. Bitte erneut versuchen.",
        left_short: "übrig",
        need_pet_h: "Füge ein Tier hinzu, bevor du losgehst",
        need_pet_sub: "Erstelle ein schnelles Profil: Name, Foto und eine Telefonnummer für den QR-Anhänger. Unter einer Minute.",
        create_pet_cta: "Tierprofil erstellen",
        missing_pet: "Tier",
        missing_duration: "Dauer",
        missing_consent: "Zustimmung",
        missing_location: "Standort",
        missing_location_hint: "Wir brauchen deinen Live-Standort, um den Pin zu verwischen. Tippe zuerst auf 'Auf mich zentrieren'.",
    },
    care: {
        kicker: "PawLink Care",
        title: "Pflege-Erinnerungen",
        add: "Hinzufügen",
        empty_no_pets: "Füge zuerst ein Tier hinzu.",
        pet: "Tier",
        type: "Typ",
        title_label: "Titel",
        title_placeholder: "z. B. Tollwut-Auffrischung",
        when: "Wann",
        note: "Notiz (optional)",
        notify_me: "Erinnere mich",
        offset_7d: "7 Tage vorher",
        offset_1d: "1 Tag vorher",
        offset_0d: "Am selben Tag",
        save: "Speichern",
        saving: "Wird gespeichert…",
        cancel: "Abbrechen",
        err_save: "Konnte nicht gespeichert werden. Bitte erneut versuchen.",
        tab_upcoming: "Anstehend",
        tab_overdue: "Überfällig",
        tab_completed: "Abgeschlossen",
        empty_upcoming: "Nichts anstehend.",
        empty_overdue: "Nichts überfällig.",
        empty_completed: "Noch keine abgeschlossenen Erinnerungen.",
        type_vaccination: "Impfung",
        type_vet: "Tierarztbesuch",
        type_medication: "Medikament",
        type_grooming: "Fellpflege",
        type_other: "Sonstige",
        mark_done: "Erledigt",
        delete: "Löschen",
    },
};

const _it_overrides = {
    nav: { community: "Community", local_walks: "Passeggiate locali" },
    safety: {
        tab_emergency: "Allerta",
        tab_personality: "Carattere",
        tab_passport: "Passaporto",
        tab_health: "Salute",
    },
    community: {
        filter_all: "Tutti",
        filter_lost: "Animali smarriti",
        filter_walking_now: "In passeggiata",
        filter_helpers: "Vicino",
        filter_found: "Trovati",
        walks_legend: "Marker caldi = animali in passeggiata. I marker di smarrimento e soccorso restano visibili.",
        legend_walking: "In passeggiata",
        find_my_location: "Trovami",
        center_on_me: "Centra su di me",
        distance_h: "Distanza",
        map_visibility_h: "Visibilità sulla mappa",
        map_visibility_hidden: "Nascosta",
        map_visibility_approximate: "Approssimativa",
        map_visibility_live_approx: "Live approssimativa",
        map_visibility_change: "Modifica",
        km_unit: "km",
    },
    health: {
        kicker: "Salute & cure",
        setup_kicker: "Iniziamo",
        setup_h: "Crea la scheda salute del tuo animale",
        setup_sub: "Scegli come iniziare — puoi aggiungere altro dopo. Solo nome e specie sono obbligatori.",
        setup_manual_h: "Inserisci manualmente",
        setup_manual_sub: "Compila brevi sezioni al tuo ritmo.",
        setup_scan_h: "Scansiona un documento",
        setup_scan_sub: "Foto del libretto vaccinale o del passaporto — precompiliamo i campi.",
        ai_badge: "IA",
        overview_h: "Panoramica",
        stat_vaccinations: "Vaccinazioni",
        stat_documents: "Documenti",
        stat_reminders: "Promemoria",
        manual_h: "Salute e identità",
        sec_identification: "Identificazione",
        sec_health: "Note sanitarie",
        sec_vet: "Veterinario",
        sec_vaccinations: "Vaccinazioni e appuntamenti",
        sec_reminders: "Promemoria",
        sec_documents: "Documenti",
        sec_timeline: "Cronologia",
        save: "Salva",
        cancel: "Annulla",
        view: "Vedi",
        scan_title: "Scansiona un documento",
        scanning: "Estrazione dei dati…",
        review_title: "Rivedi i dati estratti",
        review_sub: "Nulla è stato salvato. Correggi i campi evidenziati e premi Salva.",
        please_verify: "Verifica",
        review_ai_note: "L'IA può sbagliare. Controlla sempre date e identificatori.",
        no_diagnosis_note: "PawLink salva le tue note così come sono, senza diagnosi mediche.",

        // Promemoria suggerito (deve essere confermato dall'utente)
        rem_suggest_h: "Creare un promemoria?",
        rem_suggest_h_vaccination: "Creare un promemoria per la prossima dose?",
        rem_suggest_h_appointment: "Creare un promemoria per questo appuntamento?",
        rem_suggest_sub: "Lo aggiungeremo ai tuoi promemoria per non dimenticare. Modifica tutto prima di confermare.",
        rem_suggest_open: "Crea promemoria",
        rem_suggest_existing: "Promemoria già impostato",
        rem_dialog_title: "Nuovo promemoria",
        rem_dialog_sub: "PawLink ti avviserà prima della scadenza. Modifica quello che vuoi qui sotto.",
        rem_field_title: "Titolo",
        rem_field_date: "Data",
        rem_field_time: "Ora",
        rem_field_note: "Nota (facoltativa)",
        rem_field_notify: "Avvisami",
        rem_offset_7d: "7 giorni prima",
        rem_offset_1d: "1 giorno prima",
        rem_offset_0d: "Il giorno stesso",
        rem_confirm: "Conferma promemoria",
        rem_confirming: "Conferma…",
        rem_never_auto: "Nulla viene creato automaticamente — decidi tu.",

        // Appuntamenti veterinari
        sec_appointments: "Appuntamenti veterinari",
        apt_add: "Aggiungi appuntamento",
        apt_empty: "Nessun appuntamento.",
        apt_f_date: "Data",
        apt_f_time: "Ora",
        apt_f_clinic: "Clinica",
        apt_f_vet: "Veterinario",
        apt_f_reason: "Motivo",
        apt_f_reason_ph: "es. visita annuale, pulizia dentale",
        apt_f_notes: "Note",
        apt_f_notes_ph: "Altre cose da ricordare",
        apt_also_reminder: "Crea anche un promemoria",
        apt_status_scheduled: "In programma",
        apt_status_completed: "Completato",
        apt_status_cancelled: "Annullato",
        apt_mark_done: "Segna come fatto",
        apt_edit: "Modifica",
        apt_delete: "Elimina",
        apt_confirm_delete: "Eliminare questo appuntamento?",
        apt_date_req: "Scegli una data.",
        apt_reason_default: "Visita veterinaria",
    },

    walks: {
        kicker: "Passeggiate locali",
        h1: "Guarda chi è in giro vicino a te",
        tagline: "Trasforma una passeggiata qualsiasi in un momento PawLink amichevole.",
        cta_start: "Stiamo passeggiando 🐾",
        start_title: "Inizia una passeggiata locale",
        pet: "Animale",
        duration: "Durata",
        min: "min",
        consent_text: "PawLink mostrerà il tuo animale in un'area approssimativa vicina per il tempo scelto. La tua posizione esatta e i dati personali rimangono privati.",
        cancel: "Annulla",
        confirm_start: "Inizia",
        starting: "Avvio…",
        end: "Termina",
        remaining: "restanti",
        you_are_walking: "Stai passeggiando con {name}",
        your_pet: "il tuo animale",
        need_pet: "Aggiungi prima un animale.",
        nearby_kicker: "Adesso vicino",
        nearby_loading: "Ricerca…",
        nearby_none: "Nessun amico PawLink in passeggiata vicino.",
        nearby_count: "{n} amici PawLink stanno passeggiando vicino 🐾",
        upgrade_to_see_pins: "Passa a PawLink Protection per vedere gli animali vicini sulla mappa.",
        friend: "Amico PawLink",
        privacy_note: "Vengono mostrate solo aree approssimative. PawLink non rivela nome, telefono, indirizzo, posizione esatta o percorso.",
        err_no_location: "È necessario il permesso di localizzazione per iniziare o vedere gli amici vicini.",
        err_start: "Impossibile iniziare. Riprova.",
        left_short: "rimasti",
        need_pet_h: "Aggiungi un animale prima di partire",
        need_pet_sub: "Crea un profilo veloce: nome, foto e un numero per l'etichetta QR. Meno di un minuto.",
        create_pet_cta: "Crea profilo animale",
        missing_pet: "animale",
        missing_duration: "durata",
        missing_consent: "consenso",
        missing_location: "posizione",
        missing_location_hint: "Ci serve la tua posizione live per sfocare il pin. Tocca prima «Centra su di me».",
    },
    care: {
        kicker: "PawLink Care",
        title: "Promemoria di cura",
        add: "Aggiungi",
        empty_no_pets: "Aggiungi prima un animale.",
        pet: "Animale",
        type: "Tipo",
        title_label: "Titolo",
        title_placeholder: "es. Richiamo antirabbico",
        when: "Quando",
        note: "Nota (facoltativo)",
        notify_me: "Ricordamelo",
        offset_7d: "7 giorni prima",
        offset_1d: "1 giorno prima",
        offset_0d: "Lo stesso giorno",
        save: "Salva",
        saving: "Salvataggio…",
        cancel: "Annulla",
        err_save: "Impossibile salvare. Riprova.",
        tab_upcoming: "In arrivo",
        tab_overdue: "Scaduti",
        tab_completed: "Completati",
        empty_upcoming: "Niente in arrivo.",
        empty_overdue: "Niente scaduto.",
        empty_completed: "Nessun promemoria completato.",
        type_vaccination: "Vaccinazione",
        type_vet: "Visita veterinaria",
        type_medication: "Medicinale",
        type_grooming: "Toelettatura",
        type_other: "Altro",
        mark_done: "Segna come fatto",
        delete: "Elimina",
    },
};

// Deep-merge overrides on top of English so every key resolves either
// natively or via a working English fallback (no missing-key placeholders).
function _deepMerge(base, over) {
    const out = { ...base };
    for (const k of Object.keys(over || {})) {
        out[k] = (typeof over[k] === "object" && over[k] && !Array.isArray(over[k]))
            ? _deepMerge(base?.[k] || {}, over[k])
            : over[k];
    }
    return out;
}
const de = _deepMerge(en, _de_overrides);
const it = _deepMerge(en, _it_overrides);

export const TRANSLATIONS = { en, fr, de, it, ar, es };
